function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};

// src/components/customer-notification/customer-notification.tsx
import React84 from "react";
import { useQuery } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useEntityContext } from "@shared-ui/entity-context";
import { useExperiment as useExperiment2 } from "@shared-ui/experiment-context";

// ../internal/src/notification-action-executor/notification-action-fragment.ts
import { gql } from "@shared-ui/apollo-client-wrapper";
var NotificationActionFragments = gql`
  fragment NotificationActionSchema on NotificationSchema {
    __typename
    name
    messageContent {
      __typename
      name
      value
    }
  }

  fragment NotificationActionAnalytics on NotificationAnalytics {
    __typename
    description
    referrerId
    schema {
      ...NotificationActionSchema
    }
  }

  fragment NotificationActionEgClickstream on NotificationAnalyticsEgClickstream {
    __typename
    description
    event {
      __typename
      eventName
      eventType
      eventCategory
      eventVersion
      actionLocation
    }
    schema {
      ...NotificationActionSchema
    }
  }

  fragment NotificationAction on NotificationAction {
    __typename
    ...NotificationActionAnalytics
    ...NotificationActionEgClickstream
    ... on NotificationCookie {
      name
      value
      expires
    }
  }
`;
var NotificationActionFragment = gql`
  fragment NotificationActionFragment on NotificationAction {
    __typename
    ... on NotificationAnalytics {
      __typename
      description
      referrerId
      schema {
        __typename
        name
        messageContent {
          __typename
          name
          value
        }
      }
    }
    ... on NotificationAnalyticsEgClickstream {
      __typename
      description
      event {
        __typename
        eventName
        eventType
        eventCategory
        eventVersion
        actionLocation
      }
      schema {
        name
        messageContent {
          name
          value
        }
      }
    }
    ... on NotificationCookie {
      __typename
      name
      value
      expires
    }
  }
`;

// ../internal/src/utils/is-numeric.ts
var isNumeric = val => {
  return !Number.isNaN(Number(val));
};

// ../internal/src/utils/set-value-by-keypath.ts
var stringToPath = path => path.split(".").map(part => {
  const indexPart = part.match(/^\[(\d+)\]$/);
  return indexPart ? indexPart[1] : part;
}).filter(p => typeof p === "string");
var setValueByKeyPath = (obj, path, value) => {
  var _a;
  const parts = Array.isArray(path) ? path : stringToPath(path);
  const [current, ...nextParts] = parts;
  if (!Object.prototype.hasOwnProperty.call(obj, current) && current) {
    if (nextParts.length) {
      obj[current] = isNumeric((_a = nextParts[0]) != null ? _a : "") ? [] : {};
    } else {
      obj[current] = value;
    }
  }
  if (nextParts.length && current) {
    setValueByKeyPath(obj[current], nextParts, value);
  }
};

// ../internal/src/utils/is-boolean.ts
var isBoolean = value => {
  return typeof value === "boolean" || typeof value === "string" && ((value == null ? void 0 : value.toLowerCase()) === "true" || (value == null ? void 0 : value.toLowerCase()) === "false");
};

// ../internal/src/utils/clickstream-utils.ts
var createNotificationSchema = (schemaName, props) => ({
  __typename: "NotificationSchema",
  name: schemaName,
  messageContent: Object.entries(props).map(([name, value]) => ({
    __typename: "NotificationAnalyticsSchemaAttribute",
    name,
    value
  }))
});

// ../internal/src/utils/text-utils.ts
var TEXT_SIZE_DICTIONARY = {
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
};
var TEXT_WEIGHT_DICTIONARY = {
  REGULAR: "regular",
  MEDIUM: "medium",
  BOLD: "bold"
};

// ../internal/src/notification-action-executor/build-egclickstream-data.ts
var buildEgClickstreamData = ({
  event,
  schema
}) => {
  var _a;
  const data = {
    event: {
      event_name: event.eventName,
      event_type: event.eventType,
      event_category: event.eventCategory,
      event_version: event.eventVersion,
      action_location: (_a = event.actionLocation) != null ? _a : ""
    }
  };
  schema == null ? void 0 : schema.forEach(({
    name: schemaName,
    messageContent
  }) => {
    messageContent.forEach(({
      name,
      value
    }) => {
      setValueByKeyPath(data, `${schemaName}.${name}`, value);
    });
  });
  return data;
};
var buildEgClickstreamErrorEvent = ({
  errorName,
  errorDescription,
  errorCode,
  clickStreamActionLocation
}) => ({
  __typename: "NotificationAnalyticsEgClickstream",
  description: "message module failed",
  event: {
    __typename: "EGClickstreamEvent",
    eventName: "message_module.failed",
    eventType: "Outcome",
    eventVersion: "1.4.0",
    actionLocation: clickStreamActionLocation != null ? clickStreamActionLocation : null,
    eventCategory: "Search"
  },
  schema: [createNotificationSchema("error_list", {
    "[0].error_name": errorName ? "misconfiguration" : "network_error",
    "[0].error_description": errorDescription || "message module failed",
    "[0].error_code": errorCode != null ? errorCode : ""
  })]
});

// ../internal/src/notification-action-executor/get-uis-events.ts
var getUisEvents = action => {
  var _a;
  const events = [];
  (_a = action.schema) == null ? void 0 : _a.forEach(schema => {
    const result = {};
    schema.messageContent.forEach(({
      name,
      value
    }) => {
      const nameParts = name.split(".");
      if (nameParts.length === 1) {
        result[name.replace(/\s/g, "-")] = value;
      } else if (nameParts[0] && nameParts[1]) {
        const currentValue = result[nameParts[0]] || [{}];
        const innerObject = __spreadValues({}, currentValue[0]);
        if (isNumeric(value) || isBoolean(value)) {
          innerObject[nameParts[1]] = isNumeric(value) ? Number.parseInt(value, 10) : JSON.parse(value == null ? void 0 : value.toLowerCase());
        } else {
          innerObject[nameParts[1]] = value;
        }
        result[nameParts[0]] = [innerObject];
      }
    });
    events.push({
      schemaName: schema.name,
      messageContent: result
    });
  });
  return events;
};

// ../internal/src/notification-action-executor/use-notification-action-executor.ts
import { useCallback, useMemo } from "react";
import { useClickTracker, useEgClickstream } from "@shared-ui/clickstream-analytics-context";
var useNotificationActionExecutor = () => {
  const analyticsTracker = useClickTracker();
  const egClickstreamTracker = useEgClickstream();
  const actionExecutors = useMemo(() => ({
    NotificationCookie(action) {
      document.cookie = `${action.name}=${action.value}; path=/; expires=${action.expires}`;
    },
    NotificationAnalyticsEgClickstream(action) {
      egClickstreamTracker(buildEgClickstreamData(action));
    },
    NotificationAnalytics(action) {
      analyticsTracker(action.referrerId, action.description || "", void 0, getUisEvents(action));
    }
  }), [analyticsTracker, egClickstreamTracker]);
  return useCallback(actions => {
    actions == null ? void 0 : actions.forEach(action => {
      var _a;
      (_a = actionExecutors[action == null ? void 0 : action.__typename]) == null ? void 0 : _a.call(actionExecutors, action);
    });
  }, [actionExecutors]);
};

// src/__generated__/types.ts
var NotificationInModuleMessageName = /* @__PURE__ */(NotificationInModuleMessageName2 => {
  NotificationInModuleMessageName2["COUPON_REMOVAL_FAILED_MESSAGE"] = "COUPON_REMOVAL_FAILED_MESSAGE";
  NotificationInModuleMessageName2["CPM_CC_ON_FILE_MESSAGE"] = "CPM_CC_ON_FILE_MESSAGE";
  NotificationInModuleMessageName2["CPM_CC_ON_FILE_MESSAGE_CAR"] = "CPM_CC_ON_FILE_MESSAGE_CAR";
  NotificationInModuleMessageName2["CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE"] = "CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE";
  NotificationInModuleMessageName2["CPM_CC_ON_FILE_UPDATED_MESSAGE"] = "CPM_CC_ON_FILE_UPDATED_MESSAGE";
  NotificationInModuleMessageName2["CPM_NO_PAYMENT_DUE_MESSAGE"] = "CPM_NO_PAYMENT_DUE_MESSAGE";
  NotificationInModuleMessageName2["CPM_NO_PAYMENT_DUE_MESSAGE_CAR"] = "CPM_NO_PAYMENT_DUE_MESSAGE_CAR";
  NotificationInModuleMessageName2["CPM_NO_PAYMENT_DUE_UPDATED_MESSAGE"] = "CPM_NO_PAYMENT_DUE_UPDATED_MESSAGE";
  NotificationInModuleMessageName2["CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE"] = "CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE";
  NotificationInModuleMessageName2["CPM_ONLY_INSURANCE_PAYMENT_DUE_UPDATED_MESSAGE"] = "CPM_ONLY_INSURANCE_PAYMENT_DUE_UPDATED_MESSAGE";
  NotificationInModuleMessageName2["OKC_ADD_FAILED_MESSAGE"] = "OKC_ADD_FAILED_MESSAGE";
  NotificationInModuleMessageName2["OKC_REMOVAL_FAILED_MESSAGE"] = "OKC_REMOVAL_FAILED_MESSAGE";
  NotificationInModuleMessageName2["PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT"] = "PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_OKC_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT"] = "PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT"] = "PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PAY_NOW_OKC_TOTAL_AMOUNT"] = "PAY_NOW_OKC_TOTAL_AMOUNT";
  NotificationInModuleMessageName2["PROMOTION_CHANGED_MESSAGE"] = "PROMOTION_CHANGED_MESSAGE";
  return NotificationInModuleMessageName2;
})(NotificationInModuleMessageName || {});
var NotificationInModuleModuleName = /* @__PURE__ */(NotificationInModuleModuleName2 => {
  NotificationInModuleModuleName2["COMMON_PAYMENT_MODULE"] = "COMMON_PAYMENT_MODULE";
  NotificationInModuleModuleName2["COUPON_MODULE"] = "COUPON_MODULE";
  NotificationInModuleModuleName2["LOYALTY_BURN_MODULE"] = "LOYALTY_BURN_MODULE";
  NotificationInModuleModuleName2["PROMOTION_CHANGED_MODULE"] = "PROMOTION_CHANGED_MODULE";
  return NotificationInModuleModuleName2;
})(NotificationInModuleModuleName || {});
var NotificationLocationOnPage = /* @__PURE__ */(NotificationLocationOnPage5 => {
  NotificationLocationOnPage5["AFTER_HEADER"] = "AFTER_HEADER";
  NotificationLocationOnPage5["AFTER_WIZARD"] = "AFTER_WIZARD";
  NotificationLocationOnPage5["ERROR"] = "ERROR";
  NotificationLocationOnPage5["FOOTER"] = "FOOTER";
  NotificationLocationOnPage5["FULL_PAGE"] = "FULL_PAGE";
  NotificationLocationOnPage5["IN_MODAL"] = "IN_MODAL";
  NotificationLocationOnPage5["IN_MODULE"] = "IN_MODULE";
  NotificationLocationOnPage5["IN_PAGE"] = "IN_PAGE";
  NotificationLocationOnPage5["IN_PAGE_AD"] = "IN_PAGE_AD";
  NotificationLocationOnPage5["LEGAL"] = "LEGAL";
  NotificationLocationOnPage5["POPUP"] = "POPUP";
  NotificationLocationOnPage5["PRE_HEADER"] = "PRE_HEADER";
  return NotificationLocationOnPage5;
})(NotificationLocationOnPage || {});
var TextTheme = /* @__PURE__ */(TextTheme2 => {
  TextTheme2["EMPHASIS"] = "EMPHASIS";
  TextTheme2["INVERSE"] = "INVERSE";
  TextTheme2["LOYALTY"] = "LOYALTY";
  TextTheme2["NEGATIVE"] = "NEGATIVE";
  TextTheme2["POSITIVE"] = "POSITIVE";
  TextTheme2["PRIMARY"] = "PRIMARY";
  TextTheme2["SECONDARY"] = "SECONDARY";
  return TextTheme2;
})(TextTheme || {});
var TextWeight = /* @__PURE__ */(TextWeight2 => {
  TextWeight2["BOLD"] = "BOLD";
  TextWeight2["MEDIUM"] = "MEDIUM";
  TextWeight2["REGULAR"] = "REGULAR";
  return TextWeight2;
})(TextWeight || {});
var TripScheduleChangeStatus = /* @__PURE__ */(TripScheduleChangeStatus2 => {
  TripScheduleChangeStatus2["FLIGHT_SCHEDULE_CHANGE"] = "FLIGHT_SCHEDULE_CHANGE";
  TripScheduleChangeStatus2["NO_CHANGE"] = "NO_CHANGE";
  return TripScheduleChangeStatus2;
})(TripScheduleChangeStatus || {});

// src/components/customer-notification/customer-notification-placeholder.tsx
import React from "react";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSSkeleton } from "@egds/react-core/skeleton";
import { EGDSSpacing } from "@egds/react-core/spacing";
var CustomerNotificationPlaceholder = () => /* @__PURE__ */React.createElement(EGDSCard, {
  backgroundTheme: "global-loyalty-standard",
  padded: false,
  "data-stid": "customer-notifications-placeholder"
}, /* @__PURE__ */React.createElement(EGDSCardContentSection, null, /* @__PURE__ */React.createElement(EGDSSpacing, {
  margin: {
    block: "four"
  }
}, /* @__PURE__ */React.createElement(EGDSSkeleton, {
  type: "line"
})), /* @__PURE__ */React.createElement(EGDSSpacing, {
  margin: {
    block: "four"
  }
}, /* @__PURE__ */React.createElement(EGDSSkeleton, {
  type: "line",
  animation: true,
  lineLength: "secondary"
}))));

// src/components/customer-notification/customer-notification-render.tsx
import React83 from "react";
import { EGDSSpacing as EGDSSpacing30 } from "@egds/react-core/spacing";

// ../internal/src/context/theme/theme-context.tsx
import React2 from "react";

// ../internal/src/context/theme/handle-text-theme.ts
import { EGDSCardBackgroundThemes } from "@egds/react-core/cards";
var BANNER_THEME_DICTIONARY = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  BRAND_PROMO_PRIMARY: "brand_promo_primary",
  NONE: "none"
};
var CARD_THEME_DICTIONARY = {
  PRIMARY: EGDSCardBackgroundThemes.PRIMARY,
  SECONDARY: EGDSCardBackgroundThemes.SECONDARY,
  GLOBAL_LOYALTY_STANDARD: EGDSCardBackgroundThemes.GLOBAL_LOYALTY_STANDARD,
  GLOBAL_LOYALTY_LOW: EGDSCardBackgroundThemes.GLOBAL_LOYALTY_LOW,
  GLOBAL_LOYALTY_HIGH: EGDSCardBackgroundThemes.GLOBAL_LOYALTY_HIGH,
  GLOBAL_LOYALTY_EXTRAHIGH: EGDSCardBackgroundThemes.GLOBAL_LOYALTY_EXTRAHIGH,
  GLOBAL_LOYALTY_MIDDLE: EGDSCardBackgroundThemes.GLOBAL_LOYALTY_MIDDLE
};
var handleTextTheme = theme => {
  var _a, _b, _c, _d;
  let bannerTheme;
  let textTheme = "inverse";
  switch (theme == null ? void 0 : theme.__typename) {
    case "NotificationBannerTheme":
      bannerTheme = (_b = BANNER_THEME_DICTIONARY[(_a = theme.bannerTheme) != null ? _a : "BRAND_PROMO_PRIMARY" /* BRAND_PROMO_PRIMARY */]) != null ? _b : "brand_promo_primary";
      textTheme = bannerTheme === BANNER_THEME_DICTIONARY.BRAND_PROMO_PRIMARY ? "inverse" : "default";
      break;
    case "NotificationCardTheme":
      bannerTheme = (_d = CARD_THEME_DICTIONARY[(_c = theme.themeValue) != null ? _c : "GLOBAL_LOYALTY_EXTRAHIGH"]) != null ? _d : EGDSCardBackgroundThemes.GLOBAL_LOYALTY_EXTRAHIGH;
      textTheme = bannerTheme === CARD_THEME_DICTIONARY.GLOBAL_LOYALTY_STANDARD || bannerTheme === CARD_THEME_DICTIONARY.GLOBAL_LOYALTY_EXTRAHIGH ? "inverse" : "default";
      break;
    default:
      bannerTheme = "brand_promo_primary";
      break;
  }
  return {
    bannerTheme,
    textTheme
  };
};

// ../internal/src/context/theme/theme-context.tsx
var TEXT_ALIGN_MAP = {
  LEFT: "left",
  RIGHT: "right",
  CENTER: "center"
};
var BannerThemeStateContext = React2.createContext({
  bodyTheme: "brand_promo_primary",
  layout: "CENTER" /* CENTER */,
  view: "CAROUSEL" /* CAROUSEL */,
  textStyle: {
    theme: "inverse",
    align: "center"
  }
});
var Link_Size_Dictionary = {
  small: "small",
  medium: "medium",
  large: "large"
};
var CalculatedBannerThemeStateContext = data => {
  var _a, _b, _c, _d, _e, _f;
  const {
    textStyle: text
  } = React2.useContext(BannerThemeStateContext);
  const {
    overrideTextStyles,
    textFragments
  } = data;
  let textSize;
  let textWeight;
  if (textFragments.__typename === "EGDSStandardLink") {
    textSize = Link_Size_Dictionary[textFragments.size];
    textWeight = "regular";
  } else {
    textSize = TEXT_SIZE_DICTIONARY[(_a = textFragments.textSize) != null ? _a : 300];
    textWeight = TEXT_WEIGHT_DICTIONARY[(_b = textFragments.weight) != null ? _b : "regular"];
  }
  return {
    textStyle: {
      theme: (_c = overrideTextStyles == null ? void 0 : overrideTextStyles.theme) != null ? _c : text.theme,
      align: (_d = overrideTextStyles == null ? void 0 : overrideTextStyles.align) != null ? _d : text.align,
      size: (_e = overrideTextStyles == null ? void 0 : overrideTextStyles.size) != null ? _e : textSize,
      weight: (_f = overrideTextStyles == null ? void 0 : overrideTextStyles.weight) != null ? _f : textWeight
    }
  };
};
var BannerThemeStateProvider = ({
  children,
  notificationContainer
}) => {
  const {
    layout,
    theme,
    view
  } = notificationContainer != null ? notificationContainer : {};
  const {
    bannerTheme,
    textTheme
  } = handleTextTheme(theme);
  const result = React2.useMemo(() => ({
    bodyTheme: bannerTheme,
    layout: layout != null ? layout : "CENTER" /* CENTER */,
    view: view != null ? view : "CAROUSEL" /* CAROUSEL */,
    textStyle: {
      align: TEXT_ALIGN_MAP[layout != null ? layout : "CENTER"],
      theme: textTheme
    }
  }), [bannerTheme, layout, textTheme, view]);
  return /* @__PURE__ */React2.createElement(BannerThemeStateContext.Provider, {
    value: result
  }, children);
};

// src/components/bottom-sheet/bottom-sheet-wrapper.tsx
import React5 from "react";

// src/components/bottom-sheet/bottom-sheet.tsx
import React4 from "react";
import { EGDSButtonSize, EGDSOverlayButton } from "@egds/react-core/button";
import { EGDSIcon, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid, EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSheet, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText2 } from "@egds/react-core/text";
import { EGDSViewRow } from "@egds/react-core/view";
import { useApolloClient } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/custom-qr-code/custom-qr-code.tsx
import React3 from "react";
import { EGDSFigure, EGDSFigureAspectRatioType, EGDSImage } from "@egds/react-core/images";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { EGDSText } from "@egds/react-core/text";
import { gql as gql2 } from "@shared-ui/apollo-client-wrapper";
var __CustomQrCodeImageFragment = gql2`
  fragment NotificationCustomQrCodeFragment on InlineNotification {
    customQrCode {
      __typename
      image {
        description
        url
      }
      title
      encodedImage
    }
  }
`;
var CustomQrCodeImage = ({
  data,
  className,
  aspectRatio,
  // This is needed because og the MAD Marquee component that uses the theme prop
  theme
}) => {
  var _a;
  const {
    textStyle: text
  } = React3.useContext(BannerThemeStateContext);
  if (!data) {
    return null;
  }
  const {
    encodedImage,
    image,
    title
  } = data;
  const urlToRender = encodedImage ? `data:image/png;base64,${encodedImage}` : image == null ? void 0 : image.url;
  return (image == null ? void 0 : image.url) || encodedImage ? /* @__PURE__ */React3.createElement("div", {
    className
  }, /* @__PURE__ */React3.createElement("div", {
    role: "definition",
    "aria-labelledby": "qrCodeTitle"
  }, /* @__PURE__ */React3.createElement("input", {
    type: "hidden",
    id: "qrCodeTitle",
    "aria-label": title
  })), /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: "column",
    space: "half",
    justifyContent: "center"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSFigure, {
    imageFit: "contain",
    ratio: aspectRatio != null ? aspectRatio : EGDSFigureAspectRatioType.R3_4,
    "aria-hidden": "true"
  }, /* @__PURE__ */React3.createElement(EGDSImage, {
    src: urlToRender,
    alt: (_a = image == null ? void 0 : image.description) != null ? _a : title
  }))), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, (data == null ? void 0 : data.title) && /* @__PURE__ */React3.createElement(EGDSText, {
    align: "center",
    size: 300,
    theme: theme != null ? theme : text.theme,
    "aria-hidden": "true"
  }, data.title)))) : null;
};
CustomQrCodeImage.displayName = "CustomQrCodeImage";
CustomQrCodeImage.fragment = __CustomQrCodeImageFragment;

// src/components/bottom-sheet/bottom-sheet.tsx
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";

// src/components/customer-notification/helpers/cache-eviction.ts
var cacheEviction = (apolloCache, type, notificationLocation) => {
  const pageLocation = notificationLocation || "PRE_HEADER" /* PRE_HEADER */;
  const cacheId = apolloCache.identify({
    type,
    notificationLocation: pageLocation,
    __typename: "InlineNotification"
  });
  apolloCache.evict({
    id: cacheId
  });
  apolloCache.gc();
};

// src/components/customer-notification/helpers/create-deep-link-url.ts
var createDeepLinkUrl = (linkUrl, referer) => {
  if (!linkUrl) {
    return void 0;
  }
  const deepLinkUrl = new URL(linkUrl);
  return deepLinkUrl.searchParams.has("$canonical_url") || !referer ? `${deepLinkUrl}` : `${deepLinkUrl}&${encodeURIComponent("$canonical_url")}=${encodeURIComponent(referer)}`;
};

// src/components/helpers/common-button-sheet-dictionary.tsx
import { EGDSPrimaryButton, EGDSSecondaryButton, EGDSTertiaryButton } from "@egds/react-core/button";
var CTA_DICTIONARY = {
  ["PRIMARY_BUTTON" /* PRIMARY_BUTTON */]: EGDSPrimaryButton,
  ["SECONDARY_BUTTON" /* SECONDARY_BUTTON */]: EGDSSecondaryButton,
  ["TERTIARY_BUTTON" /* TERTIARY_BUTTON */]: EGDSTertiaryButton
};
var getButtonComponent = buttonType => CTA_DICTIONARY[`${buttonType}`] || EGDSPrimaryButton;

// src/components/bottom-sheet/bottom-sheet.tsx
var BottomSheet = ({
  type,
  notificationLocation,
  body,
  title,
  logo,
  dismiss,
  customQrCode,
  bannerLink,
  revealActions,
  referer,
  termsAndConditions,
  termsAndConditionsText,
  dismissCallback
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k;
  const [display, setDisplay] = React4.useState(true);
  const {
    cache
  } = useApolloClient();
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const triggerRef = React4.useRef(null);
  const memoizedImpressionLogger = React4.useCallback(() => {
    if (display) {
      customerNotificationActionsExecutor(revealActions);
    }
    return display;
  }, [display]);
  const onClickDismiss = React4.useCallback(() => {
    dismissCallback == null ? void 0 : dismissCallback();
    customerNotificationActionsExecutor(dismiss == null ? void 0 : dismiss.actions);
    cacheEviction(cache, type, notificationLocation);
    setDisplay(false);
  }, []);
  const onClickButton = React4.useCallback(() => {
    customerNotificationActionsExecutor(bannerLink == null ? void 0 : bannerLink.actions);
  }, []);
  const deepLinkUrl = React4.useMemo(() => {
    var _a2;
    return createDeepLinkUrl((_a2 = bannerLink == null ? void 0 : bannerLink.uri) == null ? void 0 : _a2.value, referer);
  }, []);
  const ButtonComponent = React4.useMemo(() => getButtonComponent(bannerLink == null ? void 0 : bannerLink.type), []);
  const qrCodeEnabled = (customQrCode == null ? void 0 : customQrCode.title) && ((_a = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _a.description) || (customQrCode == null ? void 0 : customQrCode.encodedImage);
  return /* @__PURE__ */React4.createElement(React4.Fragment, null, display && memoizedImpressionLogger() && /* @__PURE__ */React4.createElement(Viewport, null, /* @__PURE__ */React4.createElement(ViewSmall, null, /* @__PURE__ */React4.createElement(EGDSSheetTransition, {
    isVisible: display
  }, /* @__PURE__ */React4.createElement(EGDSSheet, {
    isVisible: display,
    type: "bottom",
    triggerRef
  }, /* @__PURE__ */React4.createElement(EGDSViewRow, {
    canvasTheme: "brand_promo_primary",
    layout: "fullwidth"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "three",
      blockend: "six",
      inline: "two"
    }
  }, /* @__PURE__ */React4.createElement(EGDSSheetContent, {
    padded: false,
    fullSheetContentMaxWidth: "extra-large"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    direction: "column",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "end"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "one",
      blockend: "four",
      inlineend: "one"
    }
  }, /* @__PURE__ */React4.createElement(EGDSOverlayButton, {
    onClick: onClickDismiss,
    "aria-label": "close"
  }, /* @__PURE__ */React4.createElement(EGDSIcon, {
    name: "close",
    size: EGDSIconSize.MEDIUM,
    theme: "primary",
    title: "Close Sheet",
    id: "sheet-close-button"
  })))), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React4.createElement("img", {
    alt: logo == null ? void 0 : logo.description,
    src: logo == null ? void 0 : logo.url,
    width: 56
  })), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React4.createElement(EGDSText2, {
    theme: "inverse",
    align: "center",
    weight: "medium",
    size: 600
  }, (_d = (_c = (_b = body == null ? void 0 : body[0]) == null ? void 0 : _b.items) == null ? void 0 : _c[0]) == null ? void 0 : _d.text))), (bannerLink == null ? void 0 : bannerLink.uri) && deepLinkUrl && (bannerLink == null ? void 0 : bannerLink.text) && /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "six",
      blockend: "four"
    }
  }, /* @__PURE__ */React4.createElement(ButtonComponent, {
    href: deepLinkUrl,
    size: EGDSButtonSize.LARGE,
    onClick: onClickButton
  }, bannerLink.text))), termsAndConditionsText && (termsAndConditions == null ? void 0 : termsAndConditions.uri) && /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "two",
      blockend: "four",
      inline: "one"
    }
  }, /* @__PURE__ */React4.createElement(EGDSLink, {
    align: "center",
    size: "small",
    theme: "inverse",
    inline: true
  }, /* @__PURE__ */React4.createElement("a", {
    href: termsAndConditions.uri.value,
    target: "_blank",
    rel: "noopener"
  }, termsAndConditionsText))))))))))), /* @__PURE__ */React4.createElement(ViewMedium, null, /* @__PURE__ */React4.createElement(EGDSSheetTransition, {
    isVisible: display
  }, /* @__PURE__ */React4.createElement(EGDSSheet, {
    isVisible: display,
    type: "bottom",
    triggerRef
  }, /* @__PURE__ */React4.createElement(EGDSViewRow, {
    canvasTheme: "brand_promo_primary",
    layout: "fullwidth"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      inlinestart: "one",
      inlineend: "two",
      blockstart: "three",
      blockend: "six"
    }
  }, /* @__PURE__ */React4.createElement(EGDSSheetContent, {
    padded: false,
    fullSheetContentMaxWidth: "extra-large"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    direction: "row-reverse"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      inlineend: "one",
      blockstart: "one"
    }
  }, /* @__PURE__ */React4.createElement(EGDSOverlayButton, {
    name: (_e = dismiss == null ? void 0 : dismiss.icon) == null ? void 0 : _e.id,
    onClick: onClickDismiss,
    "aria-label": "close"
  }, /* @__PURE__ */React4.createElement(EGDSIcon, {
    name: "close",
    size: EGDSIconSize.EXTRA_SMALL,
    theme: "primary",
    description: (_f = dismiss == null ? void 0 : dismiss.icon) == null ? void 0 : _f.description,
    id: "sheet-close-button"
  }))))), /* @__PURE__ */React4.createElement(EGDSLayoutGrid, {
    columns: 10
  }, /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
    colSpan: qrCodeEnabled ? 8 : 10
  }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(EGDSLayoutGrid, {
    columns: qrCodeEnabled ? 8 : 10
  }, /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
    colSpan: 1,
    alignSelf: "center"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React4.createElement("img", {
    src: logo == null ? void 0 : logo.url,
    alt: logo == null ? void 0 : logo.description,
    height: 45
  }))), ((_g = title == null ? void 0 : title.items[0]) == null ? void 0 : _g.text) && /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
    colSpan: qrCodeEnabled ? 7 : 9,
    alignSelf: "center"
  }, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React4.createElement(EGDSText2, {
    theme: "inverse",
    align: "left",
    size: 600,
    weight: "bold"
  }, (_h = title == null ? void 0 : title.items[0]) == null ? void 0 : _h.text)))), /* @__PURE__ */React4.createElement(EGDSLayoutGrid, null, /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: {
      block: "three",
      inlineend: "four",
      inlinestart: "one"
    }
  }, /* @__PURE__ */React4.createElement(EGDSText2, {
    theme: "inverse",
    weight: "medium",
    size: 500
  }, (_k = (_j = (_i = body == null ? void 0 : body[0]) == null ? void 0 : _i.items) == null ? void 0 : _j[0]) == null ? void 0 : _k.text)))), (bannerLink == null ? void 0 : bannerLink.text) && deepLinkUrl && (bannerLink == null ? void 0 : bannerLink.linkTheme) !== "INVERSE" /* INVERSE */ && /* @__PURE__ */React4.createElement(EGDSLayoutGrid, {
    columns: 10
  }, /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
    colSpan: 5
  }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      inlinestart: "one"
    }
  }, /* @__PURE__ */React4.createElement(ButtonComponent, {
    href: deepLinkUrl,
    size: EGDSButtonSize.LARGE,
    onClick: onClickButton
  }, bannerLink.text))))), termsAndConditionsText && (termsAndConditions == null ? void 0 : termsAndConditions.uri) && /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      inlinestart: "one",
      blockend: "one"
    }
  }, /* @__PURE__ */React4.createElement(EGDSLink, {
    size: "small",
    theme: "inverse",
    inline: true
  }, /* @__PURE__ */React4.createElement("a", {
    href: termsAndConditions.uri.value,
    target: "_blank",
    rel: "noopener"
  }, termsAndConditionsText))))))), qrCodeEnabled && /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, {
    colSpan: 2
  }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: {
      inlinestart: "two"
    }
  }, /* @__PURE__ */React4.createElement(CustomQrCodeImage, {
    data: customQrCode,
    theme: "inverse"
  })))))))))))));
};
BottomSheet.displayName = "sharedui-BottomSheet";

// src/components/bottom-sheet/bottom-sheet-wrapper.tsx
var MemoizedBottomSheet = React5.memo(BottomSheet);
var BottomSheetWrapper = ({
  data,
  inputs,
  dismissCallback
}) => {
  var _a, _b, _c;
  const {
    notificationLocation,
    legalText,
    title,
    body,
    logo,
    links,
    revealActions,
    customQrCode,
    dismiss
  } = data;
  const {
    optionalContext
  } = inputs;
  const termsAndConditionLink = (_a = legalText == null ? void 0 : legalText.items) == null ? void 0 : _a.find(link => link.__typename === "NotificationPhraseLinkNode");
  const termsAndConditions = (termsAndConditionLink == null ? void 0 : termsAndConditionLink.uri) && termsAndConditionLink.uri.value ? termsAndConditionLink : void 0;
  const termsAndConditionsText = (_c = (_b = legalText == null ? void 0 : legalText.items) == null ? void 0 : _b[0]) == null ? void 0 : _c.text;
  const memoizedSheetData = React5.useMemo(() => ({
    type: "BOTTOM_SHEET" /* BOTTOM_SHEET */,
    notificationLocation,
    body,
    title,
    logo,
    dismiss,
    customQrCode,
    bannerLink: links == null ? void 0 : links[0],
    revealActions,
    referer: optionalContext == null ? void 0 : optionalContext.referer,
    termsAndConditions,
    termsAndConditionsText,
    dismissCallback
  }), []);
  if (!logo || !dismiss) {
    return null;
  }
  return /* @__PURE__ */React5.createElement(MemoizedBottomSheet, __spreadValues({}, memoizedSheetData));
};

// src/components/citi-cobrand-ad/citi-cobrand-ad-wrapper.tsx
import React8 from "react";

// src/components/citi-cobrand-ad-vertical/citi-cobrand-ad-vertical.tsx
import React6 from "react";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSLink as EGDSLink2 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText3 } from "@egds/react-core/text";
var CitiCobrandVerticalAd = props => {
  const {
    bodyText,
    cardImage,
    headingText,
    learnMoreLink,
    revealActions
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React6.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const onClickLink = link => () => {
    customerNotificationActionsExecutor(link.actions);
  };
  return /* @__PURE__ */React6.createElement(EGDSCard2, null, /* @__PURE__ */React6.createElement(EGDSCardContentSection2, {
    padded: false
  }, /* @__PURE__ */React6.createElement(EGDSSpacing3, {
    padding: "four"
  }, /* @__PURE__ */React6.createElement("div", null, /* @__PURE__ */React6.createElement("img", {
    src: cardImage.url,
    alt: cardImage.description
  }), /* @__PURE__ */React6.createElement(EGDSSpacing3, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React6.createElement(EGDSHeading, {
    tag: "h2",
    size: 5
  }, headingText)), /* @__PURE__ */React6.createElement(EGDSText3, {
    size: 300
  }, bodyText), /* @__PURE__ */React6.createElement(EGDSSpacing3, {
    padding: {
      blockstart: "two",
      inlineend: "six"
    }
  }, /* @__PURE__ */React6.createElement(EGDSLink2, {
    onClick: onClickLink(learnMoreLink),
    inline: true
  }, learnMoreLink.uri ? /* @__PURE__ */React6.createElement("a", {
    href: learnMoreLink.uri.value,
    target: "_blank",
    rel: "noopener"
  }, learnMoreLink.text) : /* @__PURE__ */React6.createElement("button", {
    type: "button"
  }, learnMoreLink.text)))))));
};
CitiCobrandVerticalAd.displayName = "sharedui-CitiCobrandVerticalAd";

// src/components/citi-cobrand-ad/citi-cobrand-ad.tsx
import React7 from "react";
import { EGDSCard as EGDSCard3, EGDSCardContentSection as EGDSCardContentSection3 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid2, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink3 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2, EGDSText as EGDSText4 } from "@egds/react-core/text";
var CitiCobrandAd = props => {
  const {
    bodyText,
    cardImage,
    headingText,
    learnMoreLink,
    revealActions
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React7.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const onClickLink = link => () => {
    customerNotificationActionsExecutor(link.actions);
  };
  return /* @__PURE__ */React7.createElement(EGDSCard3, null, /* @__PURE__ */React7.createElement(EGDSCardContentSection3, {
    padded: false
  }, /* @__PURE__ */React7.createElement(EGDSSpacing4, {
    padding: "four"
  }, /* @__PURE__ */React7.createElement("div", null, /* @__PURE__ */React7.createElement(EGDSLayoutGrid2, {
    columns: 3
  }, /* @__PURE__ */React7.createElement(EGDSLayoutGridItem2, {
    colSpan: "all"
  }, /* @__PURE__ */React7.createElement("div", null, /* @__PURE__ */React7.createElement(EGDSHeading2, {
    tag: "h2",
    size: 6
  }, headingText))), /* @__PURE__ */React7.createElement(EGDSSpacing4, {
    padding: {
      blockstart: "three",
      inlineend: "one"
    }
  }, /* @__PURE__ */React7.createElement(EGDSLayoutGridItem2, {
    colSpan: 2
  }, /* @__PURE__ */React7.createElement("div", null, /* @__PURE__ */React7.createElement(EGDSText4, {
    align: "left",
    size: 300
  }, bodyText), /* @__PURE__ */React7.createElement(EGDSSpacing4, {
    padding: {
      blockstart: "two",
      inlineend: "six"
    }
  }, /* @__PURE__ */React7.createElement(EGDSLink3, {
    onClick: onClickLink(learnMoreLink),
    inline: true
  }, learnMoreLink.uri ? /* @__PURE__ */React7.createElement("a", {
    href: learnMoreLink.uri.value,
    target: "_blank",
    rel: "noopener"
  }, learnMoreLink.text) : /* @__PURE__ */React7.createElement("button", {
    type: "button"
  }, learnMoreLink.text)))))), /* @__PURE__ */React7.createElement(EGDSSpacing4, {
    padding: {
      blockstart: "three"
    }
  }, /* @__PURE__ */React7.createElement(EGDSLayoutGridItem2, {
    colSpan: 1
  }, /* @__PURE__ */React7.createElement(EGDSLayoutFlex3, {
    alignItems: "end",
    direction: "column"
  }, /* @__PURE__ */React7.createElement("img", {
    src: cardImage.url,
    alt: cardImage.description
  })))))))));
};
CitiCobrandAd.displayName = "sharedui-CitiCobrandAd";

// src/components/citi-cobrand-ad/citi-cobrand-ad-wrapper.tsx
var CitiCobrandAdWrapper = ({
  data
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  const {
    type,
    title,
    backgroundImage,
    body,
    links,
    revealActions
  } = data || {};
  if (!backgroundImage || !body || !(links == null ? void 0 : links[0]) || !revealActions || !title) {
    return null;
  }
  if (type && type === "CITI_COBRAND_VERTICAL" /* CITI_COBRAND_VERTICAL */) {
    return /* @__PURE__ */React8.createElement(CitiCobrandVerticalAd, {
      bodyText: (_c = (_b = (_a = body[0]) == null ? void 0 : _a.items[0]) == null ? void 0 : _b.text) != null ? _c : "",
      cardImage: backgroundImage,
      headingText: (_e = (_d = title.items[0]) == null ? void 0 : _d.text) != null ? _e : "",
      learnMoreLink: links[0],
      revealActions
    });
  }
  return /* @__PURE__ */React8.createElement(CitiCobrandAd, {
    bodyText: (_h = (_g = (_f = body[0]) == null ? void 0 : _f.items[0]) == null ? void 0 : _g.text) != null ? _h : "",
    cardImage: backgroundImage,
    headingText: (_j = (_i = title.items[0]) == null ? void 0 : _i.text) != null ? _j : "",
    learnMoreLink: links[0],
    revealActions
  });
};

// src/components/cleanliness-banner/cleanliness-banner-wrapper.tsx
import React11 from "react";

// src/components/cleanliness-banner/cleanliness-banner.tsx
import React10 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex5, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid3 } from "@egds/react-core/layout-grid";
import { EGDSHeading as EGDSHeading4, EGDSParagraph } from "@egds/react-core/text";

// src/components/cleanliness-banner/cleanliness-message.tsx
import React9 from "react";
import { EGDSIcon as EGDSIcon2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGridItem as EGDSLayoutGridItem3 } from "@egds/react-core/layout-grid";
import { EGDSHeading as EGDSHeading3, EGDSText as EGDSText5 } from "@egds/react-core/text";
var CleanlinessMessage = ({
  iconName,
  title,
  subtitle
}) => {
  return /* @__PURE__ */React9.createElement(EGDSLayoutGridItem3, null, /* @__PURE__ */React9.createElement(EGDSLayoutFlex4, {
    alignItems: "center",
    space: "four"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem3, {
    minWidth: "fifteen"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlex4, null, /* @__PURE__ */React9.createElement(EGDSIcon2, {
    name: iconName,
    spotlight: "standard"
  }))), /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React9.createElement(EGDSLayoutFlex4, {
    direction: "column"
  }, /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React9.createElement(EGDSHeading3, {
    size: 7
  }, title)), /* @__PURE__ */React9.createElement(EGDSLayoutFlexItem3, null, /* @__PURE__ */React9.createElement(EGDSText5, null, subtitle))))));
};
var cleanliness_message_default = CleanlinessMessage;

// src/components/cleanliness-banner/cleanliness-banner.tsx
var CleanlinessBanner = ({
  title,
  subtitle,
  messages
}) => {
  return /* @__PURE__ */React10.createElement(EGDSLayoutFlex5, {
    space: "four",
    direction: "column"
  }, /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(EGDSHeading4, {
    tag: "h2",
    size: 3
  }, title), /* @__PURE__ */React10.createElement(EGDSParagraph, null, subtitle))), /* @__PURE__ */React10.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React10.createElement(EGDSLayoutGrid3, {
    columns: {
      small: 1,
      medium: 2
    },
    space: "four"
  }, messages.map(message => /* @__PURE__ */React10.createElement(cleanliness_message_default, __spreadValues({
    key: message.iconName
  }, message))))));
};
var cleanliness_banner_default = CleanlinessBanner;

// src/components/cleanliness-banner/helpers/index.ts
var getCleanlinessMessages = body => {
  const messages = [];
  body.forEach(element => {
    var _a, _b, _c, _d, _e, _f, _g;
    const message = {
      title: (_b = (_a = element == null ? void 0 : element.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.text,
      iconName: (_e = (_d = (_c = element == null ? void 0 : element.items) == null ? void 0 : _c[0]) == null ? void 0 : _d.icon) == null ? void 0 : _e.id,
      subtitle: (_g = (_f = element == null ? void 0 : element.items) == null ? void 0 : _f[1]) == null ? void 0 : _g.text
    };
    messages.push(message);
  });
  return messages;
};

// src/components/cleanliness-banner/cleanliness-banner-wrapper.tsx
var CleanlinessBannerWrapper = ({
  data
}) => {
  var _a, _b, _c, _d, _e, _f;
  const {
    title,
    body
  } = data || {};
  if (!body || !title) {
    return null;
  }
  const titleText = (_c = (_b = (_a = title.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.text) != null ? _c : "";
  const subtitle = (_f = (_e = (_d = title.items) == null ? void 0 : _d[1]) == null ? void 0 : _e.text) != null ? _f : "";
  const messages = getCleanlinessMessages(body);
  return /* @__PURE__ */React11.createElement(cleanliness_banner_default, {
    title: titleText,
    subtitle,
    messages
  });
};

// src/components/configurable-banner/configurable-banner-wrapper.tsx
import React20 from "react";

// src/components/configurable-banner/configurable-banner.tsx
import React19 from "react";
import { EGDSButtonSize as EGDSButtonSize4, EGDSOverlayButton as EGDSOverlayButton2 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon3, EGDSIconSize as EGDSIconSize2 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex7, EGDSLayoutFlexItem as EGDSLayoutFlexItem7 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid4, EGDSLayoutGridItem as EGDSLayoutGridItem4 } from "@egds/react-core/layout-grid";
import { EGDSMark } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing6 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText9 } from "@egds/react-core/text";
import { useApolloClient as useApolloClient2 } from "@shared-ui/apollo-client-wrapper";
import { ViewLarge, ViewMedium as ViewMedium2, Viewport as Viewport2, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";

// src/components/helpers/egds-link-adapters.ts
var LINK_THEME_DICTIONARY = {
  INVERSE: "inverse",
  DEFAULT: "default"
};
var LINKS_TEXT_SIZE_DICTIONARY = {
  SMALL: "small",
  MEDIUM: "medium",
  LARGE: "large"
};
var getLinkTheme = linkTheme => {
  var _a;
  return (_a = LINK_THEME_DICTIONARY[`${linkTheme}`]) != null ? _a : "inverse";
};
var getLinkSize = linkSize => {
  var _a;
  return (_a = LINKS_TEXT_SIZE_DICTIONARY[`${linkSize}`]) != null ? _a : "medium";
};

// src/components/customer-notification/helpers/get-identity.ts
var LineOfBusinessMapper = {
  H: "LODGING" /* LODGING */,
  P: "PACKAGES" /* PACKAGES */,
  F: "FLIGHT" /* FLIGHT */,
  C: "CAR" /* CAR */,
  CR: "CRUISES" /* CRUISES */,
  A: "ACTIVITIES" /* ACTIVITIES */,
  U: "UNCLASSIFIED" /* UNCLASSIFIED */,
  R: "RAILS" /* RAILS */,
  GT: "GROUNDTRANSFERS" /* GROUNDTRANSFERS */
};
var pageLocationMapper = {
  0: "SYSTEM" /* SYSTEM */,
  10: "ENTRY" /* ENTRY */,
  20: "SEARCH_RESULTS" /* SEARCH_RESULTS */,
  30: "DETAILS" /* DETAILS */,
  40: "CHECKOUT" /* CHECKOUT */,
  50: "CHECKOUT_ERROR" /* CHECKOUT_ERROR */,
  60: "PAYMENT_ERROR" /* PAYMENT_ERROR */,
  70: "CONFIRMATION" /* CONFIRMATION */,
  80: "POST_BOOKING" /* POST_BOOKING */,
  90: "USER" /* USER */,
  500: "FEATURES" /* FEATURES */
};
var getIdentity = xPageId => {
  var _a, _b, _c, _d, _e;
  const identifiers = xPageId.split(",").map(identifier => identifier.trim());
  return {
    pageId: (_a = identifiers[0]) != null ? _a : "",
    lineOfBusiness: (_c = LineOfBusinessMapper[(_b = identifiers[1]) != null ? _b : ""]) != null ? _c : "UNCLASSIFIED" /* UNCLASSIFIED */,
    pageLocation: (_e = pageLocationMapper[(_d = identifiers[2]) != null ? _d : ""]) != null ? _e : "ENTRY" /* ENTRY */
  };
};
var EGDSTextWeightMap = Object.freeze({
  ["BOLD" /* BOLD */]: "bold",
  ["MEDIUM" /* MEDIUM */]: "medium",
  ["REGULAR" /* REGULAR */]: "regular"
});
var EGDSTextThemeMap = Object.freeze({
  ["NEGATIVE" /* NEGATIVE */]: "negative",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["EMPHASIS" /* EMPHASIS */]: "emphasis",
  ["PRIMARY" /* PRIMARY */]: "emphasis",
  ["LOYALTY" /* LOYALTY */]: "loyalty",
  ["SECONDARY" /* SECONDARY */]: "default",
  ["INVERSE" /* INVERSE */]: "inverse"
});

// src/components/helpers/egds-text-adapters.ts
var TEXT_SIZE_DICTIONARY2 = {
  "100": 100,
  "200": 200,
  "300": 300,
  "400": 400,
  "500": 500,
  "600": 600,
  "700": 700,
  "800": 800,
  "900": 900
};
var TEXT_WEIGHT_DICTIONARY2 = {
  REGULAR: "regular",
  MEDIUM: "medium",
  BOLD: "bold"
};
var getTextTheme = textTheme => {
  var _a;
  return (_a = EGDSTextThemeMap[`${textTheme}`]) != null ? _a : EGDSTextThemeMap["INVERSE" /* INVERSE */];
};
var getTextSize = textSize => {
  var _a;
  return (_a = TEXT_SIZE_DICTIONARY2[`${textSize}`]) != null ? _a : 500;
};
var getTextWeight = textWeight => {
  var _a;
  return (_a = TEXT_WEIGHT_DICTIONARY2[`${textWeight}`]) != null ? _a : "regular";
};

// src/components/helpers/themes-dictionary.tsx
import { EGDSCardBackgroundThemes as EGDSCardBackgroundThemes2 } from "@egds/react-core/cards";
var CARD_THEME_DICTIONARY2 = {
  PRIMARY: EGDSCardBackgroundThemes2.PRIMARY,
  SECONDARY: EGDSCardBackgroundThemes2.SECONDARY,
  GLOBAL_LOYALTY_STANDARD: EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_STANDARD,
  GLOBAL_LOYALTY_LOW: EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_LOW,
  GLOBAL_LOYALTY_HIGH: EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_HIGH,
  GLOBAL_LOYALTY_EXTRAHIGH: EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_EXTRAHIGH,
  GLOBAL_LOYALTY_MIDDLE: EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_MIDDLE
};
var BANNER_THEME_DICTIONARY2 = {
  PRIMARY: "primary",
  SECONDARY: "secondary",
  BRAND_PROMO_PRIMARY: "brand_promo_primary",
  NONE: "none"
};
var getCardTheme = cardTheme => {
  var _a;
  return (_a = CARD_THEME_DICTIONARY2[`${cardTheme}`]) != null ? _a : EGDSCardBackgroundThemes2.GLOBAL_LOYALTY_STANDARD;
};
var getBannerTheme = bannerTheme => {
  var _a;
  return (_a = BANNER_THEME_DICTIONARY2[`${bannerTheme}`]) != null ? _a : BANNER_THEME_DICTIONARY2.BRAND_PROMO_PRIMARY;
};

// src/components/helpers/egds-button-adapters.ts
import { EGDSButtonSize as EGDSButtonSize2 } from "@egds/react-core/button";
var BUTTON_SIZE_DICTIONARY = {
  IMPORTANT: EGDSButtonSize2.LARGE,
  MEDIUM: EGDSButtonSize2.MEDIUM,
  STANDARD: EGDSButtonSize2.SMALL
};
var getButtonSize = buttonSize => {
  var _a;
  return (_a = BUTTON_SIZE_DICTIONARY[`${buttonSize}`]) != null ? _a : "medium";
};

// src/components/configurable-banner/configurable-banner-body-dictionary.tsx
import React12 from "react";
import { EGDSCard as EGDSCard4 } from "@egds/react-core/cards";
import { EGDSViewRow as EGDSViewRow2 } from "@egds/react-core/view";
var CardBody = ({
  background,
  border,
  children
}) => /* @__PURE__ */React12.createElement(EGDSCard4, {
  border,
  backgroundTheme: getCardTheme(background),
  padded: true
}, children);
var RowBody = ({
  children
}) => /* @__PURE__ */React12.createElement(EGDSViewRow2, {
  canvasTheme: "brand_promo_primary",
  layout: "centered"
}, children);
var AnchorBody = ({
  children,
  bannerLink,
  onCardClickCallback
}) => {
  return bannerLink ? /* @__PURE__ */React12.createElement("a", {
    href: bannerLink,
    onClick: onCardClickCallback,
    onKeyDown: onCardClickCallback
  }, children) : /* @__PURE__ */React12.createElement(React12.Fragment, null, children);
};
var BODY_DICTIONARY = {
  ["PRE_HEADER" /* PRE_HEADER */]: RowBody,
  ["IN_PAGE" /* IN_PAGE */]: CardBody
};
var getGenericBannerBodyComponent = location => BODY_DICTIONARY[`${location}`] || CardBody;

// src/components/configurable-banner/configurable-banner-body-field.tsx
import React13 from "react";
import { EGDSText as EGDSText6 } from "@egds/react-core/text";
var BodyField = props => {
  var _a, _b;
  const {
    body
  } = props;
  const bodyItems = (_b = (_a = body == null ? void 0 : body[0]) == null ? void 0 : _a.egdsItems) == null ? void 0 : _b[0];
  const textTheme = (bodyItems == null ? void 0 : bodyItems.__typename) === "NotificationEGDSTextNode" ? bodyItems == null ? void 0 : bodyItems.theme : "INVERSE" /* INVERSE */;
  return /* @__PURE__ */React13.createElement(React13.Fragment, null, body.map((bodyItem, index) => {
    var _a2;
    return (_a2 = bodyItem.items) == null ? void 0 : _a2.map(({
      text,
      styles
    }, textIndex) => /* @__PURE__ */React13.createElement(EGDSText6, {
      key: `body-${index}.item-${textIndex}`,
      theme: getTextTheme(textTheme),
      align: "left",
      size: 300,
      weight: (styles == null ? void 0 : styles[0]) === "IMPORTANT" /* IMPORTANT */ ? "bold" : "regular"
    }, text));
  }));
};

// src/components/configurable-banner/configurable-banner-links-field.tsx
import React14 from "react";
import { useLocation } from "react-router-dom-v5-compat";
import { EGDSButtonSize as EGDSButtonSize3 } from "@egds/react-core/button";
import { EGDSLayoutFlex as EGDSLayoutFlex6, EGDSLayoutFlexItem as EGDSLayoutFlexItem5 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink4 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";

// src/components/helpers/redirection-url-generator.ts
var redirectionUrlGenerator = (url, pathname, search) => {
  let newPathname = pathname;
  if (pathname.charAt(0) === "/") {
    newPathname = pathname.substring(1, pathname.length);
  }
  const currentUrl = newPathname + search;
  return url + encodeURIComponent(currentUrl);
};

// src/components/configurable-banner/configurable-banner-button-dictionary.tsx
import { EGDSPrimaryButton as EGDSPrimaryButton2, EGDSSecondaryButton as EGDSSecondaryButton2, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
var BUTTON_DICTIONARY = {
  ["PRIMARY_BUTTON" /* PRIMARY_BUTTON */]: EGDSPrimaryButton2,
  ["SECONDARY_BUTTON" /* SECONDARY_BUTTON */]: EGDSSecondaryButton2,
  ["TERTIARY_BUTTON" /* TERTIARY_BUTTON */]: EGDSTertiaryButton2
};
var getButtonComponent2 = buttonType => BUTTON_DICTIONARY[`${buttonType}`] || EGDSPrimaryButton2;

// src/components/configurable-banner/configurable-banner-links-field.tsx
var LinksField = props => {
  const {
    links,
    isMobile,
    isButtonOnRight,
    referer,
    isContainerLayoutPositionBottom
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const {
    pathname,
    search
  } = useLocation();
  const buttonsSpacing = isButtonOnRight ? {
    padding: {
      extra_large: {
        blockstart: "unset",
        inlinestart: "unset"
      },
      large: {
        blockstart: "unset",
        inlinestart: "unset"
      },
      medium: {
        blockstart: "three",
        inlinestart: "unset"
      },
      small: {
        blockstart: "three",
        inlinestart: "unset"
      }
    }
  } : {
    padding: {
      blockstart: "three",
      inlinestart: "unset"
    }
  };
  return /* @__PURE__ */React14.createElement(EGDSLayoutFlexItem5, {
    shrink: 0
  }, /* @__PURE__ */React14.createElement(EGDSSpacing5, {
    padding: isContainerLayoutPositionBottom ? {
      blockstart: "unset",
      inlinestart: "unset"
    } : buttonsSpacing.padding
  }, /* @__PURE__ */React14.createElement(EGDSLayoutFlex6, {
    direction: "row",
    alignItems: "center"
  }, links == null ? void 0 : links.map((button, index) => {
    var _a, _b, _c, _d;
    const id = button == null ? void 0 : button.id;
    const isLoginOrSignUp = id === "logIn-mod" || id === "signUp-mod";
    const buttonLink = isLoginOrSignUp ? redirectionUrlGenerator(((_a = button.uri) == null ? void 0 : _a.value) || "", pathname, search) : createDeepLinkUrl((_b = button.uri) == null ? void 0 : _b.value, referer);
    const linkTarget = button.target === "NEW_TAB" /* NEW_TAB */ ? "_blank" : "_self";
    const linkSize = ((_c = button == null ? void 0 : button.styles) == null ? void 0 : _c[0]) ? getButtonSize((_d = button == null ? void 0 : button.styles) == null ? void 0 : _d[0]) : null;
    const defaultButtonSize = isMobile ? EGDSButtonSize3.SMALL : EGDSButtonSize3.MEDIUM;
    if (button.type === "ANCHOR") {
      return /* @__PURE__ */React14.createElement(EGDSSpacing5, {
        key: `${button == null ? void 0 : button.id}-${index}`,
        padding: {
          block: "two"
        }
      }, /* @__PURE__ */React14.createElement(EGDSLayoutFlex6, {
        direction: "row",
        alignItems: "start",
        justifyContent: "space-between"
      }, /* @__PURE__ */React14.createElement(EGDSLink4, {
        noWrap: true,
        theme: getLinkTheme(button == null ? void 0 : button.linkTheme),
        onClick: () => customerNotificationActionsExecutor(button.actions)
      }, /* @__PURE__ */React14.createElement("a", {
        "aria-label": button == null ? void 0 : button.text,
        href: buttonLink,
        target: linkTarget,
        rel: "noopener"
      }, button.text))));
    }
    const ButtonComponent = getButtonComponent2(button.type);
    const inverse = button.type === "TERTIARY_BUTTON" /* TERTIARY_BUTTON */;
    const buttonSize = linkSize !== null ? linkSize : defaultButtonSize;
    return /* @__PURE__ */React14.createElement(EGDSSpacing5, {
      margin: {
        inlineend: "three"
      },
      key: `${button == null ? void 0 : button.id}-${index}`
    }, /* @__PURE__ */React14.createElement(ButtonComponent, {
      href: buttonLink,
      size: buttonSize,
      inverse,
      tag: button.target ? "a" : "button",
      target: linkTarget,
      onClick: () => customerNotificationActionsExecutor(button.actions)
    }, button.text));
  }))));
};

// src/components/configurable-banner/configurable-banner-sub-body-field.tsx
import React15 from "react";
import { EGDSText as EGDSText7 } from "@egds/react-core/text";
var SubBodyField = props => {
  var _a, _b, _c;
  const {
    subBody
  } = props;
  const titleItem = (_c = (_b = (_a = subBody == null ? void 0 : subBody[0]) == null ? void 0 : _a.title) == null ? void 0 : _b.egdsItems) == null ? void 0 : _c[0];
  const titleTheme = (titleItem == null ? void 0 : titleItem.__typename) === "NotificationEGDSTextNode" ? titleItem == null ? void 0 : titleItem.theme : "INVERSE" /* INVERSE */;
  const titleText = titleItem && "text" in titleItem && titleItem.text;
  const titleWeight = titleItem && "weight" in titleItem && titleItem.weight || "REGULAR" /* REGULAR */;
  return /* @__PURE__ */React15.createElement(EGDSText7, {
    theme: getTextTheme(titleTheme),
    weight: titleWeight && EGDSTextWeightMap[titleWeight],
    size: 300
  }, titleText);
};

// src/components/configurable-banner/configurable-banner-terms-and-conditions.tsx
import React18 from "react";
import { EGDSLayoutFlexItem as EGDSLayoutFlexItem6 } from "@egds/react-core/layout-flex";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";

// src/components/shared/egds-stylized-text.tsx
import React16 from "react";
import { EGDSText as EGDSText8 } from "@egds/react-core/text";
var EGDSStylizedText = ({
  align,
  text,
  size,
  weight,
  theme,
  overflow,
  className
}) => {
  return /* @__PURE__ */React16.createElement(EGDSText8, {
    theme: getTextTheme(theme),
    align,
    weight: getTextWeight(weight),
    size: getTextSize(size),
    overflow,
    className
  }, text);
};

// src/components/shared/egds-standard-link.tsx
import React17 from "react";
import { EGDSLink as EGDSLink5 } from "@egds/react-core/link";
var EGDSStandardLink = ({
  align,
  size,
  theme,
  resource,
  text,
  className,
  onClick
}) => {
  const textTheme = getBannerTheme(theme) !== "brand_promo_primary" ? "default" : "inverse";
  return /* @__PURE__ */React17.createElement(EGDSLink5, {
    align,
    size: getLinkSize(size),
    theme: textTheme,
    className,
    onClick
  }, /* @__PURE__ */React17.createElement("a", {
    href: resource
  }, text));
};

// src/components/configurable-banner/configurable-banner-terms-and-conditions.tsx
var TermsAndConditionsField = props => {
  var _a;
  const {
    bannerTheme,
    termsAndConditions,
    className
  } = props;
  const analyticsTrackers = useClickTracker2();
  const onClickTermsAndConditions = () => {
    if ((termsAndConditions == null ? void 0 : termsAndConditions.__typename) === "EGDSStandardLink") {
      analyticsTrackers(termsAndConditions.action.analytics.referrerId, termsAndConditions.action.analytics.linkName);
    }
  };
  if (!termsAndConditions) {
    return null;
  }
  return /* @__PURE__ */React18.createElement(EGDSLayoutFlexItem6, {
    className
  }, termsAndConditions.__typename === "EGDSStandardLink" && termsAndConditions.action.resource.value && /* @__PURE__ */React18.createElement(EGDSStandardLink, {
    align: "left",
    size: termsAndConditions.size,
    theme: bannerTheme != null ? bannerTheme : "PRIMARY" /* PRIMARY */,
    onClick: onClickTermsAndConditions,
    resource: termsAndConditions.action.resource.value,
    text: termsAndConditions.text
  }), termsAndConditions.__typename === "EGDSStylizedText" && termsAndConditions.text && /* @__PURE__ */React18.createElement(EGDSStylizedText, {
    text: termsAndConditions.text,
    align: "left",
    weight: termsAndConditions.weight,
    size: termsAndConditions.textSize,
    theme: (_a = termsAndConditions.theme) != null ? _a : "INVERSE" /* INVERSE */
  }));
};

// src/components/configurable-banner/configurable-banner.tsx
var ConfigurableBanner = ({
  type,
  bannerTheme,
  notificationLocation,
  title,
  egdsTextItem,
  revealActions,
  logo,
  links,
  containerLink,
  dismiss,
  referer,
  body,
  subBody,
  icon,
  customQrCode,
  termsAndConditions,
  backgroundTheme,
  border,
  bannerContainer
}) => {
  var _a, _b, _c, _d;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const [display, setDisplay] = React19.useState(true);
  const {
    cache
  } = useApolloClient2();
  const isCardBody = notificationLocation === "IN_PAGE" /* IN_PAGE */;
  const isInPageAdBody = notificationLocation === "IN_PAGE_AD" /* IN_PAGE_AD */;
  const isCardBodyLargeTextSpacing = isCardBody ? "four" : "three";
  const isCollapsible = (bannerContainer == null ? void 0 : bannerContainer.view) === "COLLAPSIBLE" /* COLLAPSIBLE */;
  const [isExpanded, setIsExpanded] = React19.useState(false);
  const titleEgdsItems = (_a = title == null ? void 0 : title.egdsItems) == null ? void 0 : _a[0];
  const textSize = (egdsTextItem == null ? void 0 : egdsTextItem.textSize) ? getTextSize(egdsTextItem.textSize) : null;
  const textWeight = (egdsTextItem == null ? void 0 : egdsTextItem.weight) ? getTextWeight(egdsTextItem.weight) : null;
  const textTheme = (titleEgdsItems == null ? void 0 : titleEgdsItems.__typename) === "NotificationEGDSTextNode" ? titleEgdsItems == null ? void 0 : titleEgdsItems.theme : "INVERSE" /* INVERSE */;
  const notificationBorder = border != null ? border : void 0;
  const memoizedImpressionLogger = React19.useCallback(() => {
    if (display) {
      customerNotificationActionsExecutor(revealActions);
    }
    return display;
  }, [display]);
  const logoImageSize = isCardBody ? 10 : 12;
  const logoIconSpacing = isCardBody ? {
    margin: {
      blockstart: "one"
    }
  } : {
    margin: {}
  };
  const BodyWrapper = React19.useMemo(() => getGenericBannerBodyComponent(notificationLocation), []);
  const containerBannerLink = React19.useMemo(() => {
    var _a2;
    return createDeepLinkUrl((_a2 = containerLink == null ? void 0 : containerLink.uri) == null ? void 0 : _a2.value, referer);
  }, []);
  const isContainerLayoutPositionBottom = (bannerContainer == null ? void 0 : bannerContainer.layout) === "BOTTOM" /* BOTTOM */;
  const onClickDismiss = React19.useCallback(() => {
    setDisplay(false);
    customerNotificationActionsExecutor(dismiss == null ? void 0 : dismiss.actions);
    cacheEviction(cache, type, notificationLocation);
  }, []);
  const onCardClick = React19.useCallback(() => {
    customerNotificationActionsExecutor(containerLink == null ? void 0 : containerLink.actions);
  }, []);
  const onExpandableClick = () => {
    if (!isCollapsible) {
      return;
    }
    setIsExpanded(prev => !prev);
  };
  return /* @__PURE__ */React19.createElement(React19.Fragment, null, display && memoizedImpressionLogger() && /* @__PURE__ */React19.createElement(Viewport2, null, /* @__PURE__ */React19.createElement(ViewLarge, null, /* @__PURE__ */React19.createElement(BodyWrapper, {
    background: backgroundTheme,
    border: notificationBorder
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignContent: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(AnchorBody, {
    bannerLink: !isCardBody ? containerBannerLink : null,
    onCardClickCallback: onCardClick
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      block: isCardBody ? "unset" : "three",
      inline: isInPageAdBody ? "two" : "unset"
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "center"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: (bannerContainer == null ? void 0 : bannerContainer.layout) === "TOP" /* TOP */ ? "start" : "center",
    grow: 0,
    shrink: isCardBody ? 0 : 1
  }, (logo == null ? void 0 : logo.url) ? /* @__PURE__ */React19.createElement(EGDSMark, {
    url: logo.url,
    description: logo.description,
    size: logoImageSize
  }) : null, (icon == null ? void 0 : icon.id) ? /* @__PURE__ */React19.createElement("span", null, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    name: icon.id,
    title: icon.title || "",
    description: icon.description,
    spotlight: {
      theme: "standard",
      background: true
    }
  })) : null), /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center",
    grow: 0,
    shrink: 1,
    maxWidth: isContainerLayoutPositionBottom ? 1082 : 600
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      inlinestart: isInPageAdBody ? "six" : isCardBodyLargeTextSpacing
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "column",
    alignItems: "start",
    space: isCardBody ? "half" : void 0
  }, (_b = title == null ? void 0 : title.items) == null ? void 0 : _b.map(({
    text,
    styles
  }, index) => /* @__PURE__ */React19.createElement(EGDSText9, {
    key: `text-element-${index}`,
    theme: getTextTheme(textTheme),
    align: "left",
    size: isInPageAdBody ? textSize || 400 : 300,
    weight: textWeight || ((styles == null ? void 0 : styles[0]) === "IMPORTANT" /* IMPORTANT */ ? "bold" : "medium")
  }, text)), body && /* @__PURE__ */React19.createElement(BodyField, {
    body
  }), subBody && /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "start",
    space: isCardBody ? "half" : void 0,
    wrap: "wrap"
  }, /* @__PURE__ */React19.createElement(SubBodyField, {
    subBody
  })), /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React19.createElement(TermsAndConditionsField, {
    termsAndConditions,
    bannerTheme
  })), links && ((customQrCode == null ? void 0 : customQrCode.title) || isContainerLayoutPositionBottom) && /* @__PURE__ */React19.createElement(LinksField, {
    links,
    referer,
    isContainerLayoutPositionBottom
  })))))))), dismiss && /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(EGDSOverlayButton2, {
    onClick: onClickDismiss,
    name: "close",
    "aria-label": "close",
    size: EGDSButtonSize4.SMALL
  }, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    name: "close",
    size: EGDSIconSize2.SMALL
  }))), links && !customQrCode && !isContainerLayoutPositionBottom && /* @__PURE__ */React19.createElement(LinksField, {
    links,
    isButtonOnRight: true,
    referer
  }), customQrCode && /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    minWidth: 76,
    maxWidth: 150,
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutGrid4, null, /* @__PURE__ */React19.createElement(EGDSLayoutGridItem4, {
    colSpan: 1
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    grow: 1,
    minWidth: 78,
    maxWidth: 150,
    alignSelf: "end"
  }, /* @__PURE__ */React19.createElement(CustomQrCodeImage, {
    data: customQrCode,
    theme: "inverse"
  })))))))), /* @__PURE__ */React19.createElement(ViewMedium2, null, /* @__PURE__ */React19.createElement(BodyWrapper, {
    background: backgroundTheme,
    border: notificationBorder
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignContent: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(AnchorBody, {
    bannerLink: !isCardBody ? containerBannerLink : null,
    onCardClickCallback: onCardClick
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      block: isCardBody ? "unset" : "three"
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "start",
    grow: 0,
    shrink: isCardBody ? 0 : 1
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    margin: logoIconSpacing.margin
  }, (logo == null ? void 0 : logo.url) ? /* @__PURE__ */React19.createElement(EGDSMark, {
    url: logo.url,
    description: logo.description,
    size: logoImageSize
  }) : null, (icon == null ? void 0 : icon.id) ? /* @__PURE__ */React19.createElement("span", null, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    name: icon.id,
    title: icon.title || "",
    description: icon.description,
    theme: "primary",
    size: EGDSIconSize2.LARGE,
    spotlight: "standard"
  })) : null)), /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center",
    grow: 0,
    shrink: 1,
    maxWidth: isContainerLayoutPositionBottom ? 1082 : 500
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      inlinestart: isCardBody ? "four" : "three"
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "column",
    alignItems: "start",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, (_c = title == null ? void 0 : title.items) == null ? void 0 : _c.map(({
    text,
    styles
  }, index) => /* @__PURE__ */React19.createElement(EGDSText9, {
    key: `text-element-${index}`,
    theme: getTextTheme(textTheme),
    align: "left",
    size: isInPageAdBody ? textSize || 400 : 300,
    weight: textWeight || ((styles == null ? void 0 : styles[0]) === "IMPORTANT" /* IMPORTANT */ ? "bold" : "regular")
  }, text)), body && /* @__PURE__ */React19.createElement(BodyField, {
    body
  }), subBody && (customQrCode == null ? void 0 : customQrCode.title) && /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "start",
    space: isCardBody ? "half" : void 0,
    wrap: "wrap"
  }, /* @__PURE__ */React19.createElement(SubBodyField, {
    subBody
  })), termsAndConditions && /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React19.createElement(TermsAndConditionsField, {
    termsAndConditions,
    bannerTheme
  })), links && isContainerLayoutPositionBottom && /* @__PURE__ */React19.createElement(LinksField, {
    links,
    isMobile: true,
    referer,
    isContainerLayoutPositionBottom
  })))))))), /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    grow: 0,
    shrink: 0,
    alignSelf: "end"
  }), links && !isContainerLayoutPositionBottom && /* @__PURE__ */React19.createElement(LinksField, {
    links,
    isMobile: true,
    referer
  }), dismiss && /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(EGDSOverlayButton2, {
    onClick: onClickDismiss,
    name: "close",
    "aria-label": "close",
    size: EGDSButtonSize4.SMALL
  }, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    name: "close",
    size: EGDSIconSize2.SMALL
  })))))), /* @__PURE__ */React19.createElement(ViewSmall2, null, /* @__PURE__ */React19.createElement(BodyWrapper, {
    background: backgroundTheme,
    border: notificationBorder
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "center",
    blockSize: "full_size",
    justifyContent: "space-between",
    onClick: onExpandableClick
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(AnchorBody, {
    bannerLink: !isCardBody ? containerBannerLink : null,
    onCardClickCallback: onCardClick
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      block: isCardBody ? "unset" : "three"
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "center"
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: (bannerContainer == null ? void 0 : bannerContainer.layout) === "TOP" /* TOP */ ? "start" : "center",
    grow: 0,
    shrink: isCardBody ? 0 : 1
  }, (logo == null ? void 0 : logo.url) ? /* @__PURE__ */React19.createElement(EGDSMark, {
    url: logo.url,
    description: logo.description,
    size: logoImageSize
  }) : null, (icon == null ? void 0 : icon.id) ? /* @__PURE__ */React19.createElement("span", null, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    id: icon.id,
    name: icon.id,
    title: icon.title || "",
    description: icon.description,
    theme: "primary",
    size: EGDSIconSize2.LARGE,
    spotlight: "standard"
  })) : null), /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center",
    grow: 0,
    shrink: 1
  }, /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      inlinestart: isCardBody ? "four" : "three"
    }
  }, /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "column",
    alignItems: "start",
    blockSize: "full_size",
    justifyContent: "start"
  }, (_d = title == null ? void 0 : title.items) == null ? void 0 : _d.map(({
    text,
    styles
  }, index) => /* @__PURE__ */React19.createElement(EGDSText9, {
    key: `text-element-${index}`,
    theme: getTextTheme(textTheme),
    align: "left",
    size: textSize || 300,
    weight: textWeight || ((styles == null ? void 0 : styles[0]) === "IMPORTANT" /* IMPORTANT */ ? "bold" : "regular")
  }, text)), (!isCollapsible || isCollapsible && isExpanded) && /* @__PURE__ */React19.createElement(React19.Fragment, null, body && /* @__PURE__ */React19.createElement(BodyField, {
    body
  }), subBody && /* @__PURE__ */React19.createElement(EGDSLayoutFlex7, {
    direction: "row",
    alignItems: "start",
    space: isCardBody ? "half" : void 0,
    wrap: "wrap"
  }, /* @__PURE__ */React19.createElement(SubBodyField, {
    subBody
  })), termsAndConditions && /* @__PURE__ */React19.createElement(EGDSSpacing6, {
    padding: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React19.createElement(TermsAndConditionsField, {
    termsAndConditions,
    bannerTheme
  })), links && /* @__PURE__ */React19.createElement(LinksField, {
    links,
    isMobile: true,
    referer,
    isContainerLayoutPositionBottom
  }))))))))), dismiss && /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center"
  }, /* @__PURE__ */React19.createElement(EGDSOverlayButton2, {
    onClick: onClickDismiss,
    name: "close",
    "aria-label": "close",
    size: EGDSButtonSize4.SMALL
  }, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    name: "close",
    size: EGDSIconSize2.SMALL
  }))), isCollapsible && /* @__PURE__ */React19.createElement(EGDSLayoutFlexItem7, {
    alignSelf: "center",
    grow: 0
  }, /* @__PURE__ */React19.createElement("div", {
    "data-testid": "configurable-banner-expando"
  }, /* @__PURE__ */React19.createElement(EGDSIcon3, {
    name: isExpanded ? "expand_less" : "expand_more",
    size: EGDSIconSize2.MEDIUM
  }))))))));
};
ConfigurableBanner.displayName = "sharedui-ConfigurableBanner";

// src/components/configurable-banner/configurable-banner-wrapper.tsx
var MemoizedConfigurableBanner = React20.memo(ConfigurableBanner);
var ConfigurableBannerWrapper = ({
  data,
  inputs
}) => {
  var _a, _b;
  const {
    notificationLocation,
    title,
    logo,
    dismiss,
    revealActions,
    links,
    containerLink,
    body,
    subBody,
    icon,
    customQrCode,
    legalText,
    theme,
    bannerContainer
  } = data || {};
  const {
    optionalContext
  } = inputs;
  const backgroundTheme = (theme == null ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme == null ? void 0 : theme.themeValue : null;
  const border = (theme == null ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme == null ? void 0 : theme.cardBorder : false;
  const termsAndConditions = (_a = legalText == null ? void 0 : legalText.egdsTextItems) == null ? void 0 : _a.find(link => (link == null ? void 0 : link.__typename) === "EGDSStandardLink" || (link == null ? void 0 : link.__typename) === "EGDSStylizedText");
  const egdsTextItem = (_b = title == null ? void 0 : title.egdsTextItems) == null ? void 0 : _b.find(item => (item == null ? void 0 : item.__typename) === "EGDSStylizedText");
  const bannerTheme = "BRAND_PROMO_PRIMARY" /* BRAND_PROMO_PRIMARY */;
  const memoizedConfigurableData = React20.useMemo(() => ({
    bannerTheme,
    type: "CONFIGURABLE" /* CONFIGURABLE */,
    notificationLocation,
    title,
    egdsTextItem,
    revealActions,
    logo,
    links,
    containerLink,
    dismiss,
    referer: optionalContext == null ? void 0 : optionalContext.referer,
    body,
    subBody,
    icon,
    customQrCode,
    backgroundTheme,
    border,
    termsAndConditions,
    bannerContainer
  }), []);
  if (!title) {
    return null;
  }
  return /* @__PURE__ */React20.createElement(MemoizedConfigurableBanner, __spreadValues({}, memoizedConfigurableData));
};

// src/components/full-sheet-image/full-sheet-image-wrapper.tsx
import React38 from "react";

// src/components/full-sheet-image/full-sheet-image.tsx
import React37 from "react";
import { EGDSButtonSize as EGDSButtonSize6 } from "@egds/react-core/button";
import { EGDSFigure as EGDSFigure3, EGDSImage as EGDSImage3 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex8, EGDSLayoutFlexItem as EGDSLayoutFlexItem8 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid5 } from "@egds/react-core/layout-grid";
import { EGDSMark as EGDSMark3 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing7 } from "@egds/react-core/spacing";
import { EGDSViewRow as EGDSViewRow3 } from "@egds/react-core/view";
import { useApolloClient as useApolloClient3 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";

// ../internal/src/components/egds-text/bulletpoint-text.tsx
import React21 from "react";
import { EGDSIcon as EGDSIcon4, EGDSIconSize as EGDSIconSize3 } from "@egds/react-core/icons";
import { EGDSList, EGDSListItem } from "@egds/react-core/list";
import { EGDSText as EGDSText10 } from "@egds/react-core/text";
var BulletpointText = props => {
  var _a;
  const {
    body,
    isCardTheme
  } = props;
  if (!body && !(body == null ? void 0 : body.items)) {
    return null;
  }
  return /* @__PURE__ */React21.createElement(EGDSList, {
    bullet: "icon-standard",
    spacing: false,
    type: "unordered"
  }, (_a = body == null ? void 0 : body.items) == null ? void 0 : _a.map((item, index) => /* @__PURE__ */React21.createElement(EGDSListItem, {
    key: index
  }, /* @__PURE__ */React21.createElement(EGDSIcon4, {
    theme: isCardTheme ? "default" : "positive",
    name: "check",
    size: EGDSIconSize3.EXTRA_SMALL
  }), /* @__PURE__ */React21.createElement(EGDSText10, {
    theme: isCardTheme ? "default" : "inverse",
    weight: "regular",
    size: 400
  }, item.text))));
};
BulletpointText.displayName = "BulletpointText";

// ../internal/src/components/egds-text/inline-text.tsx
import React22 from "react";
import { EGDSText as EGDSText11 } from "@egds/react-core/text";
var SPACE = " ";
var InlineText = props => {
  var _a;
  const {
    body,
    isCardTheme,
    className
  } = props;
  if (!body && !(body == null ? void 0 : body.items)) {
    return null;
  }
  return /* @__PURE__ */React22.createElement(EGDSText11, {
    className
  }, (_a = body == null ? void 0 : body.items) == null ? void 0 : _a.map((item, index) => (item == null ? void 0 : item.text) && /* @__PURE__ */React22.createElement(EGDSText11, {
    key: index,
    inline: true,
    align: "left",
    theme: isCardTheme ? "default" : "inverse",
    weight: index === 0 ? "bold" : "regular",
    size: 400,
    className
  }, item.text, SPACE)));
};
InlineText.displayName = "InlineText";

// ../internal/src/components/dismiss-notification/dismiss-notification.tsx
import React23 from "react";
import { EGDSTransparentToolbar } from "@egds/react-core/toolbar";
import { gql as gql3 } from "@shared-ui/apollo-client-wrapper";
var __NotificationDismissFragment = gql3`
  fragment NotificationDismissFragment on NotificationDismiss {
    icon {
      id
      description
    }
    actions {
      ...NotificationActionFragment
    }
  }
  ${NotificationActionFragment}
`;
var DismissNotification = ({
  data,
  onClickDismissCB
}) => {
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  if (!data) {
    return null;
  }
  const {
    icon,
    actions
  } = data;
  const onClick = () => {
    customerNotificationActionsExecutor(actions);
    onClickDismissCB();
  };
  return (icon == null ? void 0 : icon.id) && /* @__PURE__ */React23.createElement(EGDSTransparentToolbar, {
    overlay: true,
    navigationContent: {
      onClick,
      navIconLabel: icon == null ? void 0 : icon.description,
      navButtonId: icon == null ? void 0 : icon.id
    }
  });
};
DismissNotification.displayName = "DismissNotification";
DismissNotification.fragment = __NotificationDismissFragment;

// ../internal/src/components/logo/notification-logo.tsx
import React24 from "react";
import { EGDSMark as EGDSMark2 } from "@egds/react-core/mark";
import { gql as gql4 } from "@shared-ui/apollo-client-wrapper";
var __NotificationLogoFragment = gql4`
  fragment NotificationLogoFragment on Image {
    description
    url
  }
`;
var NotificationLogo = ({
  data,
  className
}) => {
  if (!(data == null ? void 0 : data.url)) {
    return null;
  }
  const {
    description,
    url
  } = data;
  return /* @__PURE__ */React24.createElement(EGDSMark2, {
    description,
    url,
    size: 14,
    className
  });
};
NotificationLogo.displayName = "CustomerNotificationLogo";
NotificationLogo.fragment = __NotificationLogoFragment;

// ../internal/src/components/background-image/background-image.tsx
import React25 from "react";
import { EGDSFigure as EGDSFigure2, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType2, EGDSImage as EGDSImage2 } from "@egds/react-core/images";
import { gql as gql5 } from "@shared-ui/apollo-client-wrapper";
var __BackgroundImageFragment = gql5`
  fragment BackgroundImageFragment on Image {
    description
    url
    aspectRatio
  }
`;
var RatioDictionary = {
  ["ONE_ONE" /* ONE_ONE */]: EGDSFigureAspectRatioType2.R1_1,
  ["FOUR_THREE" /* FOUR_THREE */]: EGDSFigureAspectRatioType2.R4_3,
  ["THREE_TWO" /* THREE_TWO */]: EGDSFigureAspectRatioType2.R3_2,
  ["SIXTEEN_NINE" /* SIXTEEN_NINE */]: EGDSFigureAspectRatioType2.R16_9,
  ["TWENTY_ONE_NINE" /* TWENTY_ONE_NINE */]: EGDSFigureAspectRatioType2.R21_9,
  ["THREE_FOUR" /* THREE_FOUR */]: EGDSFigureAspectRatioType2.R3_4,
  ["FOUR_ONE" /* FOUR_ONE */]: EGDSFigureAspectRatioType2.R4_1
};
var BackgroundImage = ({
  data,
  overrideAspectRatio,
  className
}) => {
  if (!(data == null ? void 0 : data.url)) {
    return null;
  }
  const {
    description,
    url,
    aspectRatio
  } = data;
  return /* @__PURE__ */React25.createElement(EGDSFigure2, {
    imageFit: "contain",
    ratio: overrideAspectRatio != null ? overrideAspectRatio : RatioDictionary[aspectRatio != null ? aspectRatio : "SIXTEEN_NINE" /* SIXTEEN_NINE */],
    className
  }, /* @__PURE__ */React25.createElement(EGDSImage2, {
    alt: description,
    src: url
  }));
};
BackgroundImage.displayName = "CustomerBackgroundImage";
BackgroundImage.fragment = __BackgroundImageFragment;

// ../internal/src/components/notification-body/notification-body.tsx
import React35 from "react";

// ../internal/src/components/notification-phrase/notification-phrase.tsx
import React34 from "react";
import { gql as gql13 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-list/egds-unordered-list.tsx
import React27 from "react";
import { EGDSList as EGDSList2, EGDSListItem as EGDSListItem2 } from "@egds/react-core/list";
import { EGDSText as EGDSText12 } from "@egds/react-core/text";
import { gql as gql7 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-icon/egds-icon.tsx
import React26 from "react";
import { EGDSIcon as EGDSIcon5, EGDSIconSize as EGDSIconSize4 } from "@egds/react-core/icons";
import { gql as gql6 } from "@shared-ui/apollo-client-wrapper";
var __EGDSIconFragment = gql6`
  fragment EGDSIconFragment on Icon {
    id
    token
    size
    theme
    title
    withBackground
    spotLight
  }
`;
var ICON_SIZE_MAP = {
  EXTRA_SMALL: EGDSIconSize4.EXTRA_SMALL,
  SMALL: EGDSIconSize4.SMALL,
  MEDIUM: EGDSIconSize4.MEDIUM,
  LARGE: EGDSIconSize4.LARGE
};
var EGDSIconComponent = ({
  data
}) => {
  if (!data) {
    return null;
  }
  const {
    id,
    token,
    size,
    theme
  } = data;
  return /* @__PURE__ */React26.createElement(EGDSIcon5, {
    name: id != null ? id : token,
    size: ICON_SIZE_MAP[size != null ? size : "EXTRA_SMALL"],
    theme: theme != null ? theme : "default"
  });
};
EGDSIconComponent.displayName = "CustomerEGDSIcon";
EGDSIconComponent.fragment = __EGDSIconFragment;

// ../internal/src/components/egds-list/egds-unordered-list.tsx
var __EGDSUnorderedListFragment = gql7`
  fragment EGDSUnorderedListFragment on EGDSUnorderedList {
    listItems {
      ... on EGDSTextIconListItem {
        text
        icon {
          ...EGDSIconFragment
        }
      }
    }
  }

  ${EGDSIconComponent.fragment}
`;
var EGDSUnorderedList = ({
  data,
  className
}) => {
  const {
    textStyle: text
  } = React27.useContext(BannerThemeStateContext);
  if (!data) {
    return null;
  }
  const {
    listItems
  } = data;
  return /* @__PURE__ */React27.createElement(EGDSList2, {
    bullet: "icon-standard",
    spacing: false,
    type: "unordered",
    className
  }, listItems == null ? void 0 : listItems.map((item, index) => {
    switch (item.__typename) {
      case "EGDSTextIconListItem":
        return /* @__PURE__ */React27.createElement(EGDSListItem2, {
          key: index
        }, /* @__PURE__ */React27.createElement(EGDSIconComponent, {
          data: item.icon
        }), /* @__PURE__ */React27.createElement(EGDSText12, {
          weight: "regular",
          size: 400,
          theme: text == null ? void 0 : text.theme,
          align: "left"
        }, item.text));
      default:
        return null;
    }
  }));
};
EGDSUnorderedList.displayName = "EGDSUnorderedList";
EGDSUnorderedList.fragment = __EGDSUnorderedListFragment;

// ../internal/src/components/egds-spannable-text/egds-spannable-text.tsx
import React30 from "react";
import { EGDSText as EGDSText14 } from "@egds/react-core/text";
import { gql as gql10 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-standard-link/egds-standard-link.tsx
import React28 from "react";
import { EGDSLink as EGDSLink6 } from "@egds/react-core/link";
import { gql as gql8 } from "@shared-ui/apollo-client-wrapper";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var __EGDSStandardLinkFragment = gql8`
  fragment EGDSStandardLinkFragment on EGDSStandardLink {
    __typename
    text
    action {
      resource {
        value
      }
      target
      analytics {
        linkName
        referrerId
      }
    }
    iconPosition
    size
    disabled
  }
`;
var Link_Size_Dictionary2 = {
  small: "small",
  medium: "medium",
  large: "large"
};
var EGDSStandardLink2 = ({
  data,
  overrideTextStyles,
  className
}) => {
  const analyticsTrackers = useClickTracker3();
  if (!data) {
    return null;
  }
  const {
    action,
    text,
    __typename
  } = data;
  const {
    textStyle
  } = CalculatedBannerThemeStateContext({
    textFragments: data,
    overrideTextStyles
  });
  const onClick = () => {
    if (__typename === "EGDSStandardLink") {
      analyticsTrackers(action.analytics.referrerId, action.analytics.linkName);
    }
  };
  return /* @__PURE__ */React28.createElement(EGDSLink6, {
    theme: textStyle.theme,
    size: Link_Size_Dictionary2[textStyle.size],
    align: textStyle.align,
    inline: true,
    onClick,
    className
  }, /* @__PURE__ */React28.createElement("a", {
    href: action.resource.value,
    target: "_blank",
    rel: "noopener"
  }, text));
};
EGDSStandardLink2.displayName = "CustomerEGDSStandardLink";
EGDSStandardLink2.fragment = __EGDSStandardLinkFragment;

// ../internal/src/components/egds-stylized-text/egds-stylized-text.tsx
import React29 from "react";
import { EGDSText as EGDSText13 } from "@egds/react-core/text";
import { gql as gql9 } from "@shared-ui/apollo-client-wrapper";
var __EGDSStylizedTextFragment = gql9`
  fragment EGDSStylizedTextFragment on EGDSStylizedText {
    __typename
    text
    textSize: size
    weight
    theme
  }
`;
var EGDSStylizedText2 = ({
  data,
  inline,
  overrideTextStyles,
  className
}) => {
  if (!(data == null ? void 0 : data.text)) {
    return null;
  }
  const {
    text
  } = data;
  const {
    textStyle
  } = CalculatedBannerThemeStateContext({
    textFragments: data,
    overrideTextStyles
  });
  return /* @__PURE__ */React29.createElement(EGDSText13, {
    size: textStyle.size,
    weight: textStyle.weight,
    theme: textStyle.theme,
    align: textStyle.align,
    inline,
    className
  }, text);
};
EGDSStylizedText2.displayName = "CustomerEGDSStylizedText";
EGDSStylizedText2.fragment = __EGDSStylizedTextFragment;

// ../internal/src/components/egds-spannable-text/egds-spannable-text.tsx
var __EGDSSpannableTextFragment = gql10`
  fragment EGDSSpannableTextFragment on EGDSSpannableText {
    inlineContent {
      ...EGDSStylizedTextFragment
      ...EGDSStandardLinkFragment
    }
  }
  ${EGDSStylizedText2.fragment}
  ${EGDSStandardLink2.fragment}
`;
var EGDSSpannableText = ({
  data,
  className
}) => {
  if (!data) {
    return null;
  }
  const {
    inlineContent
  } = data;
  return /* @__PURE__ */React30.createElement(EGDSText14, {
    className
  }, inlineContent == null ? void 0 : inlineContent.map((content, index) => {
    switch (content.__typename) {
      case "EGDSStylizedText":
        return /* @__PURE__ */React30.createElement(EGDSStylizedText2, {
          key: index,
          data: content,
          inline: true
        });
      case "EGDSStandardLink":
        return /* @__PURE__ */React30.createElement(EGDSStandardLink2, {
          key: index,
          data: content
        });
      default:
        return null;
    }
  }));
};
EGDSSpannableText.displayName = "EGDSSpannableText";
EGDSSpannableText.fragment = __EGDSSpannableTextFragment;

// ../internal/src/components/notification-phrase-link-node/notification-phrase-link-node.tsx
import React32 from "react";
import { EGDSButtonSize as EGDSButtonSize5 } from "@egds/react-core/button";
import { EGDSLink as EGDSLink7 } from "@egds/react-core/link";
import { gql as gql11 } from "@shared-ui/apollo-client-wrapper";

// ../internal/src/components/egds-button/egds-button.tsx
import React31 from "react";
import { EGDSPrimaryButton as EGDSPrimaryButton3, EGDSTertiaryButton as EGDSTertiaryButton3 } from "@egds/react-core/button";
var EGDSButton = ({
  notificationLinkType,
  href,
  size,
  onClick,
  className,
  children
}) => {
  switch (notificationLinkType) {
    case "PRIMARY_BUTTON" /* PRIMARY_BUTTON */:
      return /* @__PURE__ */React31.createElement(EGDSPrimaryButton3, {
        href,
        size,
        className,
        isFullWidth: true,
        onClick
      }, children);
    case "TERTIARY_BUTTON" /* TERTIARY_BUTTON */:
      return /* @__PURE__ */React31.createElement(EGDSTertiaryButton3, {
        href,
        size,
        className,
        isFullWidth: true,
        onClick
      }, children);
    default:
      return /* @__PURE__ */React31.createElement(EGDSPrimaryButton3, {
        href,
        size,
        className,
        isFullWidth: true,
        onClick
      }, children);
  }
};
EGDSButton.displayName = "NotificationButton";

// ../internal/src/components/notification-phrase-link-node/notification-phrase-link-node.tsx
var __NotificationPhraseLinkNodeFragment = gql11`
  fragment NotificationLinkNodeFragment on NotificationPhraseLinkNode {
    id
    type
    text
    target
    uri {
      __typename
      value
    }
    icon {
      id
      description
      title
    }
    actions {
      ...NotificationActionFragment
    }
  }
`;
var NotificationPhraseLinkNode = ({
  data,
  overrideTextStyles,
  className,
  onCloseAction
}) => {
  var _a;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  if (!data) {
    return null;
  }
  const {
    icon,
    uri,
    actions,
    text,
    type
  } = data;
  const onClickAction = (uri == null ? void 0 : uri.value) ? () => {
    customerNotificationActionsExecutor(actions);
  } : onCloseAction;
  if (type === "ANCHOR" /* ANCHOR */) {
    return /* @__PURE__ */React32.createElement(EGDSLink7, {
      align: (_a = overrideTextStyles == null ? void 0 : overrideTextStyles.align) != null ? _a : "center",
      size: "small",
      theme: "inverse",
      inline: true,
      onClick: onClickAction,
      className
    }, /* @__PURE__ */React32.createElement("a", {
      href: uri == null ? void 0 : uri.value,
      target: "_blank",
      rel: "noopener"
    }, text));
  }
  return /* @__PURE__ */React32.createElement(EGDSButton, {
    notificationLinkType: type,
    href: uri == null ? void 0 : uri.value,
    size: EGDSButtonSize5.LARGE,
    onClick: onClickAction,
    isFullWidth: true,
    className
  }, text);
};
NotificationPhraseLinkNode.displayName = "NotificationPhraseLinkNode";
NotificationPhraseLinkNode.fragment = __NotificationPhraseLinkNodeFragment;

// ../internal/src/components/notification-phrase-text-node/notification-phrase-text-node.tsx
import React33 from "react";
import { EGDSText as EGDSText15 } from "@egds/react-core/text";
import { gql as gql12 } from "@shared-ui/apollo-client-wrapper";
import { ViewMedium as ViewMedium3, Viewport as Viewport3, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
var __NotificationPhraseTextNodeFragment = gql12`
  fragment NotificationPhraseTextNodeFragment on NotificationPhraseTextNode {
    text
  }
`;
var NotificationPhraseTextNode = ({
  data,
  overrideTextStyles
}) => {
  var _a, _b, _c;
  const {
    textStyle
  } = React33.useContext(BannerThemeStateContext);
  if (!(data == null ? void 0 : data.text)) {
    return null;
  }
  const {
    text
  } = data;
  return /* @__PURE__ */React33.createElement(Viewport3, null, /* @__PURE__ */React33.createElement(ViewMedium3, null, /* @__PURE__ */React33.createElement(EGDSText15, {
    theme: (_a = overrideTextStyles == null ? void 0 : overrideTextStyles.theme) != null ? _a : textStyle == null ? void 0 : textStyle.theme,
    size: 500,
    weight: "medium",
    align: "left"
  }, text)), /* @__PURE__ */React33.createElement(ViewSmall3, null, /* @__PURE__ */React33.createElement(EGDSText15, {
    theme: (_b = overrideTextStyles == null ? void 0 : overrideTextStyles.theme) != null ? _b : textStyle == null ? void 0 : textStyle.theme,
    size: 500,
    weight: "regular",
    align: (_c = textStyle == null ? void 0 : textStyle.align) != null ? _c : "center"
  }, text)));
};
NotificationPhraseTextNode.displayName = "NotificationPhraseTextNode";
NotificationPhraseTextNode.fragment = __NotificationPhraseTextNodeFragment;

// ../internal/src/components/notification-phrase/notification-phrase.tsx
var __NotificationPhraseFragment = gql13`
  fragment EgdsItems on NotificationPhrase {
    egdsItems {
      ... on NotificationEGDSTextNode {
        text
        theme
        weight
      }
      ... on NotificationEGDSLinkNode {
        action {
          accessibility
          analytics {
            linkName
            referrerId
          }
          resource {
            value
          }
          target
        }
      }
    }
  }
  fragment NotificationPhraseFragment on NotificationPhrase {
    accessibilityLabel
    completeText
    ...EgdsItems
    egdsTextItems {
      ...EGDSStylizedTextFragment
      ...EGDSStandardLinkFragment
      ...EGDSUnorderedListFragment
      ...EGDSSpannableTextFragment
    }
    items {
      __typename
      text
      styles
      ...NotificationLinkNodeFragment
    }
  }
  ${EGDSStylizedText2.fragment}
  ${EGDSStandardLink2.fragment}
  ${EGDSUnorderedList.fragment}
  ${EGDSSpannableText.fragment}
  ${NotificationPhraseLinkNode.fragment}
`;
var NotificationPhrase = ({
  data,
  overrideTextStyles,
  className,
  onCloseAction
}) => {
  if (!data) {
    return null;
  }
  const {
    items,
    egdsTextItems
  } = data;
  if ((egdsTextItems == null ? void 0 : egdsTextItems.length) > 0) {
    return egdsTextItems.map((item, index) => {
      switch (item.__typename) {
        case "EGDSStylizedText":
          return /* @__PURE__ */React34.createElement(EGDSStylizedText2, {
            key: index,
            data: item,
            overrideTextStyles,
            className
          });
        case "EGDSStandardLink":
          return /* @__PURE__ */React34.createElement(EGDSStandardLink2, {
            key: index,
            data: item,
            overrideTextStyles,
            className
          });
        case "EGDSUnorderedList":
          return /* @__PURE__ */React34.createElement(EGDSUnorderedList, {
            key: index,
            data: item,
            className
          });
        case "EGDSSpannableText":
          return /* @__PURE__ */React34.createElement(EGDSSpannableText, {
            key: index,
            data: item,
            className
          });
        default:
          return null;
      }
    });
  }
  if ((items == null ? void 0 : items.length) > 0) {
    return items.map((item, index) => {
      switch (item.__typename) {
        case "NotificationPhraseTextNode":
          return /* @__PURE__ */React34.createElement(NotificationPhraseTextNode, {
            key: index,
            data: item,
            overrideTextStyles
          });
        case "NotificationPhraseLinkNode":
          return /* @__PURE__ */React34.createElement(NotificationPhraseLinkNode, {
            key: index,
            data: item,
            overrideTextStyles,
            onCloseAction
          });
        default:
          return null;
      }
    });
  }
  return null;
};
NotificationPhrase.displayName = "NotificationPhrase";
NotificationPhrase.fragment = __NotificationPhraseFragment;

// ../internal/src/components/notification-body/notification-body.tsx
var NotificationBodyArray = ({
  body,
  overrideTextStyles,
  className
}) => {
  if (!body) {
    return null;
  }
  return body.map((item, itemIndex) => {
    return /* @__PURE__ */React35.createElement(NotificationPhrase, {
      key: itemIndex,
      data: item,
      overrideTextStyles,
      className
    });
  });
};
NotificationBodyArray.displayName = "CustomerNotificationBodyArray";

// src/components/full-sheet-image/full-sheet-image.tsx
import { Viewport as Viewport4, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";

// src/components/helpers/use-sheet-wrapper.tsx
import React36 from "react";
import { EGDSSheetServerSideRender, EGDSSheetServerSideRenderContent } from "@egds/react-app-growth";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { useDialog } from "@shared-ui/dialog-context";
import { useExperiment } from "@shared-ui/experiment-context";
var EGDSSheetContentWrapper = ({
  children,
  padded,
  fullSheetContentMaxWidth,
  className
}) => {
  return /* @__PURE__ */React36.createElement(EGDSSheetContent2, {
    padded,
    fullSheetContentMaxWidth,
    className
  }, children);
};
var ServerSideSheetContentWrapper = ({
  children,
  padded,
  fullSheetContentMaxWidth,
  className
}) => {
  return /* @__PURE__ */React36.createElement(EGDSSheetServerSideRenderContent, {
    padded,
    fullSheetContentMaxWidth,
    className
  }, children);
};
var useSheetWrapper = onDialogClose => {
  const {
    exposure
  } = useExperiment("server_sheet_integration");
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog("customer-notification-centered-sheet-dialog", "", true, onDialogClose);
  const [isOpen, setIsOpen] = React36.useState(true);
  const flag = exposure.bucket === 1 ? isOpen : isDialogOpen;
  const WrapperComponent = ({
    type,
    triggerRef,
    centeredSheetSize,
    theme,
    className: classNames,
    onDismiss,
    children
  }) => {
    if (exposure.bucket === 1) {
      return /* @__PURE__ */React36.createElement(EGDSSheetServerSideRender, {
        isVisible: isOpen,
        type,
        triggerRef,
        centeredSheetSize,
        theme,
        className: classNames,
        onDismiss
      }, children);
    }
    return /* @__PURE__ */React36.createElement(EGDSSheetTransition2, {
      isVisible: isDialogOpen,
      closeCallback: onDialogClose
    }, /* @__PURE__ */React36.createElement(DialogComponent, null, /* @__PURE__ */React36.createElement(EGDSSheet2, {
      isVisible: isDialogOpen,
      type,
      triggerRef,
      theme,
      className: classNames,
      centeredSheetSize
    }, children)));
  };
  const ContentComponent = exposure.bucket === 1 ? ServerSideSheetContentWrapper : EGDSSheetContentWrapper;
  React36.useEffect(() => {
    if (exposure.bucket === 0) {
      dialogActions.openDialog();
    }
  }, []);
  return [flag, dialogActions, WrapperComponent, ContentComponent];
};

// src/components/full-sheet-image/full-sheet-image.tsx
var FullSheetImage = ({
  type,
  bannerTheme,
  notificationLocation,
  sheetTitle,
  logo,
  switchToTheAppLink,
  dismiss,
  termsAndConditions,
  backgroundImage,
  referer,
  revealActions
}) => {
  var _a, _b, _c;
  const triggerRef = React37.useRef(null);
  const [isOpen, sheetAction, WrapperComponent, ContentComponent] = useSheetWrapper();
  const {
    cache
  } = useApolloClient3();
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const analyticsTrackers = useClickTracker4();
  const theme = getBannerTheme(bannerTheme);
  const bottomMargin = !termsAndConditions ? {
    blockstart: "six",
    blockend: "eight"
  } : void 0;
  const deepLink = createDeepLinkUrl((_a = switchToTheAppLink.uri) == null ? void 0 : _a.value, referer);
  const CustomerButtonComponent = getButtonComponent(switchToTheAppLink.type);
  const onClickButton = () => {
    customerNotificationActionsExecutor(switchToTheAppLink.actions);
  };
  const onClickDismiss = () => {
    sheetAction.closeDialog();
    cacheEviction(cache, type, notificationLocation);
  };
  const onClickTermsAndConditions = () => {
    var _a2, _b2;
    if ((termsAndConditions == null ? void 0 : termsAndConditions.__typename) === "EGDSStandardLink") {
      analyticsTrackers((_a2 = termsAndConditions == null ? void 0 : termsAndConditions.action.analytics.referrerId) != null ? _a2 : "", (_b2 = termsAndConditions == null ? void 0 : termsAndConditions.action.analytics.linkName) != null ? _b2 : "");
    }
  };
  React37.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  return /* @__PURE__ */React37.createElement(React37.Fragment, null, isOpen && /* @__PURE__ */React37.createElement(Viewport4, null, /* @__PURE__ */React37.createElement(ViewSmall4, null, /* @__PURE__ */React37.createElement(WrapperComponent, {
    type: "full",
    triggerRef,
    theme: "dark"
  }, dismiss && /* @__PURE__ */React37.createElement(DismissNotification, {
    data: dismiss,
    onClickDismissCB: onClickDismiss
  }), /* @__PURE__ */React37.createElement(ContentComponent, {
    padded: false
  }, /* @__PURE__ */React37.createElement(EGDSLayoutGrid5, {
    blockSize: "full_size"
  }, /* @__PURE__ */React37.createElement(EGDSLayoutFlex8, {
    direction: "column",
    style: {
      height: "100%"
    }
  }, /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, null, /* @__PURE__ */React37.createElement(EGDSViewRow3, {
    canvasTheme: theme,
    layout: "fullwidth"
  }, /* @__PURE__ */React37.createElement(EGDSSpacing7, {
    margin: {
      blockstart: "sixteen"
    }
  }, /* @__PURE__ */React37.createElement(EGDSSpacing7, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React37.createElement(EGDSLayoutFlex8, {
    direction: "column",
    justifyContent: termsAndConditions ? "center" : "start",
    space: "six",
    wrap: "wrap"
  }, /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, {
    alignSelf: "start"
  }, /* @__PURE__ */React37.createElement(EGDSMark3, {
    url: logo.url,
    description: logo.description,
    size: 12
  })), sheetTitle.text && /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, {
    shrink: 1,
    maxWidth: "180x"
  }, /* @__PURE__ */React37.createElement(EGDSSpacing7, {
    margin: {
      inlineend: "twelve"
    }
  }, /* @__PURE__ */React37.createElement(EGDSStylizedText, {
    theme: (_b = sheetTitle.theme) != null ? _b : "INVERSE" /* INVERSE */,
    weight: sheetTitle == null ? void 0 : sheetTitle.weight,
    size: sheetTitle == null ? void 0 : sheetTitle.textSize,
    text: sheetTitle == null ? void 0 : sheetTitle.text
  }))), switchToTheAppLink.text && deepLink && /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, {
    alignSelf: "start"
  }, /* @__PURE__ */React37.createElement(EGDSSpacing7, {
    margin: bottomMargin
  }, /* @__PURE__ */React37.createElement(CustomerButtonComponent, {
    href: deepLink,
    size: EGDSButtonSize6.LARGE,
    onClick: onClickButton
  }, switchToTheAppLink.text))), (termsAndConditions == null ? void 0 : termsAndConditions.text) && /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, {
    alignSelf: "start"
  }, /* @__PURE__ */React37.createElement(EGDSLayoutFlex8, {
    justifyContent: "center",
    alignItems: "end"
  }, /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, {
    grow: 2,
    alignSelf: "end"
  }, /* @__PURE__ */React37.createElement(EGDSSpacing7, {
    margin: {
      blockend: "eight"
    }
  }, termsAndConditions.__typename === "EGDSStandardLink" && termsAndConditions.action.resource.value && /* @__PURE__ */React37.createElement(EGDSStandardLink, {
    align: "center",
    size: termsAndConditions.size,
    theme: bannerTheme != null ? bannerTheme : "PRIMARY" /* PRIMARY */,
    onClick: onClickTermsAndConditions,
    resource: termsAndConditions.action.resource.value,
    text: termsAndConditions.text
  }), termsAndConditions.__typename === "EGDSStylizedText" && termsAndConditions.text && /* @__PURE__ */React37.createElement(EGDSStylizedText, {
    text: termsAndConditions.text,
    align: "center",
    weight: termsAndConditions.weight,
    size: termsAndConditions.textSize,
    theme: (_c = termsAndConditions.theme) != null ? _c : "INVERSE" /* INVERSE */
  })))))))))), /* @__PURE__ */React37.createElement(EGDSLayoutFlexItem8, {
    grow: 2
  }, backgroundImage.url && /* @__PURE__ */React37.createElement(EGDSFigure3, {
    imageFit: "cover"
  }, /* @__PURE__ */React37.createElement(EGDSImage3, {
    src: backgroundImage.url,
    alt: backgroundImage.description,
    placeholderImage: true,
    additionalProps: {
      fetchPriority: "high"
    }
  }))))))))));
};

// src/components/full-sheet-image/full-sheet-image-wrapper.tsx
var FullSheetImageWrapper = props => {
  var _a, _b, _c, _d, _e;
  const {
    data: {
      type,
      bannerContainer,
      notificationLocation,
      title,
      logo,
      links,
      revealActions,
      dismiss,
      backgroundImage,
      legalText
    },
    inputs: {
      optionalContext
    }
  } = props;
  const switchToTheApp = links == null ? void 0 : links[0];
  if (!((_a = switchToTheApp == null ? void 0 : switchToTheApp.uri) == null ? void 0 : _a.value) || !title || !logo || !backgroundImage || !revealActions || !(dismiss == null ? void 0 : dismiss.icon.id)) {
    return null;
  }
  const termsAndContitionsLink = (_b = legalText == null ? void 0 : legalText.egdsTextItems) == null ? void 0 : _b.find(link => (link == null ? void 0 : link.__typename) === "EGDSStandardLink" || (link == null ? void 0 : link.__typename) === "EGDSStylizedText");
  let sheetTitle;
  let bannerTheme = "BRAND_PROMO_PRIMARY" /* BRAND_PROMO_PRIMARY */;
  if (((_d = (_c = title == null ? void 0 : title.egdsTextItems) == null ? void 0 : _c[0]) == null ? void 0 : _d.__typename) === "EGDSStylizedText") {
    const [firstItem] = title.egdsTextItems;
    sheetTitle = firstItem;
  }
  if (((_e = bannerContainer == null ? void 0 : bannerContainer.theme) == null ? void 0 : _e.__typename) === "NotificationBannerTheme" && bannerContainer.theme.bannerTheme) {
    bannerTheme = bannerContainer.theme.bannerTheme;
  }
  if (!sheetTitle) {
    return null;
  }
  return /* @__PURE__ */React38.createElement(FullSheetImage, {
    type,
    bannerTheme,
    backgroundImage,
    notificationLocation,
    sheetTitle,
    logo,
    switchToTheAppLink: switchToTheApp,
    termsAndConditions: termsAndContitionsLink,
    dismiss,
    referer: optionalContext == null ? void 0 : optionalContext.referer,
    revealActions
  });
};

// src/components/generic-notification/generic-notification-wrapper.tsx
import React41 from "react";

// src/components/generic-notification/generic-notification.tsx
import React39 from "react";
import { EGDSCard as EGDSCard5, EGDSCardContentSection as EGDSCardContentSection4 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex9, EGDSLayoutFlexItem as EGDSLayoutFlexItem9 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink8 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing8 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading5, EGDSText as EGDSText16 } from "@egds/react-core/text";
var GenericNotification = props => {
  const {
    heading,
    body,
    links,
    revealActions
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React39.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const handleClick = React39.useCallback(actions => () => {
    customerNotificationActionsExecutor(actions);
  }, [customerNotificationActionsExecutor]);
  return /* @__PURE__ */React39.createElement(EGDSCard5, {
    border: true
  }, /* @__PURE__ */React39.createElement(EGDSSpacing8, {
    padding: {
      inlinestart: "four"
    }
  }, /* @__PURE__ */React39.createElement(EGDSCardContentSection4, null, heading && /* @__PURE__ */React39.createElement("div", null, /* @__PURE__ */React39.createElement(EGDSHeading5, {
    tag: "h3",
    size: 5
  }, heading)), body && /* @__PURE__ */React39.createElement("div", null, body.map((bodyItem, index) => {
    var _a, _b;
    return /* @__PURE__ */React39.createElement(EGDSText16, {
      key: `body-${index}`,
      spacing: "one",
      size: 300
    }, (_b = (_a = bodyItem.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.text);
  })), links && /* @__PURE__ */React39.createElement(EGDSSpacing8, {
    margin: {
      blockstart: "two"
    }
  }, /* @__PURE__ */React39.createElement(EGDSText16, {
    spacing: "three",
    size: 300
  }, /* @__PURE__ */React39.createElement(EGDSLayoutFlex9, {
    direction: "row",
    tag: "section"
  }, links.map((linkItem, index) => {
    var _a, _b;
    return /* @__PURE__ */React39.createElement(EGDSLayoutFlexItem9, {
      key: index
    }, /* @__PURE__ */React39.createElement(EGDSSpacing8, {
      key: `link-${index}`,
      margin: {
        inlineend: "twelve"
      }
    }, /* @__PURE__ */React39.createElement("div", null, /* @__PURE__ */React39.createElement(EGDSLink8, null, /* @__PURE__ */React39.createElement("a", {
      "aria-label": linkItem.text,
      href: (_a = linkItem.uri) == null ? void 0 : _a.value,
      target: "_blank",
      rel: "noopener",
      onClick: handleClick(linkItem.actions)
    }, linkItem.text, ((_b = linkItem.icon) == null ? void 0 : _b.description) && /* @__PURE__ */React39.createElement("span", {
      className: "is-visually-hidden"
    }, " ", linkItem.icon.description))))));
  })))))));
};

// src/components/generic-notification/generic-notification-with-icon.tsx
import React40 from "react";
import { EGDSCard as EGDSCard6 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon6 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex10, EGDSLayoutFlexItem as EGDSLayoutFlexItem10 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink9 } from "@egds/react-core/link";
import { EGDSList as EGDSList3, EGDSListItem as EGDSListItem3 } from "@egds/react-core/list";
import { EGDSMark as EGDSMark4 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing9 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading6, EGDSText as EGDSText17 } from "@egds/react-core/text";

// src/components/helpers/icon-spotlight-mapper.ts
var SPOTLIGHT_MAP = {
  ["INFO" /* INFO */]: "info",
  ["POSITIVE" /* POSITIVE */]: "positive",
  ["STANDARD" /* STANDARD */]: "standard",
  ["WARNING" /* WARNING */]: "warning"
};

// src/components/generic-notification/generic-notification-with-icon.tsx
var GenericNotificationWithIcon = props => {
  var _a;
  const {
    heading,
    body,
    links,
    icon,
    revealActions,
    logo
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React40.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const handleClick = React40.useCallback(actions => () => {
    customerNotificationActionsExecutor(actions);
  }, [customerNotificationActionsExecutor]);
  return /* @__PURE__ */React40.createElement(EGDSCard6, {
    padded: true,
    border: true
  }, /* @__PURE__ */React40.createElement(EGDSLayoutFlex10, {
    alignItems: "center",
    space: "three"
  }, /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React40.createElement("div", null, (icon == null ? void 0 : icon.id) ? /* @__PURE__ */React40.createElement(EGDSIcon6, {
    id: icon.description || icon.title ? `generic-notification-icon-${icon.id}` : void 0,
    name: icon.id,
    spotlight: {
      theme: icon.spotLight ? SPOTLIGHT_MAP[icon.spotLight] : void 0,
      background: icon.withBackground ? icon.withBackground : void 0
    },
    description: "",
    title: (_a = icon.title) != null ? _a : void 0
  }) : (logo == null ? void 0 : logo.url) && /* @__PURE__ */React40.createElement(EGDSMark4, {
    url: logo.url,
    description: logo.description,
    size: 12
  }))), /* @__PURE__ */React40.createElement(EGDSLayoutFlexItem10, null, /* @__PURE__ */React40.createElement("div", null, heading && /* @__PURE__ */React40.createElement(EGDSHeading6, {
    size: 7,
    tag: "h2"
  }, heading), body && /* @__PURE__ */React40.createElement(EGDSSpacing9, {
    margin: {
      blockstart: "half"
    }
  }, body.map((bodyItem, index) => {
    var _a2, _b;
    return /* @__PURE__ */React40.createElement(EGDSText17, {
      key: `body-text-${index}`
    }, (_b = (_a2 = bodyItem.items) == null ? void 0 : _a2[0]) == null ? void 0 : _b.text);
  })), links && /* @__PURE__ */React40.createElement(EGDSList3, {
    bullet: "no-bullet",
    orientation: "inline",
    size: 2,
    spacing: true,
    type: "unordered"
  }, /* @__PURE__ */React40.createElement(EGDSListItem3, null, links.map((linkItem, index) => {
    var _a2;
    return /* @__PURE__ */React40.createElement(EGDSLink9, {
      key: `link-text-${index}`
    }, /* @__PURE__ */React40.createElement("a", {
      href: (_a2 = linkItem.uri) == null ? void 0 : _a2.value,
      "aria-label": linkItem.text,
      onClick: handleClick(linkItem.actions)
    }, linkItem.text));
  })))))));
};

// src/components/generic-notification/generic-notification-wrapper.tsx
var GenericNotificationWrapper = props => {
  var _a, _b, _c, _d;
  const {
    data
  } = props;
  const {
    title,
    body,
    links,
    revealActions,
    icon,
    logo
  } = data || {};
  return icon || logo ? /* @__PURE__ */React41.createElement(GenericNotificationWithIcon, {
    heading: (_b = (_a = title == null ? void 0 : title.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.text,
    body,
    links,
    icon,
    logo,
    revealActions
  }) : /* @__PURE__ */React41.createElement(GenericNotification, {
    heading: (_d = (_c = title == null ? void 0 : title.items) == null ? void 0 : _c[0]) == null ? void 0 : _d.text,
    body,
    links,
    revealActions
  });
};

// src/components/header-banner/header-banner-wrapper.tsx
import React43 from "react";

// src/components/header-banner/header-banner.tsx
import React42 from "react";
import { EGDSButtonSize as EGDSButtonSize7, EGDSOverlayButton as EGDSOverlayButton3 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon7, EGDSIconSize as EGDSIconSize5 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex11, EGDSLayoutFlexItem as EGDSLayoutFlexItem11 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing10 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText18 } from "@egds/react-core/text";
import { EGDSViewRow as EGDSViewRow4 } from "@egds/react-core/view";
import { useApolloClient as useApolloClient4 } from "@shared-ui/apollo-client-wrapper";
var HeaderBanner = ({
  type,
  notificationLocation,
  title,
  revealActions,
  logo,
  containerLink,
  dismiss,
  referrer,
  body
}) => {
  var _a, _b;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const [display, setDisplay] = React42.useState(true);
  const {
    cache
  } = useApolloClient4();
  React42.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  if (!display) {
    return null;
  }
  const bannerLink = createDeepLinkUrl((_a = containerLink == null ? void 0 : containerLink.uri) == null ? void 0 : _a.value, referrer);
  const onClickDismiss = () => {
    setDisplay(false);
    customerNotificationActionsExecutor(dismiss == null ? void 0 : dismiss.actions);
    cacheEviction(cache, type, notificationLocation);
  };
  const onCardClick = () => {
    customerNotificationActionsExecutor(containerLink == null ? void 0 : containerLink.actions);
  };
  return /* @__PURE__ */React42.createElement(EGDSViewRow4, {
    canvasTheme: "brand_promo_primary",
    layout: "centered"
  }, /* @__PURE__ */React42.createElement(EGDSLayoutFlex11, {
    direction: "row",
    alignItems: "center",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React42.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center"
  }, /* @__PURE__ */React42.createElement("section", null, /* @__PURE__ */React42.createElement("a", {
    href: bannerLink,
    onClick: onCardClick,
    onKeyDown: onCardClick
  }, /* @__PURE__ */React42.createElement(EGDSSpacing10, {
    padding: {
      block: "three"
    }
  }, /* @__PURE__ */React42.createElement(EGDSLayoutFlex11, {
    direction: "row",
    alignItems: "center",
    justifyContent: "space-between"
  }, /* @__PURE__ */React42.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center",
    grow: 0,
    shrink: 1
  }, /* @__PURE__ */React42.createElement("img", {
    alt: logo.description,
    src: logo.url,
    width: "48",
    height: "48"
  })), /* @__PURE__ */React42.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center",
    grow: 1,
    shrink: 1
  }, /* @__PURE__ */React42.createElement(EGDSLayoutFlex11, {
    direction: "column",
    alignItems: "start",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, title && /* @__PURE__ */React42.createElement(EGDSSpacing10, {
    padding: {
      inlinestart: "three"
    }
  }, (_b = title.items) == null ? void 0 : _b.map(({
    text
  }, index) => /* @__PURE__ */React42.createElement(EGDSText18, {
    key: `text-element-${index}`,
    theme: "inverse",
    align: "left",
    size: 300,
    weight: "medium"
  }, text))), body && /* @__PURE__ */React42.createElement(EGDSSpacing10, {
    padding: {
      inlinestart: "three"
    }
  }, body.map((bodyItem, index) => {
    var _a2;
    return (_a2 = bodyItem.items) == null ? void 0 : _a2.map(({
      text
    }, textIndex) => /* @__PURE__ */React42.createElement(EGDSText18, {
      key: `body-${index}.item-${textIndex}`,
      theme: "inverse",
      align: "left",
      size: 300
    }, text));
  }))))))))), /* @__PURE__ */React42.createElement(EGDSLayoutFlexItem11, {
    alignSelf: "center"
  }, /* @__PURE__ */React42.createElement(EGDSOverlayButton3, {
    onClick: onClickDismiss,
    name: "close",
    "aria-label": "close",
    size: EGDSButtonSize7.SMALL
  }, /* @__PURE__ */React42.createElement(EGDSIcon7, {
    name: "close",
    size: EGDSIconSize5.SMALL
  })))));
};
HeaderBanner.displayName = "sharedui-HeaderBanner";

// src/components/header-banner/header-banner-wrapper.tsx
var HeaderBannerWrapper = ({
  data,
  inputs
}) => {
  const {
    type,
    notificationLocation,
    title,
    logo,
    dismiss,
    revealActions,
    containerLink,
    body
  } = data || {};
  const {
    optionalContext
  } = inputs;
  if (!logo || !dismiss) {
    return null;
  }
  return /* @__PURE__ */React43.createElement(HeaderBanner, {
    type,
    notificationLocation,
    title,
    logo,
    containerLink,
    revealActions,
    dismiss,
    referrer: optionalContext == null ? void 0 : optionalContext.referer,
    body
  });
};

// src/components/mad-marquee/mad-marquee-form-section-wrapper.tsx
import React50 from "react";

// src/components/mad-marquee/mad-marquee-form-section.tsx
import React49 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex12, EGDSLayoutFlexItem as EGDSLayoutFlexItem12 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing11 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading7 } from "@egds/react-core/text";

// src/components/mad-marquee/form-field/selection-field.tsx
import React45 from "react";
import { EGDSSelect } from "@egds/react-core/input";

// src/components/mad-marquee/context.tsx
import React44, { useMemo as useMemo2 } from "react";
var initialFormState = {
  countryCode: "",
  phoneNumber: "",
  phoneNumberErrMsg: "",
  hasInvalidFields: false
};
var FormContext = React44.createContext({
  state: initialFormState
});
var reducer = (state, {
  field,
  value
}) => __spreadProps(__spreadValues({}, state), {
  [field]: value
});
var FormProvider = props => {
  const {
    children,
    defaultSelectedOptionVal
  } = props;
  const formState = __spreadProps(__spreadValues({}, initialFormState), {
    countryCode: defaultSelectedOptionVal
  });
  const [state, dispatch] = React44.useReducer(reducer, formState);
  return /* @__PURE__ */React44.createElement(FormContext.Provider, {
    value: useMemo2(() => ({
      state,
      dispatch
    }), [state, dispatch])
  }, children);
};

// src/components/mad-marquee/form-field/selection-field.tsx
var CustomerNotificationSelectionField = props => {
  const {
    data
  } = props;
  const {
    label,
    id,
    options
  } = data;
  const {
    state,
    dispatch
  } = React45.useContext(FormContext);
  if (!options || !options.length) {
    return null;
  }
  return /* @__PURE__ */React45.createElement(EGDSSelect, {
    id,
    name: id,
    label,
    value: state.countryCode,
    onChange: event => dispatch({
      field: event.target.name,
      value: event.target.value
    })
  }, options.map(option => /* @__PURE__ */React45.createElement("option", {
    key: option.id,
    value: option.value
  }, option.id === state.countryCode ? option.shortLabel : option.text)));
};
CustomerNotificationSelectionField.displayName = "sharedui-CustomerNotificationSelectionField";

// src/components/mad-marquee/form-field/text-input-field.tsx
import React46 from "react";
import { EGDSTextInput } from "@egds/react-core/input";
var CustomerNotificationTextInputField = props => {
  const {
    data
  } = props;
  const {
    label,
    id
  } = data;
  const {
    state,
    dispatch
  } = React46.useContext(FormContext);
  const inputRef = React46.useRef();
  React46.useEffect(() => {
    if (state.hasInvalidFields && (inputRef == null ? void 0 : inputRef.current) && typeof (inputRef == null ? void 0 : inputRef.current.focus) === "function") {
      inputRef == null ? void 0 : inputRef.current.focus();
    }
  }, [inputRef, state.hasInvalidFields]);
  return /* @__PURE__ */React46.createElement(EGDSTextInput, {
    id,
    name: id,
    label,
    value: state.phoneNumber,
    invalid: state.phoneNumberErrMsg,
    onChange: event => dispatch({
      field: event.target.name,
      value: event.target.value
    }),
    domRef: inputRef
  });
};
CustomerNotificationTextInputField.displayName = "sharedui-CustomerNotificationTextInputField";

// src/components/mad-marquee/form-field/submit-button.tsx
import React47 from "react";
import { EGDSButtonSize as EGDSButtonSize8 } from "@egds/react-core/button";

// src/components/mad-marquee/mad-marquee-button-dictionary.ts
import { EGDSPrimaryButton as EGDSPrimaryButton4, EGDSSecondaryButton as EGDSSecondaryButton3 } from "@egds/react-core/button";
var BUTTON_DICTIONARY2 = {
  ["PRIMARY_BUTTON" /* PRIMARY_BUTTON */]: EGDSPrimaryButton4,
  ["SECONDARY_BUTTON" /* SECONDARY_BUTTON */]: EGDSSecondaryButton3
};
var getButtonComponent3 = buttonType => BUTTON_DICTIONARY2[`${buttonType}`] || EGDSPrimaryButton4;

// src/components/mad-marquee/form-field/submit-button.tsx
var CustomerNotificationSubmitButton = props => {
  const {
    data
  } = props;
  const {
    id,
    label,
    buttonType
  } = data;
  const ButtonComponent = getButtonComponent3(buttonType);
  return /* @__PURE__ */React47.createElement(ButtonComponent, {
    id,
    name: id,
    type: "submit",
    size: EGDSButtonSize8.LARGE,
    isFullWidth: true
  }, label);
};
CustomerNotificationSubmitButton.displayName = "sharedui-CustomerNotificationSubmitButton";

// src/components/mad-marquee/mad-marquee-form-fields-dictionary.ts
var FORM_FIELDS_DICTIONARY = {
  NotificationTextInputField: CustomerNotificationTextInputField,
  NotificationSubmitButton: CustomerNotificationSubmitButton,
  NotificationSelectionField: CustomerNotificationSelectionField
};

// src/components/mad-marquee/marquee-context.tsx
import React48 from "react";
var initialMarqueeState = {
  rootElements: {
    heading: false,
    body: false,
    qrCode: false,
    formSections: false,
    qrCodeTitle: false,
    backgroundImageUrl: false
  }
};
var MarqueeContext = React48.createContext(initialMarqueeState);
var MarqueeProvider = props => {
  var _a, _b, _c;
  const {
    children,
    data
  } = props;
  const {
    title,
    body,
    customQrCode,
    form,
    backgroundImage
  } = data;
  const heading = (_a = title == null ? void 0 : title.items[0]) == null ? void 0 : _a.text;
  const qrCode = ((_b = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _b.url) && ((_c = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _c.description);
  const formSections = form == null ? void 0 : form.sections;
  const qrCodeTitle = customQrCode == null ? void 0 : customQrCode.title;
  const backgroundImageUrl = backgroundImage == null ? void 0 : backgroundImage.url;
  const marqueeState = {
    rootElements: {
      heading: !!heading,
      body: !!body,
      qrCode: !!qrCode,
      formSections: !!formSections,
      qrCodeTitle: !!qrCodeTitle,
      backgroundImageUrl: !!backgroundImageUrl
    }
  };
  return /* @__PURE__ */React48.createElement(MarqueeContext.Provider, {
    value: marqueeState
  }, children);
};
var useMarqueeContext = () => {
  return React48.useContext(MarqueeContext);
};

// src/components/mad-marquee/mad-marquee-form-section.tsx
var MadMarqueeFormSection = props => {
  const {
    title,
    fields,
    formTitle
  } = props;
  const {
    rootElements
  } = useMarqueeContext();
  const titlePadding = !rootElements.body && !rootElements.heading ? "unset" : "six";
  return /* @__PURE__ */React49.createElement(React49.Fragment, null, title && /* @__PURE__ */React49.createElement(EGDSSpacing11, {
    padding: {
      blockstart: titlePadding,
      blockend: "three"
    }
  }, /* @__PURE__ */React49.createElement("div", null, /* @__PURE__ */React49.createElement(EGDSHeading7, {
    tag: "h3",
    size: 5
  }, title))), formTitle && /* @__PURE__ */React49.createElement("span", {
    className: "is-visually-hidden"
  }, formTitle), /* @__PURE__ */React49.createElement(EGDSSpacing11, {
    padding: {
      blockstart: "unset"
    }
  }, /* @__PURE__ */React49.createElement(EGDSLayoutFlex12, {
    space: "four",
    wrap: "wrap"
  }, fields.map((field, index) => {
    const FormFieldComponent = FORM_FIELDS_DICTIONARY[field.__typename];
    return /* @__PURE__ */React49.createElement(EGDSLayoutFlexItem12, {
      key: index,
      grow: 2,
      minWidth: "twenty_four"
    }, /* @__PURE__ */React49.createElement("div", null, /* @__PURE__ */React49.createElement(FormFieldComponent, {
      data: field
    })));
  }))));
};
MadMarqueeFormSection.displayName = "MadMarqueeFormSection";

// src/components/mad-marquee/mad-marquee-form-section-wrapper.tsx
var MadMarqueeFormSectionWrapper = ({
  data,
  formTitle
}) => {
  const {
    title,
    fields
  } = data;
  if (!fields || !fields.length) {
    return null;
  }
  return /* @__PURE__ */React50.createElement(MadMarqueeFormSection, {
    title,
    fields,
    formTitle
  });
};

// src/components/mad-marquee/mad-marquee-wrapper.tsx
import React60 from "react";

// src/components/mad-marquee/custom-inpage-marquee.tsx
import React55 from "react";
import { EGDSCard as EGDSCard7, EGDSCardContentSection as EGDSCardContentSection5 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure4, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType3, EGDSImage as EGDSImage4 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex13, EGDSLayoutFlexItem as EGDSLayoutFlexItem13 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid6, EGDSLayoutGridItem as EGDSLayoutGridItem5 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing14 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading8 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium4, Viewport as Viewport5, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";

// src/components/mad-marquee/mad-marquee-sub-section.tsx
import React51 from "react";
import { EGDSList as EGDSList4, EGDSListItem as EGDSListItem4 } from "@egds/react-core/list";
import { EGDSSpacing as EGDSSpacing12 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText19 } from "@egds/react-core/text";
var MadMarqueeSubSection = props => {
  var _a, _b, _c;
  const {
    body,
    isMobile
  } = props;
  const {
    rootElements
  } = useMarqueeContext();
  const {
    formSections,
    qrCode,
    qrCodeTitle
  } = rootElements;
  const isPromoMarquee = !formSections && qrCode && qrCodeTitle;
  const spacingProps = isMobile ? {
    padding: {
      blockstart: "one",
      blockend: "two"
    }
  } : {
    padding: {
      blockstart: "two",
      inlineend: "four"
    }
  };
  return /* @__PURE__ */React51.createElement(React51.Fragment, null, isPromoMarquee && /* @__PURE__ */React51.createElement(EGDSSpacing12, {
    padding: {
      blockstart: "six",
      inlineend: "four",
      blockend: "six"
    }
  }, /* @__PURE__ */React51.createElement(EGDSList4, {
    spacing: false
  }, body.map((bodyItem, index) => {
    var _a2;
    const item = (_a2 = bodyItem.items) == null ? void 0 : _a2[0];
    return /* @__PURE__ */React51.createElement(EGDSText19, {
      key: index,
      weight: (item == null ? void 0 : item.styles[0]) === "IMPORTANT" /* IMPORTANT */ ? "bold" : "regular",
      size: (item == null ? void 0 : item.styles[0]) === "IMPORTANT" /* IMPORTANT */ ? 500 : 400
    }, item == null ? void 0 : item.text);
  }))), body.length > 1 && !isPromoMarquee && /* @__PURE__ */React51.createElement(EGDSSpacing12, {
    padding: {
      blockstart: "three",
      inlineend: "four"
    }
  }, /* @__PURE__ */React51.createElement(EGDSList4, {
    spacing: false
  }, body.map((bodyItem, index) => {
    var _a2, _b2;
    return /* @__PURE__ */React51.createElement(EGDSListItem4, {
      key: index
    }, (_b2 = (_a2 = bodyItem.items) == null ? void 0 : _a2[0]) == null ? void 0 : _b2.text);
  }))), body.length === 1 && !isPromoMarquee && /* @__PURE__ */React51.createElement(EGDSSpacing12, {
    padding: spacingProps.padding
  }, /* @__PURE__ */React51.createElement(EGDSText19, {
    className: "uitk-type-paragraph-300"
  }, (_c = (_b = (_a = body[0]) == null ? void 0 : _a.items) == null ? void 0 : _b[0]) == null ? void 0 : _c.text)));
};
MadMarqueeSubSection.displayName = "MadMarqueeSubSection";

// src/components/mad-marquee/marquee-button-link-component.tsx
import React52 from "react";
import { EGDSButtonSize as EGDSButtonSize9 } from "@egds/react-core/button";
var MarqueeButtonLinkComponent = ({
  appDownloadLink,
  tuneLink,
  onClickButton
}) => {
  const ButtonComponent = getButtonComponent3(tuneLink.type);
  return /* @__PURE__ */React52.createElement(ButtonComponent, {
    id: "download-btn",
    name: "download-btn",
    href: appDownloadLink,
    onClick: onClickButton,
    size: EGDSButtonSize9.LARGE,
    isFullWidth: true
  }, tuneLink.text);
};

// src/components/mad-marquee/marquee-secondary-link-component.tsx
import React53 from "react";
import { EGDSLink as EGDSLink10 } from "@egds/react-core/link";
var MarqueeSecondaryLinkComponent = ({
  onSecondaryClickButton,
  secondaryLink,
  secondLink
}) => /* @__PURE__ */React53.createElement(EGDSLink10, {
  noWrap: true,
  inline: true,
  onClick: onSecondaryClickButton
}, /* @__PURE__ */React53.createElement("a", {
  "aria-label": secondLink == null ? void 0 : secondLink.text,
  href: secondaryLink,
  target: "_blank",
  rel: "noopener"
}, secondLink == null ? void 0 : secondLink.text));

// src/components/mad-marquee/marquee-sub-body-component.tsx
import React54 from "react";
import { EGDSSpacing as EGDSSpacing13 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText20 } from "@egds/react-core/text";
var MarqueeSubBodyComponent = ({
  subBody
}) => {
  var _a;
  if (!((_a = subBody == null ? void 0 : subBody[0]) == null ? void 0 : _a.title.egdsItems.length)) {
    return null;
  }
  const titleItem = subBody[0].title.egdsItems[0];
  const titleText = titleItem && "text" in titleItem && titleItem.text;
  const titleWeight = titleItem && "weight" in titleItem && titleItem.weight || void 0;
  if (!titleText || !titleWeight) {
    return null;
  }
  return /* @__PURE__ */React54.createElement(EGDSSpacing13, {
    padding: {
      blockstart: "twelve",
      inlineend: "four",
      blockend: "two"
    }
  }, /* @__PURE__ */React54.createElement(EGDSText20, {
    weight: titleWeight && EGDSTextWeightMap[titleWeight],
    size: 400
  }, titleText));
};

// src/components/mad-marquee/custom-inpage-marquee.tsx
var CustomInpageMarquee = props => {
  var _a, _b;
  const {
    backgroundImageUrl,
    backgroundImageDescription,
    heading,
    body,
    subBody,
    qrCodeUrl,
    qrCodeDesc,
    qrCodeTitle,
    tuneLink,
    secondLink,
    revealActions,
    referer
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React55.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const onClickButton = () => {
    customerNotificationActionsExecutor(tuneLink.actions);
  };
  const onSecondaryClickButton = () => {
    customerNotificationActionsExecutor(secondLink == null ? void 0 : secondLink.actions);
  };
  let regionColumns = 4;
  let placementId = "app_72";
  let isSlim = false;
  let isPromoMarquee = false;
  if (qrCodeUrl && qrCodeDesc) {
    placementId = "app_71";
    regionColumns = 3;
    if (body && qrCodeTitle) {
      regionColumns = 5;
      isSlim = true;
      isPromoMarquee = true;
    }
  }
  const appDownloadLink = createDeepLinkUrl((_a = tuneLink.uri) == null ? void 0 : _a.value, referer);
  const secondaryLink = createDeepLinkUrl((_b = secondLink == null ? void 0 : secondLink.uri) == null ? void 0 : _b.value, referer);
  return /* @__PURE__ */React55.createElement(Viewport5, null, /* @__PURE__ */React55.createElement(ViewLarge2, null, /* @__PURE__ */React55.createElement(EGDSCard7, {
    border: true
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGrid6, {
    columns: 3
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    colSpan: 3
  }, /* @__PURE__ */React55.createElement(EGDSCardContentSection5, {
    padded: false
  }, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: "six"
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGrid6, {
    columns: isSlim ? 7 : 4,
    space: "half"
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    alignSelf: "start",
    colSpan: regionColumns
  }, /* @__PURE__ */React55.createElement("div", {
    role: "region",
    "aria-labelledby": "marquee-title"
  }, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      blockend: isSlim ? "six" : "one"
    }
  }, heading && /* @__PURE__ */React55.createElement(EGDSHeading8, {
    tag: "h2",
    size: 3,
    id: "marquee-title"
  }, heading)), body && /* @__PURE__ */React55.createElement(MadMarqueeSubSection, {
    body
  }), subBody && /* @__PURE__ */React55.createElement(MarqueeSubBodyComponent, {
    subBody
  }))), qrCodeUrl && qrCodeDesc && /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    colSpan: isPromoMarquee ? 2 : 1
  }, /* @__PURE__ */React55.createElement("div", null, qrCodeTitle && /* @__PURE__ */React55.createElement("div", {
    role: "definition",
    "aria-labelledby": "qrCodeTitle"
  }, /* @__PURE__ */React55.createElement("input", {
    type: "hidden",
    id: "qrCodeTitle",
    "aria-label": qrCodeTitle
  })), /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      blockstart: isPromoMarquee ? "unset" : "four"
    }
  }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(EGDSFigure4, {
    ratio: EGDSFigureAspectRatioType3.R1_1
  }, /* @__PURE__ */React55.createElement(EGDSImage4, {
    src: qrCodeUrl,
    alt: qrCodeDesc
  })))), qrCodeTitle && /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      inlinestart: "four"
    }
  }, /* @__PURE__ */React55.createElement(EGDSHeading8, {
    tag: "h3",
    align: "center",
    size: 7,
    "aria-hidden": "true"
  }, qrCodeTitle))))))))))), /* @__PURE__ */React55.createElement(ViewMedium4, null, /* @__PURE__ */React55.createElement(EGDSCard7, {
    border: true
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGrid6, {
    columns: 3
  }, /* @__PURE__ */React55.createElement(React55.Fragment, null, backgroundImageUrl && /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    colSpan: 1
  }, /* @__PURE__ */React55.createElement(EGDSFigure4, {
    ratio: EGDSFigureAspectRatioType3.R16_9
  }, /* @__PURE__ */React55.createElement(EGDSImage4, {
    placeholderImage: true,
    src: backgroundImageUrl,
    alt: backgroundImageDescription
  }))), /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    colSpan: backgroundImageUrl ? 2 : 3
  }, /* @__PURE__ */React55.createElement(EGDSCardContentSection5, {
    padded: false
  }, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: "six"
  }, /* @__PURE__ */React55.createElement("div", {
    role: "region",
    "aria-labelledby": "marquee-title"
  }, /* @__PURE__ */React55.createElement(EGDSHeading8, {
    tag: "h2",
    size: 3,
    id: "marquee-title"
  }, heading), body && /* @__PURE__ */React55.createElement(MadMarqueeSubSection, {
    body
  }), /* @__PURE__ */React55.createElement(EGDSLayoutGrid6, {
    space: "six",
    columns: secondLink ? 8 : 6
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    colSpan: isSlim ? 8 : 4
  }, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      blockstart: isSlim ? "unset" : "six"
    }
  }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(MarqueeButtonLinkComponent, {
    appDownloadLink,
    tuneLink,
    onClickButton
  })))), secondLink && /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    alignSelf: "center",
    colSpan: 1
  }, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(MarqueeSecondaryLinkComponent, {
    secondaryLink,
    onSecondaryClickButton,
    secondLink
  }))))))))))))), /* @__PURE__ */React55.createElement(ViewSmall5, null, /* @__PURE__ */React55.createElement(EGDSCard7, {
    border: true
  }, backgroundImageUrl && /* @__PURE__ */React55.createElement(EGDSFigure4, {
    className: "all-image-fit-cover",
    ratio: EGDSFigureAspectRatioType3.R21_9
  }, /* @__PURE__ */React55.createElement(EGDSImage4, {
    placeholderImage: true,
    src: backgroundImageUrl,
    alt: backgroundImageDescription
  })), /* @__PURE__ */React55.createElement(EGDSCardContentSection5, {
    padded: false
  }, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: "six"
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGrid6, {
    columns: 4
  }, /* @__PURE__ */React55.createElement(EGDSLayoutGridItem5, {
    colSpan: 4
  }, /* @__PURE__ */React55.createElement("div", {
    role: "region",
    "aria-labelledby": "marquee-title"
  }, /* @__PURE__ */React55.createElement(EGDSHeading8, {
    tag: "h2",
    size: 5,
    id: "marquee-title"
  }, heading), body && /* @__PURE__ */React55.createElement(MadMarqueeSubSection, {
    body,
    isMobile: true
  }), /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      blockstart: isSlim ? "unset" : "four"
    }
  }, /* @__PURE__ */React55.createElement(EGDSLayoutFlex13, {
    space: "four",
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React55.createElement(React55.Fragment, null, /* @__PURE__ */React55.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */React55.createElement(MarqueeButtonLinkComponent, {
    appDownloadLink,
    tuneLink,
    onClickButton
  })), secondLink && /* @__PURE__ */React55.createElement(EGDSLayoutFlexItem13, null, /* @__PURE__ */React55.createElement(EGDSSpacing14, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React55.createElement("div", null, /* @__PURE__ */React55.createElement(MarqueeSecondaryLinkComponent, {
    secondaryLink,
    onSecondaryClickButton,
    secondLink
  })))))))))))))));
};
CustomInpageMarquee.displayName = "CustomInpageMarquee";

// src/components/mad-marquee/mad-marquee.tsx
import React59 from "react";
import { EGDSCard as EGDSCard8, EGDSCardContentSection as EGDSCardContentSection6 } from "@egds/react-core/cards";
import { EGDSFigure as EGDSFigure5, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType4, EGDSImage as EGDSImage5 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex14, EGDSLayoutFlexItem as EGDSLayoutFlexItem14 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid7, EGDSLayoutGridItem as EGDSLayoutGridItem6 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing17 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading9 } from "@egds/react-core/text";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium5, Viewport as Viewport6, ViewSmall as ViewSmall6 } from "@shared-ui/viewport-context";

// src/components/mad-marquee/mad-marquee-form-wrapper.tsx
import React57 from "react";

// src/components/mad-marquee/mad-marquee-form.tsx
import React56 from "react";
import { EGDSLoader } from "@egds/react-core/loader";
import { EGDSSpacing as EGDSSpacing15 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText21 } from "@egds/react-core/text";
import { Level, liveAnnounce } from "@egds/react-core/utils";
import { useMutation } from "@shared-ui/apollo-client-wrapper";
import { useBexApi } from "@shared-ui/bex-api-context";

// src/components/mad-marquee/mutation/send-text-to-download-app-mutation.tsx
import { gql as gql14 } from "@shared-ui/apollo-client-wrapper";
var SendTextToDownloadAppMutation = gql14`
  mutation SendTextToDownloadAppMutation($context: ContextInput!, $placementId: String!, $customerInput: NotificationUserInput!) {
    sendTextToDownloadApp(context: $context, placementId: $placementId, customerInput: $customerInput) {
      messageType
      messageBody
      invalidFields
    }
  }
`;

// src/components/mad-marquee/mad-marquee-form.tsx
var MadMarqueeForm = props => {
  var _a, _b, _c, _d, _e, _f, _g;
  const {
    formTitle,
    formSections,
    formMessages,
    placementId,
    successFormAnalytics,
    errorFormAnalytics
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const submitBtn = (_b = (_a = formSections[0]) == null ? void 0 : _a.fields) == null ? void 0 : _b.find(field => field.__typename === "NotificationSubmitButton");
  const submitFormButtonAction = (_c = submitBtn == null ? void 0 : submitBtn.actions) == null ? void 0 : _c.find(action => action.__typename === "NotificationAnalytics");
  const successActions = (submitFormButtonAction == null ? void 0 : submitFormButtonAction.schema) ? submitBtn == null ? void 0 : submitBtn.actions : successFormAnalytics;
  const [textToDownloadMutation, {
    loading,
    error,
    data
  }] = useMutation(SendTextToDownloadAppMutation);
  const {
    state,
    dispatch
  } = React56.useContext(FormContext);
  const invalidNumCallBack = (field, value) => {
    dispatch({
      field,
      value
    });
  };
  const resetInvalidField = () => {
    dispatch({
      field: "hasInvalidFields",
      value: false
    });
    invalidNumCallBack("phoneNumberErrMsg", "");
  };
  const unsuccessfulAction = [];
  const invalidNumberAction = [];
  errorFormAnalytics == null ? void 0 : errorFormAnalytics.forEach(action => {
    if ((action == null ? void 0 : action.__typename) === "NotificationAnalytics") {
      if (action.description === "Invalid Phone Number omtr event") {
        invalidNumberAction == null ? void 0 : invalidNumberAction.push(action);
      } else if (action.description === "Unsuccessful text message omtr event") {
        unsuccessfulAction == null ? void 0 : unsuccessfulAction.push(action);
      }
    }
  });
  const liveAnnounceLoaderMessage = (messageLevel, messageName) => {
    formMessages == null ? void 0 : formMessages.forEach(formMessage => {
      if ((formMessage == null ? void 0 : formMessage.displayType) === "FORM") {
        if (formMessage.level === messageLevel && formMessage.name === messageName) {
          liveAnnounce(formMessage.text, Level.POLITE);
        }
      }
    });
  };
  React56.useEffect(() => {
    var _a2, _b2, _c2, _d2, _e2, _f2, _g2;
    if (!loading && !error && ((_a2 = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _a2.messageType) === "SUCCESS") {
      liveAnnounce((_b2 = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _b2.messageBody, Level.POLITE);
      customerNotificationActionsExecutor(successActions);
    }
    if (!loading && ((_c2 = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _c2.messageType) === "SERVICE_ERROR" && !((_d2 = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _d2.invalidFields) || error) {
      liveAnnounceLoaderMessage("ERROR" /* ERROR */, "service_error_msg");
      customerNotificationActionsExecutor((submitFormButtonAction == null ? void 0 : submitFormButtonAction.schema) ? submitBtn == null ? void 0 : submitBtn.actions : unsuccessfulAction);
    }
    if (!loading && !error && !state.hasInvalidFields && ((_e2 = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _e2.messageType) === "SERVICE_ERROR" && ((_g2 = (_f2 = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _f2.invalidFields) == null ? void 0 : _g2[0])) {
      dispatch({
        field: "hasInvalidFields",
        value: true
      });
      invalidNumCallBack(data.sendTextToDownloadApp.invalidFields[0], data.sendTextToDownloadApp.messageBody);
      if ((invalidNumberAction == null ? void 0 : invalidNumberAction.length) > 0) {
        customerNotificationActionsExecutor(invalidNumberAction);
      } else {
        customerNotificationActionsExecutor((submitFormButtonAction == null ? void 0 : submitFormButtonAction.schema) ? submitBtn == null ? void 0 : submitBtn.actions : unsuccessfulAction);
      }
    }
  });
  const {
    context
  } = useBexApi();
  const onFormSubmission = event => {
    if (formMessages) {
      liveAnnounceLoaderMessage("INFO" /* INFO */, "info_msg");
    }
    event.preventDefault();
    resetInvalidField();
    textToDownloadMutation({
      variables: {
        context,
        placementId,
        customerInput: {
          inputs: [{
            value: state.phoneNumber,
            type: "phoneNumber"
          }, {
            value: state.countryCode,
            type: "countryCode"
          }]
        }
      }
    });
  };
  return /* @__PURE__ */React56.createElement("form", {
    onSubmit: onFormSubmission
  }, /* @__PURE__ */React56.createElement(EGDSSpacing15, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React56.createElement("div", null, formSections.map((section, index) => /* @__PURE__ */React56.createElement(MadMarqueeFormSectionWrapper, {
    data: section,
    key: index,
    formTitle
  })))), !loading && !error && ((_d = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _d.messageType) === "SUCCESS" && !state.hasInvalidFields && /* @__PURE__ */React56.createElement(EGDSSpacing15, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React56.createElement(EGDSText21, {
    size: 300,
    theme: "positive"
  }, data.sendTextToDownloadApp.messageBody)), !loading && !error && ((_e = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _e.messageType) === "SERVICE_ERROR" && !state.hasInvalidFields && !((_f = data == null ? void 0 : data.sendTextToDownloadApp) == null ? void 0 : _f.invalidFields) && /* @__PURE__ */React56.createElement(EGDSSpacing15, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React56.createElement(EGDSText21, {
    size: 300,
    theme: "negative"
  }, data.sendTextToDownloadApp.messageBody)), error && ((_g = formMessages == null ? void 0 : formMessages[0]) == null ? void 0 : _g.text) && /* @__PURE__ */React56.createElement(EGDSSpacing15, {
    padding: {
      blockend: "three"
    }
  }, /* @__PURE__ */React56.createElement(EGDSText21, {
    size: 300,
    theme: "negative"
  }, formMessages[0].text)), loading && /* @__PURE__ */React56.createElement(EGDSLoader, {
    isSmall: true
  }), formTitle && /* @__PURE__ */React56.createElement(EGDSText21, {
    size: 200,
    "aria-hidden": true
  }, formTitle));
};
MadMarqueeForm.displayName = "MadMarqueeForm";

// src/components/mad-marquee/mad-marquee-form-wrapper.tsx
var MadMarqueeFormWrapper = props => {
  var _a, _b, _c;
  const {
    formTitle,
    formSections,
    formMessages,
    placementId,
    successFormAnalytics,
    errorFormAnalytics
  } = props;
  const selectionField = (_b = (_a = formSections == null ? void 0 : formSections[0]) == null ? void 0 : _a.fields) == null ? void 0 : _b.find(field => field.__typename === "NotificationSelectionField");
  const defaultSelectedOption = (_c = selectionField == null ? void 0 : selectionField.options) == null ? void 0 : _c.find(option => option.selected === true);
  return /* @__PURE__ */React57.createElement(FormProvider, {
    defaultSelectedOptionVal: (defaultSelectedOption == null ? void 0 : defaultSelectedOption.value) || ""
  }, /* @__PURE__ */React57.createElement(MadMarqueeForm, {
    formTitle,
    formSections,
    formMessages,
    placementId,
    successFormAnalytics,
    errorFormAnalytics
  }));
};
MadMarqueeFormWrapper.displayName = "MadMarqueeFormWrapper";

// src/components/mad-marquee/marquee-legal-text-and-link-component.tsx
import React58 from "react";
import { EGDSLink as EGDSLink11 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing16 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText22 } from "@egds/react-core/text";
var MarqueeLegalTextAndLinkComponent = ({
  legalText
}) => {
  var _a;
  return /* @__PURE__ */React58.createElement(React58.Fragment, null, (_a = legalText == null ? void 0 : legalText.items) == null ? void 0 : _a.map((item, index) => /* @__PURE__ */React58.createElement("div", {
    key: `text-element-container-${index}`
  }, /* @__PURE__ */React58.createElement(EGDSSpacing16, {
    padding: {
      blockstart: "four"
    }
  }, (item == null ? void 0 : item.__typename) === "NotificationPhraseLinkNode" && (item == null ? void 0 : item.uri) && item.uri.value ? /* @__PURE__ */React58.createElement("div", null, /* @__PURE__ */React58.createElement(EGDSLink11, {
    inline: true
  }, /* @__PURE__ */React58.createElement("a", {
    href: item.uri.value,
    key: `text-element-${index}`,
    target: "_blank",
    rel: "noopener"
  }, item.text))) : /* @__PURE__ */React58.createElement("div", null, /* @__PURE__ */React58.createElement(EGDSText22, {
    size: 300
  }, " ", item.text, " "))))));
};

// src/components/mad-marquee/mad-marquee.tsx
var MadMarquee = props => {
  var _a, _b, _c, _d;
  const {
    backgroundImageUrl,
    backgroundImageDescription,
    heading,
    body,
    subBody,
    formTitle,
    formSections,
    formMessages,
    successFormAnalytics,
    errorFormAnalytics,
    customQRCode,
    tuneLink,
    secondLink,
    revealActions,
    referer,
    legalText
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React59.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const onClickButton = () => {
    customerNotificationActionsExecutor(tuneLink.actions);
  };
  const onSecondaryClickButton = () => {
    customerNotificationActionsExecutor(secondLink == null ? void 0 : secondLink.actions);
  };
  const isLayoutOnRight = backgroundImageDescription === "RIGHT_FULLBLEED_ONE_HALF";
  let regionColumns = 4;
  let placementId = "app_72";
  let isSlim = false;
  let isPromoMarquee = false;
  if (((_a = customQRCode == null ? void 0 : customQRCode.image) == null ? void 0 : _a.url) && ((_b = customQRCode == null ? void 0 : customQRCode.image) == null ? void 0 : _b.description) || (customQRCode == null ? void 0 : customQRCode.encodedImage)) {
    placementId = "app_71";
    regionColumns = 3;
    if (!backgroundImageUrl && !heading && !body) {
      regionColumns = 5;
      isSlim = true;
    }
    if (body && !formSections && customQRCode.title) {
      regionColumns = 5;
      isSlim = true;
      isPromoMarquee = true;
    }
  }
  const appDownloadLink = createDeepLinkUrl((_c = tuneLink.uri) == null ? void 0 : _c.value, referer);
  const secondaryLink = createDeepLinkUrl((_d = secondLink == null ? void 0 : secondLink.uri) == null ? void 0 : _d.value, referer);
  return /* @__PURE__ */React59.createElement(Viewport6, null, /* @__PURE__ */React59.createElement(ViewLarge3, null, /* @__PURE__ */React59.createElement(EGDSCard8, {
    border: true
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGrid7, {
    columns: 3
  }, /* @__PURE__ */React59.createElement(React59.Fragment, null, backgroundImageUrl && !isLayoutOnRight && /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: 1
  }, /* @__PURE__ */React59.createElement(EGDSFigure5, {
    ratio: EGDSFigureAspectRatioType4.R3_2
  }, /* @__PURE__ */React59.createElement(EGDSImage5, {
    placeholderImage: true,
    src: backgroundImageUrl,
    alt: backgroundImageDescription
  }))), /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: backgroundImageUrl ? 2 : 3
  }, /* @__PURE__ */React59.createElement(EGDSCardContentSection6, {
    padded: false
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: "six"
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGrid7, {
    columns: isSlim ? 6 : 4,
    space: "six"
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    alignSelf: isPromoMarquee ? "center" : "start",
    colSpan: regionColumns
  }, /* @__PURE__ */React59.createElement("div", {
    role: "region",
    "aria-labelledby": "marquee-title"
  }, heading && /* @__PURE__ */React59.createElement(EGDSHeading9, {
    tag: "h2",
    size: 3,
    id: "marquee-title"
  }, heading), body && /* @__PURE__ */React59.createElement(MadMarqueeSubSection, {
    body
  }), subBody && /* @__PURE__ */React59.createElement(MarqueeSubBodyComponent, {
    subBody
  }), secondLink && /* @__PURE__ */React59.createElement(EGDSLayoutGrid7, {
    space: "six",
    columns: 6
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: 3
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(MarqueeButtonLinkComponent, {
    appDownloadLink,
    tuneLink,
    onClickButton
  })))), /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    alignSelf: "center",
    colSpan: 3
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(MarqueeSecondaryLinkComponent, {
    secondaryLink,
    onSecondaryClickButton,
    secondLink
  }))))), formSections && /* @__PURE__ */React59.createElement(MadMarqueeFormWrapper, {
    formTitle,
    formSections,
    formMessages,
    successFormAnalytics,
    errorFormAnalytics,
    placementId
  }), /* @__PURE__ */React59.createElement(MarqueeLegalTextAndLinkComponent, {
    legalText
  }))), customQRCode && /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: 1
  }, /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      inlinestart: "four"
    }
  }, /* @__PURE__ */React59.createElement(CustomQrCodeImage, {
    data: customQRCode,
    theme: "default"
  })))))))), backgroundImageUrl && isLayoutOnRight && /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: 1
  }, /* @__PURE__ */React59.createElement(EGDSFigure5, {
    ratio: EGDSFigureAspectRatioType4.R16_9
  }, /* @__PURE__ */React59.createElement(EGDSImage5, {
    placeholderImage: true,
    src: backgroundImageUrl,
    alt: backgroundImageDescription
  }))))))), /* @__PURE__ */React59.createElement(ViewMedium5, null, /* @__PURE__ */React59.createElement(EGDSCard8, {
    border: true
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGrid7, {
    columns: 3
  }, /* @__PURE__ */React59.createElement(React59.Fragment, null, backgroundImageUrl && /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: 1
  }, /* @__PURE__ */React59.createElement(EGDSFigure5, {
    ratio: EGDSFigureAspectRatioType4.R3_2
  }, /* @__PURE__ */React59.createElement(EGDSImage5, {
    placeholderImage: true,
    src: backgroundImageUrl,
    alt: backgroundImageDescription
  }))), /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: backgroundImageUrl ? 2 : 3
  }, /* @__PURE__ */React59.createElement(EGDSCardContentSection6, {
    padded: false
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: "six"
  }, /* @__PURE__ */React59.createElement("div", {
    role: "region",
    "aria-labelledby": "marquee-title"
  }, /* @__PURE__ */React59.createElement(EGDSHeading9, {
    tag: "h2",
    size: 3,
    id: "marquee-title"
  }, heading), body && /* @__PURE__ */React59.createElement(MadMarqueeSubSection, {
    body
  }), /* @__PURE__ */React59.createElement(EGDSLayoutGrid7, {
    space: "six",
    columns: secondLink ? 6 : 3
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: isSlim ? 6 : 1
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      blockstart: isSlim ? "unset" : "six"
    }
  }, /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(MarqueeButtonLinkComponent, {
    appDownloadLink,
    tuneLink,
    onClickButton
  })))), secondLink && /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    alignSelf: "center",
    colSpan: 1
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(MarqueeSecondaryLinkComponent, {
    secondaryLink,
    onSecondaryClickButton,
    secondLink
  }))))), /* @__PURE__ */React59.createElement(MarqueeLegalTextAndLinkComponent, {
    legalText
  }))))))))), /* @__PURE__ */React59.createElement(ViewSmall6, null, /* @__PURE__ */React59.createElement(EGDSCard8, {
    border: true
  }, backgroundImageUrl && /* @__PURE__ */React59.createElement(EGDSFigure5, {
    className: "all-image-fit-cover",
    ratio: EGDSFigureAspectRatioType4.R3_2
  }, /* @__PURE__ */React59.createElement(EGDSImage5, {
    placeholderImage: true,
    src: backgroundImageUrl,
    alt: backgroundImageDescription
  })), /* @__PURE__ */React59.createElement(EGDSCardContentSection6, {
    padded: false
  }, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: "six"
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGrid7, {
    columns: 4
  }, /* @__PURE__ */React59.createElement(EGDSLayoutGridItem6, {
    colSpan: 4
  }, /* @__PURE__ */React59.createElement("div", {
    role: "region",
    "aria-labelledby": "marquee-title"
  }, /* @__PURE__ */React59.createElement(EGDSHeading9, {
    tag: "h2",
    size: 5,
    id: "marquee-title"
  }, heading), body && /* @__PURE__ */React59.createElement(MadMarqueeSubSection, {
    body,
    isMobile: true
  }), /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      blockstart: isSlim ? "unset" : "four"
    }
  }, /* @__PURE__ */React59.createElement(EGDSLayoutFlex14, {
    space: "four",
    direction: "column",
    alignItems: "center"
  }, /* @__PURE__ */React59.createElement(React59.Fragment, null, /* @__PURE__ */React59.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */React59.createElement(MarqueeButtonLinkComponent, {
    appDownloadLink,
    tuneLink,
    onClickButton
  })), secondLink && /* @__PURE__ */React59.createElement(EGDSLayoutFlexItem14, null, /* @__PURE__ */React59.createElement(EGDSSpacing17, {
    padding: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React59.createElement("div", null, /* @__PURE__ */React59.createElement(MarqueeSecondaryLinkComponent, {
    secondaryLink,
    onSecondaryClickButton,
    secondLink
  })))), /* @__PURE__ */React59.createElement(MarqueeLegalTextAndLinkComponent, {
    legalText
  }))))))))))));
};
MadMarquee.displayName = "sharedui-MadMarquee";

// src/components/mad-marquee/mad-marquee-wrapper.tsx
var MadMarqueeWrapper = props => {
  var _a, _b, _c;
  const {
    data,
    inputs
  } = props;
  const {
    optionalContext,
    notificationLocation
  } = inputs;
  const {
    legalText,
    title,
    body,
    subBody,
    logo,
    links,
    revealActions,
    backgroundImage,
    form,
    customQrCode
  } = data;
  if (!logo || !(links == null ? void 0 : links.length) || !links[0]) {
    return null;
  }
  const heading = ((_a = title == null ? void 0 : title.items[0]) == null ? void 0 : _a.text) || "";
  const [tuneLink, secondLink] = links;
  const isCustomMarquee = notificationLocation === "IN_PAGE" /* IN_PAGE */;
  if (isCustomMarquee) {
    return /* @__PURE__ */React60.createElement(MarqueeProvider, {
      data
    }, /* @__PURE__ */React60.createElement(CustomInpageMarquee, {
      body: body || null,
      subBody: subBody || null,
      heading,
      backgroundImageUrl: backgroundImage == null ? void 0 : backgroundImage.url,
      backgroundImageDescription: backgroundImage == null ? void 0 : backgroundImage.description,
      qrCodeUrl: (_b = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _b.url,
      qrCodeDesc: (_c = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _c.description,
      qrCodeTitle: customQrCode == null ? void 0 : customQrCode.title,
      tuneLink,
      secondLink: secondLink != null ? secondLink : null,
      revealActions,
      referer: optionalContext == null ? void 0 : optionalContext.referer
    }));
  }
  return /* @__PURE__ */React60.createElement(MarqueeProvider, {
    data
  }, /* @__PURE__ */React60.createElement(MadMarquee, {
    body: body || null,
    subBody: subBody || null,
    heading,
    backgroundImageUrl: backgroundImage == null ? void 0 : backgroundImage.url,
    backgroundImageDescription: backgroundImage == null ? void 0 : backgroundImage.description,
    formTitle: (form == null ? void 0 : form.title) || null,
    formSections: (form == null ? void 0 : form.sections) || null,
    formMessages: (form == null ? void 0 : form.feedbackMessages) || null,
    successFormAnalytics: (form == null ? void 0 : form.successFormAnalytics) || null,
    errorFormAnalytics: (form == null ? void 0 : form.errorFormAnalytics) || null,
    customQRCode: customQrCode,
    tuneLink,
    secondLink: secondLink != null ? secondLink : null,
    legalText,
    revealActions,
    referer: optionalContext == null ? void 0 : optionalContext.referer
  }));
};

// src/components/one-key-banner/one-key-banner-wrapper.tsx
import React62 from "react";

// src/components/one-key-banner/one-key-banner.tsx
import React61 from "react";
import { EGDSCard as EGDSCard9 } from "@egds/react-core/cards";
import { EGDSLayoutFlex as EGDSLayoutFlex15, EGDSLayoutFlexItem as EGDSLayoutFlexItem15 } from "@egds/react-core/layout-flex";
import { EGDSMark as EGDSMark5, EGDSMarkTokenSizesList } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing18 } from "@egds/react-core/spacing";
import { EGDSSwitch } from "@egds/react-core/switch";
import { Level as Level2, liveAnnounce as liveAnnounce2 } from "@egds/react-core/utils";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
var OneKeyBanner = ({
  checked,
  checkedLabel,
  toggleEnabledAnnounceMsg,
  uncheckedLabel,
  toggleDisabledAnnounceMsg,
  logoUrl,
  logoDescription,
  revealActions,
  checkedAnalytics,
  uncheckedAnalytics,
  switchHandler,
  backgroundTheme
}) => {
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const analyticsTracker = useClickTracker5();
  React61.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const [isChecked, setIsChecked] = React61.useState(checked);
  const handleOnChange = React61.useCallback(() => {
    if (checkedAnalytics && !isChecked) {
      analyticsTracker(checkedAnalytics.referrerId, checkedAnalytics.linkName);
      if (toggleEnabledAnnounceMsg) {
        liveAnnounce2(toggleEnabledAnnounceMsg, Level2.POLITE);
      }
    }
    if (uncheckedAnalytics && isChecked) {
      analyticsTracker(uncheckedAnalytics.referrerId, uncheckedAnalytics.linkName);
      if (toggleDisabledAnnounceMsg) {
        liveAnnounce2(toggleDisabledAnnounceMsg, Level2.POLITE);
      }
    }
    setIsChecked(!isChecked);
    switchHandler(!isChecked);
  }, [checkedAnalytics, uncheckedAnalytics, isChecked, switchHandler]);
  return /* @__PURE__ */React61.createElement(EGDSCard9, {
    backgroundTheme: getCardTheme(backgroundTheme != null ? backgroundTheme : "PRIMARY" /* PRIMARY */),
    border: true
  }, /* @__PURE__ */React61.createElement(EGDSSpacing18, {
    padding: {
      inlinestart: "four"
    }
  }, /* @__PURE__ */React61.createElement(EGDSLayoutFlex15, {
    direction: "row",
    alignItems: "center",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React61.createElement(EGDSLayoutFlexItem15, {
    alignSelf: "center"
  }, /* @__PURE__ */React61.createElement("section", null, /* @__PURE__ */React61.createElement(EGDSSpacing18, {
    padding: {
      block: "two"
    }
  }, /* @__PURE__ */React61.createElement(EGDSLayoutFlex15, {
    direction: "row",
    alignItems: "start",
    justifyContent: "space-between"
  }, logoUrl && logoDescription && /* @__PURE__ */React61.createElement(EGDSLayoutFlexItem15, {
    grow: 0,
    shrink: 1
  }, /* @__PURE__ */React61.createElement(EGDSMark5, {
    url: logoUrl,
    description: logoDescription,
    size: EGDSMarkTokenSizesList["7"]
  })), checkedLabel && uncheckedLabel && /* @__PURE__ */React61.createElement(EGDSLayoutFlexItem15, {
    alignSelf: "center",
    grow: 1,
    shrink: 1
  }, /* @__PURE__ */React61.createElement(EGDSLayoutFlex15, {
    direction: "column",
    alignItems: "center",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React61.createElement(EGDSSpacing18, {
    padding: {
      inline: "four"
    }
  }, /* @__PURE__ */React61.createElement(EGDSSwitch, {
    id: "SwitchLabelTrailing",
    switchPosition: "trailing",
    checked: isChecked,
    onChange: handleOnChange,
    label: isChecked ? checkedLabel : uncheckedLabel,
    labelClassName: "uitk-type-400 uitk-type-medium"
  })))))))))));
};
OneKeyBanner.displayName = "sharedui-OneKeyBanner";

// src/components/one-key-banner/one-key-banner-wrapper.tsx
var MemoizedConfigurableBanner2 = React62.memo(ConfigurableBanner);
var OneKeyWrapper = props => {
  var _a;
  const {
    data,
    switchHandler,
    useRewards,
    inputs
  } = props;
  const {
    type,
    notificationLocation,
    title,
    logo,
    dismiss,
    revealActions,
    links,
    containerLink,
    body,
    subBody,
    icon,
    customQrCode,
    theme,
    legalText,
    bannerContainer
  } = data;
  const switchData = data.switch;
  const isToggleOneKey = !!switchData;
  const backupHandler = isChecked => isChecked;
  const checked = (switchData == null ? void 0 : switchData.checked) === true && useRewards === true;
  const backgroundTheme = (theme == null ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme == null ? void 0 : theme.themeValue : null;
  const border = (theme == null ? void 0 : theme.__typename) === "NotificationCardTheme" ? theme == null ? void 0 : theme.cardBorder : false;
  const bannerTheme = "BRAND_PROMO_PRIMARY" /* BRAND_PROMO_PRIMARY */;
  const termsAndConditions = (_a = legalText == null ? void 0 : legalText.egdsTextItems) == null ? void 0 : _a.find(link => (link == null ? void 0 : link.__typename) === "EGDSStandardLink" || (link == null ? void 0 : link.__typename) === "EGDSStylizedText");
  const memoizedConfigurableData = React62.useMemo(() => {
    var _a2;
    return {
      bannerTheme,
      type,
      notificationLocation,
      title,
      revealActions,
      logo,
      links,
      containerLink,
      dismiss,
      referer: (_a2 = inputs.optionalContext) == null ? void 0 : _a2.referer,
      body,
      subBody,
      icon,
      customQrCode,
      backgroundTheme,
      border,
      termsAndConditions,
      bannerContainer
    };
  }, []);
  return /* @__PURE__ */React62.createElement(React62.Fragment, null, isToggleOneKey ? /* @__PURE__ */React62.createElement(OneKeyBanner, {
    checked,
    checkedLabel: switchData == null ? void 0 : switchData.checkedLabel,
    toggleEnabledAnnounceMsg: switchData == null ? void 0 : switchData.checkedAccessibilityLabel,
    uncheckedLabel: switchData == null ? void 0 : switchData.uncheckedLabel,
    toggleDisabledAnnounceMsg: switchData == null ? void 0 : switchData.uncheckedAccessibilityLabel,
    logoUrl: logo == null ? void 0 : logo.url,
    logoDescription: logo == null ? void 0 : logo.description,
    revealActions,
    checkedAnalytics: switchData == null ? void 0 : switchData.checkedAnalytics,
    uncheckedAnalytics: switchData == null ? void 0 : switchData.uncheckedAnalytics,
    switchHandler: switchHandler || backupHandler,
    backgroundTheme
  }) : /* @__PURE__ */React62.createElement(MemoizedConfigurableBanner2, __spreadValues({}, memoizedConfigurableData)));
};

// src/components/onetrust/onetrust-wrapper.tsx
import React64 from "react";

// src/components/onetrust/helpers/onetrust-banner-helpers.tsx
var ONETRUST_SCRIPT_ID = "cust-notif-onetrust-script";
var CAN_SELL_COOKIE_VALUE_ATTRIBUTE_KEY = "canSellCookieValue";
var SHOULD_RELOAD_ON_ACCEPT = "shouldReloadOnAccept";
var EXPERIMENT = "Experiment";
var ONE_TRUST_ALERT_CLOSED_COOKIE_NAME = "OptanonAlertBoxClosed";
var ONE_TRUST_ALERT_CLOSED_COOKIE_NAME_REGEX = /(?:^| |;)OptanonAlertBoxClosed=/;
var createScript = (oneTrustUrl, domainId, isTestEnv, logger) => {
  const envId = isTestEnv ? "-test" : "";
  const isDistinctUrl = oneTrustUrl.includes(domainId);
  let scriptUrl = oneTrustUrl;
  if (isDistinctUrl && isTestEnv && oneTrustUrl.includes("/otSDKStub.js")) {
    scriptUrl = oneTrustUrl.replace("/otSDKStub.js", "-test/otSDKStub.js");
  }
  const script = document.createElement("script");
  script.onerror = error => {
    logger(`Failed to load script: ${oneTrustUrl} 
 id: ${domainId} 
 envId: ${envId}`, error);
  };
  script.src = scriptUrl;
  script.id = ONETRUST_SCRIPT_ID;
  script.setAttribute("data-domain-script", `${domainId}${envId}`);
  script.type = "text/javascript";
  script.setAttribute("data-document-language", "true");
  script.setAttribute("charset", "UTF-8");
  return script;
};
var createCookieBlockingScript = blockingScriptUrl => {
  const script = document.createElement("script");
  script.src = blockingScriptUrl;
  script.id = ONETRUST_SCRIPT_ID;
  script.type = "text/javascript";
  script.setAttribute("data-document-language", "true");
  return script;
};
var formatActiveGroups = groups => groups.split(",").filter(item => item.length > 0);
var findAttribute = (attributes, key) => {
  var _a;
  if (attributes) {
    return (_a = attributes.find(attribute => attribute.name && attribute.name === key)) == null ? void 0 : _a.value;
  }
  return void 0;
};
var clearOneTrustAlertBoxCookies = () => {
  const {
    hostname
  } = window.location;
  const domains = [hostname];
  const index = hostname.indexOf(".");
  if (index > -1) {
    domains.push(hostname.slice(index));
  }
  document.cookie = createExpiredOneTrustAlertCookie();
  domains.forEach(domain => {
    document.cookie = createExpiredOneTrustAlertCookie(domain);
  });
};
var createExpiredOneTrustAlertCookie = domain => {
  const domainAttribute = domain ? ` domain=${domain};` : "";
  return `${ONE_TRUST_ALERT_CLOSED_COOKIE_NAME}=;${domainAttribute} expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};
var isAlertBoxClosedCookiePresent = () => ONE_TRUST_ALERT_CLOSED_COOKIE_NAME_REGEX.test(document.cookie);

// src/components/onetrust/onetrust.tsx
import React63 from "react";
import { gql as gql15, useMutation as useMutation2 } from "@shared-ui/apollo-client-wrapper";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { useLogger } from "@shared-ui/logger-context";
var ONETRUST_SCRIPT_ID_ATTRIBUTE_NAME = "onetrustScriptId";
var NOTICE_ONLY_POS_ATTRIBUTE_NAME = "noticeOnly";
var OIP_ATTRIBUTE_NAME = "optInPrivacyValue";
var OPT_IN_URL_ATTRIBUTE_NAME = "optInUrl";
var OPT_OUT_URL_ATTRIBUTE_NAME = "optOutUrl";
var BLOCKING_SCRIPT_URL_ATTRIBUTE_NAME = "blockingScriptUrl";
var CATEGORIES_ATTRIBUTE_NAME = "consentCatagories";
var USER_ID_ATTRIBUTE_NAME = "OneTrustUserId";
var USER_ID_ENCODED_ATTRIBUTE_NAME = "OneTrustUserIdEncoded";
var SHOULD_AUTO_OPEN_PREFS_ATTRIBUTE_NAME = "ShouldAutoOpenPrefs";
var CLEAR_ALERT_COOKIE_WHEN_GDPR_UNSET_ATTRIBUTE_NAME = "clearAlertCookieWhenGdprUnset";
var ENVIRONMENT_ATTRIBUTE_NAME = "env";
var __Mutation = gql15`
  mutation ConsentMgmtMutation($context: ContextInput!, $request: SavePrefRequestInput!) {
    consentMgmtPrefSubmit(context: $context, request: $request) {
      success
    }
  }
`;
var setOptInEGCookies = (optInUrl, shouldReloadOnAccept, logger) => {
  fetch(optInUrl, {
    method: "POST"
  }).then(res => {
    if (res.ok || res.redirected) {
      if (shouldReloadOnAccept === "true") {
        window.location.reload();
      }
    } else {
      throw new Error("OT_OIP_REQUEST_FAILED" /* OT_OIP_REQUEST_FAILED */);
    }
  }).catch(err => {
    logger(err);
  });
};
var setOptOutEGCookies = (optOutUrl, logger) => {
  fetch(optOutUrl, {
    method: "POST"
  }).then(res => {
    if (res.ok || res.redirected) {} else {
      throw new Error("OT_OIP_REQUEST_FAILED" /* OT_OIP_REQUEST_FAILED */);
    }
  }).catch(err => {
    logger(err);
  });
};
var registerOnetrustHandlers = async (context, attributes, updatePreference, logger) => {
  var _a;
  try {
    const OIP = findAttribute(attributes, OIP_ATTRIBUTE_NAME);
    const OIP_CCPA = findAttribute(attributes, CAN_SELL_COOKIE_VALUE_ATTRIBUTE_KEY);
    const optInUrl = findAttribute(attributes, OPT_IN_URL_ATTRIBUTE_NAME) || "";
    const optOutUrl = findAttribute(attributes, OPT_OUT_URL_ATTRIBUTE_NAME) || "";
    const CATEGORIES = (_a = findAttribute(attributes, CATEGORIES_ATTRIBUTE_NAME)) == null ? void 0 : _a.split("|");
    const cookieGroupsActive = window.OnetrustActiveGroups ? formatActiveGroups(window.OnetrustActiveGroups) : [];
    const shouldReloadOnAccept = findAttribute(attributes, SHOULD_RELOAD_ON_ACCEPT);
    const consentMutationExperiment = findAttribute(attributes, EXPERIMENT);
    const consented = (CATEGORIES == null ? void 0 : CATEGORIES.every(element => {
      return cookieGroupsActive.includes(element);
    })) || false;
    const isConsentMutationExperiment = consentMutationExperiment && consentMutationExperiment === "true";
    let variables;
    if (isConsentMutationExperiment) {
      variables = {
        context,
        request: {
          canSell: consented
        }
      };
    }
    if (OIP === "gdpr|-1" || OIP === "null" && OIP_CCPA === "null") {
      if (isConsentMutationExperiment) {
        await updatePreference({
          variables
        });
      } else if (consented) {
        setOptInEGCookies(optInUrl, shouldReloadOnAccept, logger);
      } else {
        setOptOutEGCookies(optOutUrl, logger);
      }
    } else if ((OIP === "gdpr|0" || OIP_CCPA === "ccpa|0") && consented) {
      if (isConsentMutationExperiment) {
        await updatePreference({
          variables
        });
        window.location.reload();
      } else {
        setOptInEGCookies(optInUrl, shouldReloadOnAccept, logger);
      }
    } else if ((OIP === "gdpr|1" || OIP_CCPA === "ccpa|1") && !consented) {
      if (isConsentMutationExperiment) {
        await updatePreference({
          variables
        });
        window.location.reload();
      } else {
        setOptOutEGCookies(optOutUrl, logger);
      }
    }
  } catch (err) {
    logger("OT_OIP_REQUEST_FAILED" /* OT_OIP_REQUEST_FAILED */, err);
  }
};
var Onetrust = props => {
  const {
    onetrustAttributes
  } = props;
  const {
    error: logError
  } = useLogger();
  const track = useEgClickstream2();
  const [isInitializing, setIsInitializing] = React63.useState(false);
  let scriptUrl;
  let domainId;
  let blockingScriptUrl;
  let isNoticeOnly;
  if (onetrustAttributes) {
    scriptUrl = findAttribute(onetrustAttributes, ONETRUST_SCRIPT_URL_ATTRIBUTE);
    domainId = findAttribute(onetrustAttributes, ONETRUST_SCRIPT_ID_ATTRIBUTE_NAME);
    blockingScriptUrl = findAttribute(onetrustAttributes, BLOCKING_SCRIPT_URL_ATTRIBUTE_NAME);
    isNoticeOnly = findAttribute(onetrustAttributes, NOTICE_ONLY_POS_ATTRIBUTE_NAME);
  }
  const userIdAttribute = findAttribute(onetrustAttributes, USER_ID_ATTRIBUTE_NAME);
  const userIdEncodedAttribute = findAttribute(onetrustAttributes, USER_ID_ENCODED_ATTRIBUTE_NAME);
  const shouldAutoOpenPrefsAttribute = findAttribute(onetrustAttributes, SHOULD_AUTO_OPEN_PREFS_ATTRIBUTE_NAME);
  const clearAlertCookieWhenGdprUnset = findAttribute(onetrustAttributes, CLEAR_ALERT_COOKIE_WHEN_GDPR_UNSET_ATTRIBUTE_NAME) === "true";
  const gdprIsUnset = findAttribute(onetrustAttributes, OIP_ATTRIBUTE_NAME) === "gdpr|-1";
  const shouldAddCrossDeviceUserData = userIdAttribute && userIdEncodedAttribute && userIdAttribute !== "-1" && userIdEncodedAttribute !== "null";
  const isTestEnv = findAttribute(onetrustAttributes, ENVIRONMENT_ATTRIBUTE_NAME) === "test";
  const [updatePreference] = useMutation2(__Mutation);
  const {
    context
  } = useBexApi2();
  const CLICKSTREAM_EVENT_VERSION = "1.0.0";
  const getEventData = (element, elementType) => {
    var _a, _b, _c, _d, _e, _f, _g;
    const eventType = "Interaction";
    const eventVersion = CLICKSTREAM_EVENT_VERSION;
    let eventName = "unknown";
    let componentElementName = "unlabeled";
    let eventLocation = "unknown";
    if (element.closest("#onetrust-pc-sdk")) {
      eventLocation = "privacy_banner_purpose";
    }
    if (element.closest("#onetrust-banner-sdk")) {
      eventLocation = "privacy_banner";
    }
    if (elementType === "button" || elementType === "link") {
      eventName = "privacy_banner.selected";
      componentElementName = ((_a = element.textContent) == null ? void 0 : _a.trim()) || element.getAttribute("aria-label") || "unlabeled";
    } else if (elementType === "toggle") {
      eventName = element.checked ? "toggle.selected" : "toggle_deselected";
      componentElementName = ((_d = (_c = (_b = element.closest(".ot-acc-hdr")) == null ? void 0 : _b.querySelector(".ot-cat-header")) == null ? void 0 : _c.textContent) == null ? void 0 : _d.trim()) || "unlabeled";
    } else if (elementType === "expand") {
      eventName = element.getAttribute("aria-expanded") === "false" ? "expand.selected" : "collapse.selected";
      componentElementName = ((_g = (_f = (_e = element.closest(".ot-cat-item")) == null ? void 0 : _e.querySelector(".ot-cat-header")) == null ? void 0 : _f.textContent) == null ? void 0 : _g.trim()) || "unlabeled";
    }
    const data = {
      event: {
        event_type: eventType,
        event_name: eventName,
        event_version: eventVersion,
        action_location: eventLocation
      },
      component: {
        element_name: componentElementName
      }
    };
    return data;
  };
  React63.useEffect(() => {
    const elementsForClickTracking = [{
      selector: "#onetrust-accept-btn-handler",
      elementType: "button"
    }, {
      selector: "#onetrust-reject-all-handler",
      elementType: "button"
    }, {
      selector: "button.onetrust-close-btn-handler",
      elementType: "button"
    }, {
      selector: "#onetrust-pc-btn-handler",
      elementType: "button"
    }, {
      selector: 'a[href="/lp/b/support/cookies"]',
      elementType: "link"
    }, {
      selector: "button.onetrust-vendors-list-handler",
      elementType: "link"
    }, {
      selector: "a.privacy-notice-link",
      elementType: "link"
    }, {
      selector: "#accept-recommended-btn-handler",
      elementType: "button"
    }, {
      selector: "button.ot-pc-refuse-all-handler",
      elementType: "button"
    }, {
      selector: "button.save-preference-btn-handler",
      elementType: "button"
    }, {
      selector: 'a[href="/lp/b/lg-privacypolicy"]',
      elementType: "link"
    }, {
      selector: "a.ot-imprint-link",
      elementType: "link"
    }, {
      selector: "#onetrust-pc-sdk .category-switch-handler",
      elementType: "toggle"
    }, {
      selector: '#onetrust-pc-sdk button[ot-accordion="true"]',
      elementType: "expand"
    }];
    const onInitWrapper = () => {
      var _a, _b, _c, _d;
      let shouldSendImpression = false;
      if (window == null ? void 0 : window.OneTrust) {
        const privacyBannerVariant = ((_b = (_a = window.OneTrust).getCSS) == null ? void 0 : _b.call(_a).match(/border-radius: 2500rem;/)) && ((_d = (_c = window.OneTrust).getCSS) == null ? void 0 : _d.call(_c).match(/background-color: #1668e3;/));
        const componentName = privacyBannerVariant ? "mini_height" : "full_height";
        if (window.OneTrust.OnConsentChanged) {
          window.OneTrust.OnConsentChanged(() => {
            if (isNoticeOnly) {
              return;
            }
            registerOnetrustHandlers(context, onetrustAttributes, updatePreference, logError);
          });
        }
        if (shouldAutoOpenPrefsAttribute === "true" && window.OneTrust.ToggleInfoDisplay) {
          window.OneTrust.ToggleInfoDisplay();
        }
        if (window.OneTrust.hasTracked === void 0) {
          window.OneTrust.hasTracked = false;
        }
        if (window.OneTrust.IsAlertBoxClosed) {
          shouldSendImpression = !window.OneTrust.hasTracked && !window.OneTrust.IsAlertBoxClosed();
        }
        if (shouldSendImpression) {
          const eventData = {
            event: {
              event_type: "Impression",
              event_name: "privacy_banner.presented",
              event_version: CLICKSTREAM_EVENT_VERSION,
              event_category: "Privacy & tracking consent"
            },
            additional_context: {
              user_interface: {
                component_name: componentName
              }
            }
          };
          track(eventData);
          window.OneTrust.hasTracked = true;
        }
        elementsForClickTracking.forEach(({
          selector,
          elementType
        }) => {
          const allElements = document.querySelectorAll(selector);
          allElements.forEach(element => {
            element.addEventListener("click", () => {
              try {
                track(getEventData(element, elementType));
              } catch (error) {
                logError("ERROR_TRACKING_OT_CLICKSTREAM_EVENT" /* ERROR_TRACKING_OT_CLICK */, error);
              }
            });
          });
        });
      } else {
        logError("ERROR_LOAD_OT_NOT_DEFINED_ON_INIT" /* ERROR_LOAD_OT_NOT_DEFINED_ON_INIT */);
      }
    };
    if (!isInitializing) {
      setIsInitializing(true);
      if (!document.getElementById(ONETRUST_SCRIPT_ID)) {
        if (scriptUrl && domainId && !window.OneTrust) {
          if (shouldAddCrossDeviceUserData) {
            window.OneTrust = {
              dataSubjectParams: {
                id: userIdAttribute,
                isAnonymous: false,
                token: userIdEncodedAttribute
              }
            };
          }
          if (clearAlertCookieWhenGdprUnset && gdprIsUnset && isAlertBoxClosedCookiePresent()) {
            clearOneTrustAlertBoxCookies();
          }
          window.OptanonWrapper = onInitWrapper;
          if (blockingScriptUrl) {
            document.head.appendChild(createCookieBlockingScript(blockingScriptUrl));
          }
          document.head.appendChild(createScript(scriptUrl, domainId, isTestEnv, logError));
        } else {
          logError("ERROR_LOADING_OT_MISSING_PARAMS" /* ERROR_LOADING_OT_MISSING_PARAMS */);
        }
      }
    }
  }, [blockingScriptUrl, clearAlertCookieWhenGdprUnset, context, domainId, gdprIsUnset, isInitializing, isNoticeOnly, isTestEnv, logError, onetrustAttributes, scriptUrl, shouldAddCrossDeviceUserData, shouldAutoOpenPrefsAttribute, track, updatePreference, userIdAttribute, userIdEncodedAttribute]);
  return null;
};

// src/components/onetrust/onetrust-wrapper.tsx
var ONETRUST_SCRIPT_URL_ATTRIBUTE = "onetrustScriptURL";
var OnetrustWrapper = ({
  data
}) => {
  const {
    attributes
  } = data || {};
  const onetrustBannerUrl = findAttribute(attributes, ONETRUST_SCRIPT_URL_ATTRIBUTE);
  if (!onetrustBannerUrl) {
    return null;
  }
  return /* @__PURE__ */React64.createElement(Onetrust, {
    onetrustAttributes: attributes == null ? void 0 : attributes.map(attribute => ({
      name: attribute.name,
      value: attribute.value
    }))
  });
};

// src/components/popover-sheet/popover-sheet-wrapper.tsx
import React66 from "react";

// src/components/popover-sheet/popover-sheet.tsx
import React65 from "react";
import { EGDSFigure as EGDSFigure6, EGDSFigureAspectRatioType as EGDSFigureAspectRatioType5, EGDSImage as EGDSImage6 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex16, EGDSLayoutFlexItem as EGDSLayoutFlexItem16 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink12 } from "@egds/react-core/link";
import { EGDSMark as EGDSMark6 } from "@egds/react-core/mark";
import { EGDSSheet as EGDSSheet3, EGDSSheetContent as EGDSSheetContent3, EGDSSheetTransition as EGDSSheetTransition3 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing19 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText23 } from "@egds/react-core/text";
var PopoverSheet = ({
  logo,
  sheetTitle,
  sheetBody,
  qrCodeUrl,
  qrCodeDesc,
  qrCodeTitle,
  playStoreBadge,
  appStoreBadge,
  learnMore,
  revealActions
}) => {
  var _a;
  const titleTextSize = getTextSize(sheetTitle == null ? void 0 : sheetTitle.textSize);
  const titleTextWeight = getTextWeight(sheetTitle == null ? void 0 : sheetTitle.weight);
  const bodyTextSize = getTextSize(sheetBody == null ? void 0 : sheetBody.textSize);
  const bodyTextWeight = getTextWeight(sheetBody == null ? void 0 : sheetBody.weight);
  const [visible, setVisible] = React65.useState(false);
  const buttonRef = null;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React65.useEffect(() => {
    setVisible(true);
    customerNotificationActionsExecutor(revealActions);
  });
  return /* @__PURE__ */React65.createElement(EGDSSheetTransition3, {
    isVisible: visible
  }, /* @__PURE__ */React65.createElement(EGDSSheet3, {
    position: {
      inline: "leading",
      block: "trailing"
    },
    isVisible: visible,
    applyBlockStartMargin: true,
    type: "popover",
    triggerRef: buttonRef,
    disableBodyClickHandler: true,
    returnFocusOnClose: true,
    width: 250
  }, /* @__PURE__ */React65.createElement(EGDSSheetContent3, {
    padded: false
  }, /* @__PURE__ */React65.createElement(EGDSSpacing19, {
    padding: {
      block: "six",
      inline: "eight"
    }
  }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex16, {
    direction: "column",
    alignContent: "space-around",
    justifyContent: "start",
    blockSize: "full_size",
    space: "three"
  }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSMark6, {
    url: logo == null ? void 0 : logo.url,
    description: logo.description,
    size: 12
  })), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSText23, {
    align: "center",
    spacing: "three",
    weight: titleTextWeight,
    size: titleTextSize
  }, sheetTitle == null ? void 0 : sheetTitle.text)), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSText23, {
    align: "center",
    weight: bodyTextWeight,
    size: bodyTextSize
  }, sheetBody == null ? void 0 : sheetBody.text)), /* @__PURE__ */React65.createElement(EGDSLayoutFlex16, {
    direction: "column",
    alignContent: "space-around",
    blockSize: "full_size",
    space: "two"
  }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSFigure6, {
    imageFit: "contain",
    ratio: EGDSFigureAspectRatioType5.R16_9
  }, /* @__PURE__ */React65.createElement(EGDSImage6, {
    placeholderImage: true,
    src: qrCodeUrl,
    alt: qrCodeDesc
  }))), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSText23, {
    align: "center",
    size: 200
  }, qrCodeTitle))), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, {
    alignSelf: "center"
  }, /* @__PURE__ */React65.createElement(EGDSLayoutFlex16, {
    direction: "row",
    alignContent: "space-around",
    blockSize: "full_size",
    space: "two"
  }, /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSMark6, {
    url: playStoreBadge == null ? void 0 : playStoreBadge.url,
    description: playStoreBadge == null ? void 0 : playStoreBadge.description,
    size: 7
  })), /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSMark6, {
    url: appStoreBadge == null ? void 0 : appStoreBadge.url,
    description: appStoreBadge == null ? void 0 : appStoreBadge.description,
    size: 7
  })))), learnMore && /* @__PURE__ */React65.createElement(EGDSLayoutFlexItem16, null, /* @__PURE__ */React65.createElement(EGDSLink12, {
    align: "center",
    size: "small"
  }, /* @__PURE__ */React65.createElement("a", {
    href: (_a = learnMore.uri) == null ? void 0 : _a.value,
    target: "_blank",
    rel: "noopener"
  }, learnMore == null ? void 0 : learnMore.text))))))));
};

// src/components/popover-sheet/popover-sheet-wrapper.tsx
var PopoverSheetWrapper = props => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    data: {
      title,
      body,
      logo,
      customQrCode,
      links,
      featuredImages,
      revealActions
    }
  } = props;
  const learnMore = links == null ? void 0 : links[0];
  if (!title && !body || !logo || !((_a = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _a.url) || !revealActions) {
    return null;
  }
  let sheetTitle;
  let sheetBody;
  if (((_c = (_b = title == null ? void 0 : title.egdsTextItems) == null ? void 0 : _b[0]) == null ? void 0 : _c.__typename) === "EGDSStylizedText") {
    const [firstItem] = title.egdsTextItems;
    sheetTitle = firstItem;
  }
  if (((_f = (_e = (_d = body == null ? void 0 : body[0]) == null ? void 0 : _d.egdsTextItems) == null ? void 0 : _e[0]) == null ? void 0 : _f.__typename) === "EGDSStylizedText") {
    const [firstItem] = body[0].egdsTextItems;
    sheetBody = firstItem;
  }
  const playStoreBadge = featuredImages == null ? void 0 : featuredImages[0];
  const appStoreBadge = featuredImages == null ? void 0 : featuredImages[1];
  return /* @__PURE__ */React66.createElement(PopoverSheet, {
    logo,
    sheetTitle,
    sheetBody,
    qrCodeUrl: (_g = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _g.url,
    qrCodeDesc: (_h = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _h.description,
    qrCodeTitle: customQrCode == null ? void 0 : customQrCode.title,
    playStoreBadge,
    appStoreBadge,
    learnMore,
    revealActions
  });
};

// src/components/sheet-wrapper/sheet-wrapper.tsx
import React69 from "react";
import { EGDSSheetServerSideRender as EGDSSheetServerSideRender2, EGDSSheetServerSideRenderContent as EGDSSheetServerSideRenderContent2 } from "@egds/react-app-growth";
import { EGDSLayoutGrid as EGDSLayoutGrid9 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing22 } from "@egds/react-core/spacing";
import { EGDSViewRow as EGDSViewRow5 } from "@egds/react-core/view";
import { useApolloClient as useApolloClient5 } from "@shared-ui/apollo-client-wrapper";
import { ViewMedium as ViewMedium7, Viewport as Viewport8, ViewSmall as ViewSmall8 } from "@shared-ui/viewport-context";

// src/components/sheet-wrapper/sheet-flex-layout.tsx
import React67 from "react";
import { EGDSFigureAspectRatioType as EGDSFigureAspectRatioType6 } from "@egds/react-core/images";
import { EGDSLayoutFlex as EGDSLayoutFlex17, EGDSLayoutFlexItem as EGDSLayoutFlexItem17 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing20 } from "@egds/react-core/spacing";
import { ViewMedium as ViewMedium6, Viewport as Viewport7, ViewSmall as ViewSmall7 } from "@shared-ui/viewport-context";
var SheetFlexLayout = ({
  logo,
  backgroundImage,
  title,
  body,
  links,
  legalText,
  layout,
  type,
  className,
  onClickDismiss
}) => {
  const isFullSheet = type === "FULL_SHEET" /* FULL_SHEET */;
  const isImageBanner = !!(backgroundImage == null ? void 0 : backgroundImage.url);
  const isLeft = layout === "LEFT" /* LEFT */;
  const isInlineCTA = isLeft && !legalText;
  const layoutDirectionButtons = isInlineCTA ? "row" : "column";
  const maxWidth = isImageBanner || isFullSheet ? "96x" : void 0;
  const fullSheetLeftPadding = {
    inline: isFullSheet && isLeft ? "eight" : "unset"
  };
  return /* @__PURE__ */React67.createElement(EGDSSpacing20, {
    padding: fullSheetLeftPadding
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlex17, {
    className,
    direction: "column",
    blockSize: "full_size",
    space: isFullSheet ? "six" : "four"
  }, (logo || backgroundImage) && /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */React67.createElement(EGDSSpacing20, {
    padding: {
      blockstart: !isImageBanner ? "eight" : "six"
    }
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlex17, {
    direction: "column"
  }, (logo == null ? void 0 : logo.url) && /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    alignSelf: isLeft ? "start" : "center",
    maxWidth
  }, /* @__PURE__ */React67.createElement(NotificationLogo, {
    data: logo
  })), (backgroundImage == null ? void 0 : backgroundImage.url) && /* @__PURE__ */React67.createElement(Viewport7, null, /* @__PURE__ */React67.createElement(ViewMedium6, null, /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    grow: 1,
    alignSelf: isLeft ? "start" : "center"
  }, /* @__PURE__ */React67.createElement(BackgroundImage, {
    data: backgroundImage,
    overrideAspectRatio: EGDSFigureAspectRatioType6.R21_9
  }))), /* @__PURE__ */React67.createElement(ViewSmall7, null, /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    grow: 1,
    alignSelf: isLeft ? "start" : "center"
  }, /* @__PURE__ */React67.createElement(BackgroundImage, {
    data: backgroundImage,
    overrideAspectRatio: EGDSFigureAspectRatioType6.R16_9
  }))))))), /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    maxWidth,
    alignSelf: isLeft ? "start" : "center"
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlex17, {
    direction: "column"
  }, title && /* @__PURE__ */React67.createElement(NotificationPhrase, {
    data: title
  }))), /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    maxWidth,
    alignSelf: isLeft ? "start" : "center"
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlex17, {
    direction: "column",
    space: "four"
  }, body && /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, null, /* @__PURE__ */React67.createElement(NotificationBodyArray, {
    body,
    overrideTextStyles: {
      align: isLeft ? "left" : "center"
    }
  })))), /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    alignSelf: "stretch"
  }, /* @__PURE__ */React67.createElement(EGDSLayoutFlex17, {
    direction: layoutDirectionButtons,
    space: "four"
  }, links == null ? void 0 : links.map((link, index) => /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    key: `button-list-${index}`,
    maxWidth,
    alignSelf: "center"
  }, /* @__PURE__ */React67.createElement(NotificationPhraseLinkNode, {
    key: index,
    data: link,
    onCloseAction: onClickDismiss
  }))), legalText && /* @__PURE__ */React67.createElement(EGDSLayoutFlexItem17, {
    alignSelf: "center"
  }, /* @__PURE__ */React67.createElement(NotificationPhrase, {
    data: legalText
  }))))));
};

// src/components/sheet-wrapper/sheet-grid-layout.tsx
import React68 from "react";
import { EGDSLayoutFlex as EGDSLayoutFlex18, EGDSLayoutFlexItem as EGDSLayoutFlexItem18 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGrid as EGDSLayoutGrid8, EGDSLayoutGridItem as EGDSLayoutGridItem7 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing21 } from "@egds/react-core/spacing";
var SheetGridLayout = ({
  logo,
  customQrCode,
  title,
  body,
  links,
  legalText,
  layout,
  className,
  isQrCodeEnabled,
  onClickDismiss
}) => {
  return /* @__PURE__ */React68.createElement(EGDSLayoutGrid8, {
    className,
    columns: {
      medium: isQrCodeEnabled ? ["6fr", "2fr"] : ["2fr", "0fr"]
    }
  }, /* @__PURE__ */React68.createElement(EGDSLayoutGridItem7, {
    colSpan: 1,
    alignSelf: "center"
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlex18, {
    direction: "column",
    alignItems: "start",
    space: "four"
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React68.createElement(EGDSLayoutFlex18, {
    space: "three",
    alignItems: "center"
  }, (logo == null ? void 0 : logo.url) && /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, {
    alignSelf: "center"
  }, /* @__PURE__ */React68.createElement(NotificationLogo, {
    data: logo
  })), title && /* @__PURE__ */React68.createElement(NotificationPhrase, {
    data: title,
    overrideTextStyles: {
      align: "left"
    }
  }))), /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React68.createElement(EGDSLayoutFlex18, {
    direction: "column"
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlex18, {
    direction: "column",
    space: "four"
  }, body && /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React68.createElement(NotificationBodyArray, {
    body,
    overrideTextStyles: {
      align: "left"
    }
  }))))), /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React68.createElement(EGDSLayoutFlex18, {
    direction: layout === "LEFT" /* LEFT */ ? "row" : "column",
    justifyContent: "center",
    space: "four"
  }, links == null ? void 0 : links.map((link, index) => /* @__PURE__ */React68.createElement(EGDSSpacing21, {
    key: `button-list-${index}`,
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, {
    alignSelf: "center"
  }, /* @__PURE__ */React68.createElement(NotificationPhraseLinkNode, {
    key: index,
    data: link,
    onCloseAction: onClickDismiss
  })))), legalText && /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React68.createElement(NotificationPhrase, {
    data: legalText,
    overrideTextStyles: {
      align: "left"
    }
  })))))), /* @__PURE__ */React68.createElement(EGDSLayoutGridItem7, {
    colSpan: 1,
    justifySelf: "end"
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlex18, {
    direction: "column",
    justifyContent: "start"
  }, /* @__PURE__ */React68.createElement(EGDSLayoutFlexItem18, null, /* @__PURE__ */React68.createElement(CustomQrCodeImage, {
    data: customQrCode
  })))));
};

// src/components/sheet-wrapper/sheet-wrapper.tsx
var SheetWrapperComponent = ({
  sheetType,
  isVisible,
  dismiss,
  children,
  onDismiss
}) => {
  switch (sheetType) {
    case "CENTERED_SHEET" /* CENTERED_SHEET */:
      return /* @__PURE__ */React69.createElement(Viewport8, null, /* @__PURE__ */React69.createElement(ViewSmall8, null, /* @__PURE__ */React69.createElement(EGDSSheetServerSideRender2, {
        isVisible,
        type: "centered",
        centeredSheetSize: "small",
        onDismiss
      }, dismiss && /* @__PURE__ */React69.createElement(DismissNotification, {
        data: dismiss,
        onClickDismissCB: onDismiss
      }), children)), /* @__PURE__ */React69.createElement(ViewMedium7, null, /* @__PURE__ */React69.createElement(EGDSSheetServerSideRender2, {
        isVisible,
        type: "centered",
        centeredSheetSize: "medium",
        onDismiss
      }, dismiss && /* @__PURE__ */React69.createElement(DismissNotification, {
        data: dismiss,
        onClickDismissCB: onDismiss
      }), children)));
    case "FULL_SHEET" /* FULL_SHEET */:
      return /* @__PURE__ */React69.createElement(EGDSSheetServerSideRender2, {
        isVisible,
        type: "full",
        theme: "dark",
        onDismiss
      }, dismiss && /* @__PURE__ */React69.createElement(DismissNotification, {
        data: dismiss,
        onClickDismissCB: onDismiss
      }), /* @__PURE__ */React69.createElement(EGDSLayoutGrid9, {
        blockSize: "full_size"
      }, children));
    default:
      return null;
  }
};
var SheetWrapper = ({
  data,
  inputs: {
    optionalContext
  },
  dismissCallback
}) => {
  var _a;
  const [isOpen, setIsOpen] = React69.useState(true);
  const {
    cache
  } = useApolloClient5();
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const {
    bodyTheme,
    layout
  } = React69.useContext(BannerThemeStateContext);
  const {
    notificationLocation,
    revealActions,
    customQrCode,
    dismiss,
    type
  } = data;
  const isQrCodeEnabled = ((_a = customQrCode == null ? void 0 : customQrCode.image) == null ? void 0 : _a.url) || (customQrCode == null ? void 0 : customQrCode.encodedImage);
  const onClickDismiss = () => {
    dismissCallback == null ? void 0 : dismissCallback();
    customerNotificationActionsExecutor(dismiss == null ? void 0 : dismiss.actions);
    cacheEviction(cache, type, notificationLocation);
    setIsOpen(false);
  };
  React69.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  return /* @__PURE__ */React69.createElement(React69.Fragment, null, isOpen && /* @__PURE__ */React69.createElement(Viewport8, null, /* @__PURE__ */React69.createElement(ViewSmall8, null, /* @__PURE__ */React69.createElement(SheetWrapperComponent, {
    isVisible: isOpen,
    sheetType: type,
    onDismiss: onClickDismiss,
    dismiss
  }, /* @__PURE__ */React69.createElement(EGDSViewRow5, {
    canvasTheme: bodyTheme,
    layout: "centered"
  }, /* @__PURE__ */React69.createElement(EGDSSheetServerSideRenderContent2, {
    padded: false
  }, /* @__PURE__ */React69.createElement(EGDSSpacing22, {
    padding: {
      block: "six"
    }
  }, /* @__PURE__ */React69.createElement(SheetFlexLayout, __spreadValues({
    layout,
    onClickDismiss
  }, data))))))), /* @__PURE__ */React69.createElement(ViewMedium7, null, /* @__PURE__ */React69.createElement(SheetWrapperComponent, {
    isVisible: isOpen,
    sheetType: type,
    dismiss,
    onDismiss: onClickDismiss
  }, /* @__PURE__ */React69.createElement(EGDSViewRow5, {
    canvasTheme: bodyTheme,
    layout: "centered"
  }, /* @__PURE__ */React69.createElement(EGDSSheetServerSideRenderContent2, {
    padded: false,
    fullSheetContentMaxWidth: "extra-large"
  }, /* @__PURE__ */React69.createElement(EGDSSpacing22, {
    padding: {
      blockstart: isQrCodeEnabled ? "sixteen" : "eight",
      blockend: "six",
      inline: "six"
    }
  }, isQrCodeEnabled ? /* @__PURE__ */React69.createElement(SheetGridLayout, __spreadValues({
    isQrCodeEnabled,
    layout,
    onClickDismiss
  }, data)) : /* @__PURE__ */React69.createElement(SheetFlexLayout, __spreadValues({
    layout,
    onClickDismiss
  }, data)))))))));
};

// src/components/takeover-banner/takeover-banner-wrapper.tsx
import React71 from "react";

// src/components/takeover-banner/takeover-banner.tsx
import React70 from "react";
import { EGDSButtonSize as EGDSButtonSize10, EGDSOverlayButton as EGDSOverlayButton4, EGDSPrimaryButton as EGDSPrimaryButton5 } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon8 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex19, EGDSLayoutFlexItem as EGDSLayoutFlexItem19 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink13 } from "@egds/react-core/link";
import { EGDSSpacing as EGDSSpacing23 } from "@egds/react-core/spacing";
import { EGDSText as EGDSText24 } from "@egds/react-core/text";
import { EGDSView, EGDSViewRow as EGDSViewRow6 } from "@egds/react-core/view";
import { useApolloClient as useApolloClient6 } from "@shared-ui/apollo-client-wrapper";
var TakeoverBanner = ({
  type,
  notificationLocation,
  title,
  revealActions,
  logo,
  bannerLink,
  dismiss,
  referer,
  legalText
}) => {
  var _a, _b, _c;
  const [display, setDisplay] = React70.useState(true);
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const {
    cache
  } = useApolloClient6();
  React70.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const onClickDismiss = () => {
    setDisplay(false);
    customerNotificationActionsExecutor(dismiss.actions);
    cacheEviction(cache, type, notificationLocation);
  };
  const onClickButton = () => {
    customerNotificationActionsExecutor(bannerLink == null ? void 0 : bannerLink.actions);
  };
  if (!display) {
    return null;
  }
  const deepLinkUrl = createDeepLinkUrl((_a = bannerLink == null ? void 0 : bannerLink.uri) == null ? void 0 : _a.value, referer);
  return /* @__PURE__ */React70.createElement(EGDSView, null, /* @__PURE__ */React70.createElement(EGDSSpacing23, {
    padding: "six"
  }, /* @__PURE__ */React70.createElement(EGDSViewRow6, {
    canvasTheme: "brand_promo_primary",
    layout: "fullwidth"
  }, /* @__PURE__ */React70.createElement(EGDSLayoutFlex19, {
    direction: "column",
    blockSize: "full_size",
    justifyContent: "space-between"
  }, /* @__PURE__ */React70.createElement(EGDSLayoutFlexItem19, {
    alignSelf: "end"
  }, /* @__PURE__ */React70.createElement(EGDSOverlayButton4, {
    onClick: onClickDismiss,
    "aria-label": "close"
  }, /* @__PURE__ */React70.createElement(EGDSIcon8, {
    name: "close"
  }))), /* @__PURE__ */React70.createElement(EGDSLayoutFlexItem19, {
    alignSelf: "center"
  }, /* @__PURE__ */React70.createElement("img", {
    alt: logo.description,
    src: logo.url,
    width: "64",
    height: "64"
  })), /* @__PURE__ */React70.createElement(EGDSLayoutFlexItem19, null, /* @__PURE__ */React70.createElement(EGDSSpacing23, {
    margin: {
      blockstart: "six"
    }
  }, (_b = title == null ? void 0 : title.items) == null ? void 0 : _b.map(({
    text
  }, index) => /* @__PURE__ */React70.createElement(EGDSText24, {
    key: `text-element-${index}`,
    theme: "inverse",
    align: "center",
    size: 700,
    weight: "medium"
  }, text)))), (bannerLink == null ? void 0 : bannerLink.uri) && /* @__PURE__ */React70.createElement(EGDSLayoutFlexItem19, {
    alignSelf: "center"
  }, /* @__PURE__ */React70.createElement(EGDSSpacing23, {
    margin: {
      blockstart: "six",
      blockend: "three"
    }
  }, /* @__PURE__ */React70.createElement(EGDSPrimaryButton5, {
    inverse: true,
    href: deepLinkUrl,
    size: EGDSButtonSize10.LARGE,
    onClick: onClickButton
  }, bannerLink.text))), (_c = legalText == null ? void 0 : legalText.items) == null ? void 0 : _c.map((item, index) => (item == null ? void 0 : item.__typename) === "NotificationPhraseLinkNode" && (item == null ? void 0 : item.uri) && item.uri.value && /* @__PURE__ */React70.createElement(EGDSLink13, {
    align: "center",
    inline: true,
    key: `uitkLink-element-${index}`
  }, /* @__PURE__ */React70.createElement("a", {
    href: item.uri.value,
    key: `text-element-${index}`,
    target: "_blank",
    rel: "noopener"
  }, /* @__PURE__ */React70.createElement(EGDSText24, {
    key: `text-element-${index}`,
    theme: "inverse"
  }, item.text))))))));
};
TakeoverBanner.displayName = "TakeoverBanner";

// src/components/takeover-banner/takeover-banner-wrapper.tsx
var TakeoverBannerWrapper = props => {
  const {
    data: {
      type,
      notificationLocation,
      title,
      logo,
      links,
      dismiss,
      revealActions,
      legalText
    },
    inputs: {
      optionalContext
    }
  } = props || {};
  if (!title || !logo || !dismiss) {
    return null;
  }
  let bannerLink;
  links == null ? void 0 : links.forEach(link => {
    if (link.type === "APP_DOWNLOAD_LINK" /* APP_DOWNLOAD_LINK */) {
      bannerLink = link;
    }
  });
  return /* @__PURE__ */React71.createElement(TakeoverBanner, {
    type,
    notificationLocation,
    title,
    logo,
    bannerLink,
    revealActions,
    dismiss,
    referer: optionalContext == null ? void 0 : optionalContext.referer,
    legalText
  });
};

// src/components/travel-advisory/travel-advisory-wrapper.tsx
import React73 from "react";

// src/components/travel-advisory/travel-advisory.tsx
import React72 from "react";
import { EGDSBanner } from "@egds/react-core/banner";
import { EGDSIcon as EGDSIcon9 } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex20, EGDSLayoutFlexItem as EGDSLayoutFlexItem20 } from "@egds/react-core/layout-flex";
import { EGDSLink as EGDSLink14 } from "@egds/react-core/link";
import { EGDSList as EGDSList5, EGDSListItem as EGDSListItem5 } from "@egds/react-core/list";
import { EGDSSheetTransition as EGDSSheetTransition4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing24 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading10, EGDSText as EGDSText25 } from "@egds/react-core/text";
import { useSignalSubscriber } from "@shared-ui/core-signal-manager/context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { CustomerTravelAdvisoryHideSignal } from "@shared-ui/retail-signals-customer";
var TravelAdvisory = props => {
  const {
    heading,
    message,
    icon,
    links,
    revealActions,
    queryInputs,
    actionCallback,
    bodyA11yLabel
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const [display, setDisplay] = React72.useState(true);
  const [isDialogOpen, dialogActions, DialogComponent] = useDialog2("multi-advisory-dialog");
  useSignalSubscriber("TRAVEL_ADVISORY_HIDE", CustomerTravelAdvisoryHideSignal, {
    onSuccess: () => {
      setDisplay(false);
    }
  });
  React72.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  if (!display) {
    return null;
  }
  const onClickLink = link => e => {
    var _a;
    customerNotificationActionsExecutor(link.actions);
    actionCallback == null ? void 0 : actionCallback({
      id: link.id,
      notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */,
      notificationLocation: queryInputs.notificationLocation,
      notificationLinkType: link.type
    });
    if (!((_a = link.uri) == null ? void 0 : _a.value) && link.id !== "open_multi_advisory_popup") {
      e.preventDefault();
      e.stopPropagation();
      setDisplay(false);
    } else if (link.id === "open_multi_advisory_popup") {
      dialogActions.openDialog();
    }
  };
  const dialogActionCallback = action => {
    if (action.id === "close_multi_advisory_popup" || action.id === "notification-not-found-error" || action.id === "notification-validation-error" || action.id === "notification-network-error") {
      dialogActions.closeDialog();
    }
    actionCallback == null ? void 0 : actionCallback(action);
  };
  const linkComponents = links == null ? void 0 : links.map((link, index) => /* @__PURE__ */React72.createElement(EGDSListItem5, {
    key: index
  }, /* @__PURE__ */React72.createElement(EGDSLink14, {
    onClick: onClickLink(link),
    inline: true
  }, link.uri ? /* @__PURE__ */React72.createElement("a", {
    href: link.uri.value,
    target: "_blank",
    rel: "noopener"
  }, link.text) : /* @__PURE__ */React72.createElement("button", {
    type: "button"
  }, link.text))));
  return /* @__PURE__ */React72.createElement("div", {
    role: "region",
    "aria-label": bodyA11yLabel || void 0
  }, isDialogOpen && /* @__PURE__ */React72.createElement(EGDSSheetTransition4, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React72.createElement(DialogComponent, null, /* @__PURE__ */React72.createElement(CustomerNotification, {
    inputs: __spreadProps(__spreadValues({}, queryInputs), {
      notificationLocation: "POPUP" /* POPUP */
    }),
    actionCallback: dialogActionCallback
  }))), /* @__PURE__ */React72.createElement(EGDSBanner, null, /* @__PURE__ */React72.createElement(EGDSSpacing24, {
    padding: {
      block: "one"
    }
  }, /* @__PURE__ */React72.createElement(EGDSLayoutFlex20, {
    alignItems: "center",
    space: "two"
  }, icon && /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React72.createElement(EGDSSpacing24, {
    margin: {
      inlinestart: "four",
      inlineend: "six"
    }
  }, /* @__PURE__ */React72.createElement(EGDSIcon9, {
    name: icon.iconName,
    description: icon.iconDescription,
    title: icon.iconTitle
  }))), /* @__PURE__ */React72.createElement(EGDSLayoutFlexItem20, null, /* @__PURE__ */React72.createElement("div", null, /* @__PURE__ */React72.createElement(EGDSHeading10, {
    tag: "h4"
  }, heading.heading), /* @__PURE__ */React72.createElement(EGDSText25, null, message), /* @__PURE__ */React72.createElement(EGDSList5, {
    bullet: "no-bullet",
    orientation: "inline"
  }, linkComponents)))))));
};
TravelAdvisory.displayName = "sharedui-TravelAdvisory";

// src/components/travel-advisory/travel-advisory-wrapper.tsx
var TravelAdvisoryWrapper = props => {
  var _a, _b, _c, _d, _e, _f;
  const {
    data,
    inputs,
    actionCallback
  } = props;
  const {
    title,
    body,
    links,
    revealActions,
    icon
  } = data;
  const heading = (_b = (_a = title == null ? void 0 : title.items) == null ? void 0 : _a[0]) == null ? void 0 : _b.text;
  const accessibilityHeading = title == null ? void 0 : title.accessibilityLabel;
  const message = (_d = (_c = body == null ? void 0 : body[0]) == null ? void 0 : _c.items[0]) == null ? void 0 : _d.text;
  const bodyA11yLabel = (_e = body == null ? void 0 : body[0]) == null ? void 0 : _e.accessibilityLabel;
  const possibleLinks = links == null ? void 0 : links.slice(0, 2);
  const iconDescription = (icon == null ? void 0 : icon.description) || "";
  const iconTitle = (icon == null ? void 0 : icon.title) || "";
  if (!message) {
    return null;
  }
  return /* @__PURE__ */React73.createElement(TravelAdvisory, {
    heading: {
      heading,
      accessibilityHeading
    },
    message,
    icon: {
      iconName: (_f = icon == null ? void 0 : icon.id) != null ? _f : "warning",
      iconDescription,
      iconTitle
    },
    links: possibleLinks,
    revealActions,
    queryInputs: inputs,
    actionCallback,
    bodyA11yLabel
  });
};

// src/components/travel-advisory-dialog/travel-advisory-dialog-wrapper.tsx
import React76 from "react";

// src/components/travel-advisory-dialog/travel-advisory-dialog.tsx
import React75 from "react";
import { EGDSSheet as EGDSSheet4, EGDSSheetContent as EGDSSheetContent4 } from "@egds/react-core/sheet";
import { EGDSSpacing as EGDSSpacing25 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading12 } from "@egds/react-core/text";
import { EGDSToolbar } from "@egds/react-core/toolbar";

// src/components/travel-advisory-dialog/travel-advisory-dialog-item.tsx
import React74 from "react";
import { EGDSLink as EGDSLink15 } from "@egds/react-core/link";
import { EGDSHeading as EGDSHeading11 } from "@egds/react-core/text";
var TravelAdvisoryDialogItem = props => {
  const {
    index,
    separator,
    heading,
    message,
    possibleLink,
    actionCallback
  } = props;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const onClickLink = link => () => {
    customerNotificationActionsExecutor(link.actions);
    actionCallback == null ? void 0 : actionCallback({
      id: link.id,
      notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */,
      notificationLocation: "POPUP" /* POPUP */,
      notificationLinkType: link.type
    });
  };
  return /* @__PURE__ */React74.createElement(React74.Fragment, {
    key: index
  }, heading !== "" && /* @__PURE__ */React74.createElement(EGDSHeading11, {
    tag: "h3",
    size: 6
  }, /* @__PURE__ */React74.createElement("span", {
    "data-stid": `customer-notification__travel-advisory-dialog-messages-heading-${index}`
  }, heading)), /* @__PURE__ */React74.createElement("p", {
    "data-stid": `customer-notification__travel-advisory-dialog-messages-message-${index}`
  }, message), possibleLink && possibleLink.__typename === "NotificationPhraseLinkNode" && possibleLink.uri && possibleLink.uri.value && /* @__PURE__ */React74.createElement(EGDSLink15, {
    onClick: onClickLink(possibleLink)
  }, /* @__PURE__ */React74.createElement("a", {
    href: possibleLink.uri.value,
    target: "_blank",
    rel: "noopener",
    "data-stid": `customer-notification__travel-advisory-dialog-messages-link-${index}`
  }, possibleLink.text, possibleLink.icon && /* @__PURE__ */React74.createElement("span", {
    className: "is-visually-hidden"
  }, possibleLink.icon.description))), separator && /* @__PURE__ */React74.createElement("hr", null));
};
TravelAdvisoryDialogItem.displayName = "TravelAdvisoryDialogItem";

// src/components/travel-advisory-dialog/travel-advisory-dialog.tsx
var TravelAdvisoryDialog = props => {
  const {
    heading,
    body,
    dismiss,
    revealActions,
    actionCallback
  } = props;
  const triggerRef = React75.useRef(null);
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  React75.useEffect(() => {
    customerNotificationActionsExecutor(revealActions);
  }, []);
  const onCloseDialog = () => {
    customerNotificationActionsExecutor(dismiss.actions);
    actionCallback == null ? void 0 : actionCallback({
      id: "close_multi_advisory_popup",
      notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */,
      notificationLocation: "POPUP" /* POPUP */,
      notificationLinkType: "BUTTON" /* BUTTON */
    });
  };
  return /* @__PURE__ */React75.createElement(EGDSSheet4, {
    type: "full",
    isVisible: true,
    triggerRef,
    returnFocusOnClose: true
  }, /* @__PURE__ */React75.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: onCloseDialog,
      navIconLabel: dismiss.icon.description,
      navType: "close"
    }
  }), /* @__PURE__ */React75.createElement(EGDSSheetContent4, null, heading && /* @__PURE__ */React75.createElement(EGDSHeading12, {
    tag: "h2",
    size: 3
  }, heading), /* @__PURE__ */React75.createElement(EGDSSpacing25, {
    margin: {
      blockstart: "twelve"
    }
  }, /* @__PURE__ */React75.createElement("div", {
    "data-stid": "customer-notification__travel-advisory-dialog-messages"
  }, body.map((bodyElement, index) => {
    var _a, _b, _c, _d;
    return /* @__PURE__ */React75.createElement(TravelAdvisoryDialogItem, {
      key: index,
      index,
      separator: index < body.length - 1,
      heading: (_b = (_a = bodyElement.items[0]) == null ? void 0 : _a.text) != null ? _b : "",
      message: (_d = (_c = bodyElement.items[1]) == null ? void 0 : _c.text) != null ? _d : "",
      possibleLink: bodyElement.items[2],
      actionCallback
    });
  })))));
};
TravelAdvisoryDialog.displayName = "sharedui-TravelAdvisoryDialog";

// src/components/travel-advisory-dialog/travel-advisory-dialog-wrapper.tsx
var TravelAdvisoryDialogWrapper = props => {
  var _a;
  const {
    data,
    actionCallback
  } = props;
  const {
    title,
    body,
    dismiss,
    revealActions
  } = data || {};
  if (!body || !dismiss) {
    actionCallback == null ? void 0 : actionCallback({
      id: "notification-validation-error",
      notificationLocation: "POPUP" /* POPUP */,
      notificationType: "TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */
    });
    return null;
  }
  return /* @__PURE__ */React76.createElement(TravelAdvisoryDialog, {
    heading: (_a = title == null ? void 0 : title.items[0]) == null ? void 0 : _a.text,
    body,
    dismiss,
    revealActions,
    actionCallback
  });
};

// src/components/trust-message/trust-message-wrapper.tsx
import React81 from "react";
import { EGDSMarkSize } from "@egds/react-core/mark";
import { EGDSText as EGDSText27 } from "@egds/react-core/text";
import { EGDSThemeProvider as EGDSThemeProvider2 } from "@egds/react-core/utils";

// src/components/trust-message/trust-message.tsx
import React77 from "react";
import { EGDSCard as EGDSCard10 } from "@egds/react-core/cards";
import { EGDSIcon as EGDSIcon10, EGDSIconSize as EGDSIconSize6 } from "@egds/react-core/icons";
import { EGDSIllustrations } from "@egds/react-core/illustrations";
import { EGDSLayoutFlex as EGDSLayoutFlex21, EGDSLayoutFlexItem as EGDSLayoutFlexItem21 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGridItem as EGDSLayoutGridItem8 } from "@egds/react-core/layout-grid";
import { EGDSLink as EGDSLink16 } from "@egds/react-core/link";
import { EGDSMark as EGDSMark7 } from "@egds/react-core/mark";
import { EGDSSpacing as EGDSSpacing26 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading13, EGDSText as EGDSText26 } from "@egds/react-core/text";
import { EGDSThemeProvider } from "@egds/react-core/utils";
import { IntersectionTracker } from "@shared-ui/clickstream-analytics-context";
var TrustMessage = props => {
  var _a, _b, _c, _d, _e, _f;
  const {
    graphicElement,
    markSize,
    illustrationSize,
    title,
    body,
    links,
    layout,
    view,
    impressionAnalytics,
    isIllustration
  } = props;
  const titleItem = ((_a = title.egdsItems[0]) == null ? void 0 : _a.__typename) === "NotificationEGDSTextNode" ? title.egdsItems[0] : null;
  const titleText = titleItem == null ? void 0 : titleItem.text;
  const titleTheme = (_b = titleItem == null ? void 0 : titleItem.theme) != null ? _b : void 0;
  const titleWeight = (_c = titleItem == null ? void 0 : titleItem.weight) != null ? _c : void 0;
  const bodyItem = (_d = body == null ? void 0 : body[0]) == null ? void 0 : _d.egdsItems[0];
  const bodyText = bodyItem && "text" in bodyItem && bodyItem.text;
  const bodyTheme = bodyItem && "theme" in bodyItem && bodyItem.theme || void 0;
  const bodyWeight = bodyItem && "weight" in bodyItem && bodyItem.weight || void 0;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const usedTexts = /* @__PURE__ */React77.createElement(React77.Fragment, null, titleText && /* @__PURE__ */React77.createElement(EGDSHeading13, {
    tag: "h3"
  }, /* @__PURE__ */React77.createElement(EGDSText26, {
    align: "left",
    size: 400,
    spacing: layout !== "WITH_BORDER" ? "two" : void 0,
    theme: titleTheme && EGDSTextThemeMap[titleTheme],
    weight: titleWeight && EGDSTextWeightMap[titleWeight]
  }, titleText)), bodyText && /* @__PURE__ */React77.createElement(EGDSText26, {
    align: "left",
    size: 300,
    spacing: layout !== "WITH_BORDER" ? "two" : "one",
    theme: bodyTheme && EGDSTextThemeMap[bodyTheme],
    weight: bodyWeight && EGDSTextWeightMap[bodyWeight]
  }, bodyText));
  const usedLinks = links == null ? void 0 : links.map((linkItem, index) => {
    var _a2;
    const {
      actions
    } = linkItem;
    const onClickButton = () => {
      customerNotificationActionsExecutor(actions);
    };
    return /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, {
      key: index,
      alignSelf: "start"
    }, linkItem.uri && /* @__PURE__ */React77.createElement(EGDSLink16, {
      onClick: onClickButton
    }, /* @__PURE__ */React77.createElement("a", {
      href: linkItem.uri.value,
      target: (linkItem == null ? void 0 : linkItem.target) === "SAME_TAB" /* SAME_TAB */ ? "_self" : "_blank",
      rel: "noopener",
      "aria-label": (_a2 = linkItem == null ? void 0 : linkItem.accessibilityLabel) != null ? _a2 : void 0
    }, linkItem.text)));
  });
  const usedGraphics = /* @__PURE__ */React77.createElement(React77.Fragment, null, (graphicElement == null ? void 0 : graphicElement.__typename) === "Mark" && /* @__PURE__ */React77.createElement(EGDSMark7, {
    name: graphicElement.id,
    url: (_e = graphicElement.url) == null ? void 0 : _e.value,
    description: graphicElement.description,
    size: markSize != null ? markSize : 12
  }), (graphicElement == null ? void 0 : graphicElement.__typename) === "Icon" && /* @__PURE__ */React77.createElement(EGDSIcon10, {
    id: Math.random().toString(),
    description: graphicElement.description,
    name: graphicElement.id,
    size: graphicElement.size ? EGDSIconSize6[graphicElement.size] : EGDSIconSize6.MEDIUM,
    theme: (_f = graphicElement.theme) != null ? _f : void 0,
    spotlight: graphicElement.withBackground ? "positive" : void 0
  }), (graphicElement == null ? void 0 : graphicElement.__typename) === "Illustration" && /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, {
    maxWidth: illustrationSize
  }, /* @__PURE__ */React77.createElement(EGDSIllustrations, {
    url: graphicElement.link,
    alt: graphicElement.description
  })));
  const getLayout = cardLayout => {
    switch (cardLayout) {
      case "ICON_ON_SIDE":
        return /* @__PURE__ */React77.createElement(EGDSCard10, {
          padded: true
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
          alignItems: "center",
          space: "two"
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, null, usedGraphics), /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, {
          alignSelf: "center"
        }, /* @__PURE__ */React77.createElement("div", null, usedTexts, links && /* @__PURE__ */React77.createElement(EGDSSpacing26, {
          padding: {
            blockstart: "two"
          }
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
          alignItems: "center"
        }, usedLinks))))));
      case "ICON_ON_TOP":
        return /* @__PURE__ */React77.createElement(EGDSCard10, {
          padded: true
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
          alignItems: "center",
          space: "two"
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, null, usedGraphics)), usedTexts, usedLinks);
      case "WITH_BORDER":
        return /* @__PURE__ */React77.createElement(EGDSCard10, {
          border: true
        }, /* @__PURE__ */React77.createElement(EGDSSpacing26, {
          padding: "six"
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
          alignItems: "start",
          blockSize: "full_size"
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, null, usedGraphics), /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */React77.createElement(EGDSSpacing26, {
          margin: {
            inlinestart: "two"
          }
        }, /* @__PURE__ */React77.createElement("div", null, usedTexts, links && /* @__PURE__ */React77.createElement(EGDSSpacing26, {
          margin: {
            blockstart: "one"
          }
        }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
          alignItems: "center"
        }, usedLinks))))))));
      default:
        return null;
    }
  };
  const carouselView = impressionAnalytics && impressionAnalytics.__typename === "NotificationAnalytics" ? /* @__PURE__ */React77.createElement(IntersectionTracker, {
    tag: "section",
    referrerId: impressionAnalytics == null ? void 0 : impressionAnalytics.referrerId,
    linkName: (impressionAnalytics == null ? void 0 : impressionAnalytics.description) ? impressionAnalytics == null ? void 0 : impressionAnalytics.description : "",
    intersectionOptions: {
      threshold: 0.5
    }
  }, usedTexts, links && /* @__PURE__ */React77.createElement(EGDSSpacing26, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
    alignItems: "center"
  }, usedLinks))) : null;
  const gridView = /* @__PURE__ */React77.createElement("div", null, usedTexts, links && /* @__PURE__ */React77.createElement(EGDSSpacing26, {
    margin: {
      blockstart: "one"
    }
  }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
    alignItems: "center"
  }, usedLinks)));
  const setView = /* @__PURE__ */React77.createElement(EGDSThemeProvider, {
    config: {
      lightMode: {
        colorTheme: "light-1",
        isGradient: true
      },
      darkMode: {
        colorTheme: "light-1",
        isGradient: true
      }
    },
    isColorThemeContainer: true
  }, /* @__PURE__ */React77.createElement(EGDSCard10, null, /* @__PURE__ */React77.createElement(EGDSSpacing26, {
    padding: isIllustration ? void 0 : "six"
  }, /* @__PURE__ */React77.createElement(EGDSLayoutFlex21, {
    alignItems: "start",
    blockSize: "full_size"
  }, /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, null, usedGraphics), /* @__PURE__ */React77.createElement(EGDSLayoutFlexItem21, null, /* @__PURE__ */React77.createElement(EGDSSpacing26, {
    margin: {
      inlinestart: view === "GRID_EXTENDED_PADDING" /* GRID_EXTENDED_PADDING */ ? "four" : "two"
    }
  }, view === "CAROUSEL" /* CAROUSEL */ ? carouselView : gridView))))));
  switch (view) {
    case "CAROUSEL" /* CAROUSEL */:
    case "GRID" /* GRID */:
    case "GRID_EXTENDED_PADDING" /* GRID_EXTENDED_PADDING */:
      return /* @__PURE__ */React77.createElement(EGDSLayoutGridItem8, null, setView);
    default:
      return /* @__PURE__ */React77.createElement("li", null, /* @__PURE__ */React77.createElement(EGDSLayoutGridItem8, null, getLayout(layout)));
  }
};
TrustMessage.displayName = "sharedui-TrustMessage";

// src/components/trust-message/trust-message-carousel.tsx
import React78 from "react";
import { EGDSCard as EGDSCard11 } from "@egds/react-core/cards";
import { EGDSCarousel } from "@egds/react-core/carousel";
import { EGDSLayoutFlex as EGDSLayoutFlex22, EGDSLayoutFlexItem as EGDSLayoutFlexItem22 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing27 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading14 } from "@egds/react-core/text";
import { ViewMedium as ViewMedium8, Viewport as Viewport9, ViewSmall as ViewSmall9 } from "@shared-ui/viewport-context";
var TrustMessageWithCarousel = ({
  messageCards,
  heading
}) => {
  const titleItem = heading == null ? void 0 : heading.egdsItems[0];
  const weightProp = titleItem && "weight" in titleItem && titleItem.weight;
  const themeProp = titleItem && "theme" in titleItem && titleItem.theme;
  const carouselItem = /* @__PURE__ */React78.createElement(EGDSCarousel, {
    buttonText: {
      prevButton: "",
      nextButton: ""
    },
    itemsMaxHeight: true,
    itemsVisible: {
      sm: 1,
      md: 3,
      lg: 3
    },
    peek: true,
    hideNav: true
  }, messageCards);
  return /* @__PURE__ */React78.createElement(Viewport9, null, /* @__PURE__ */React78.createElement(ViewSmall9, null, /* @__PURE__ */React78.createElement(EGDSSpacing27, {
    padding: {
      block: "six",
      inlinestart: "six",
      inlineend: "three"
    }
  }, /* @__PURE__ */React78.createElement(EGDSCard11, null, /* @__PURE__ */React78.createElement(EGDSLayoutFlex22, {
    space: "two",
    direction: "column"
  }, (heading == null ? void 0 : heading.completeText) && /* @__PURE__ */React78.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */React78.createElement(EGDSSpacing27, {
    padding: {
      inlineend: "one"
    }
  }, /* @__PURE__ */React78.createElement(EGDSHeading14, {
    tag: "h2",
    typeStyle: {
      customStyle: "display-small",
      customTheme: "standard"
    }
  }, /* @__PURE__ */React78.createElement(EGDSStylizedText, {
    weight: weightProp ? TextWeight[weightProp] : "REGULAR" /* REGULAR */,
    size: "500",
    theme: themeProp ? TextTheme[themeProp] : "PRIMARY" /* PRIMARY */,
    text: heading.completeText,
    overflow: "wrap"
  })))), /* @__PURE__ */React78.createElement(EGDSLayoutFlexItem22, null, /* @__PURE__ */React78.createElement(EGDSSpacing27, {
    margin: {
      blockstart: "three"
    }
  }, carouselItem)))))), /* @__PURE__ */React78.createElement(ViewMedium8, null, /* @__PURE__ */React78.createElement(EGDSCard11, null, /* @__PURE__ */React78.createElement(EGDSSpacing27, {
    padding: {
      block: "three",
      inlineend: "three"
    }
  }, /* @__PURE__ */React78.createElement(EGDSLayoutFlex22, {
    alignItems: "center",
    space: "four"
  }, (heading == null ? void 0 : heading.completeText) && /* @__PURE__ */React78.createElement(EGDSLayoutFlexItem22, {
    maxWidth: "76x"
  }, /* @__PURE__ */React78.createElement(EGDSSpacing27, {
    padding: {
      inlinestart: "twelve"
    },
    margin: {
      inlineend: "six"
    }
  }, /* @__PURE__ */React78.createElement(EGDSHeading14, {
    tag: "h2",
    typeStyle: {
      customStyle: "display-small",
      customTheme: "standard"
    }
  }, /* @__PURE__ */React78.createElement(EGDSStylizedText, {
    weight: weightProp ? TextWeight[weightProp] : "REGULAR" /* REGULAR */,
    size: "600",
    theme: themeProp ? TextTheme[themeProp] : "PRIMARY" /* PRIMARY */,
    text: heading.completeText
  })))), /* @__PURE__ */React78.createElement(EGDSLayoutFlexItem22, null, carouselItem))))));
};
TrustMessageWithCarousel.displayName = "sharedui-TrustMessageWithCarousel";

// src/components/trust-message/trust-message-grid.tsx
import React79 from "react";
import { EGDSCard as EGDSCard12 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid10, EGDSLayoutGridItem as EGDSLayoutGridItem9 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing28 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading15 } from "@egds/react-core/text";
import { EGDSViewRow as EGDSViewRow7 } from "@egds/react-core/view";
import { IntersectionTracker as IntersectionTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge4, ViewMedium as ViewMedium9, Viewport as Viewport10, ViewSmall as ViewSmall10 } from "@shared-ui/viewport-context";
var TrustMessageWithGrid = ({
  messageCards,
  isInlineHeading,
  trustMessageHeading,
  columnNumber,
  title,
  impressionAnalytics,
  isIllustration
}) => {
  var _a, _b;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const notificationAnalytics = impressionAnalytics == null ? void 0 : impressionAnalytics.find(item => item.__typename === "NotificationAnalytics");
  React79.useEffect(() => {
    if (!notificationAnalytics) {
      customerNotificationActionsExecutor(impressionAnalytics);
    }
  }, []);
  const titleItem = title == null ? void 0 : title.egdsItems[0];
  const weightProp = titleItem && "weight" in titleItem && titleItem.weight;
  const themeProp = titleItem && "theme" in titleItem && titleItem.theme;
  return /* @__PURE__ */React79.createElement(IntersectionTracker2, {
    tag: "section",
    referrerId: (_a = notificationAnalytics == null ? void 0 : notificationAnalytics.referrerId) != null ? _a : "",
    linkName: (_b = notificationAnalytics == null ? void 0 : notificationAnalytics.description) != null ? _b : ""
  }, !isInlineHeading && /* @__PURE__ */React79.createElement(Viewport10, null, /* @__PURE__ */React79.createElement(ViewSmall10, null, /* @__PURE__ */React79.createElement(EGDSHeading15, {
    size: 3
  }, trustMessageHeading)), /* @__PURE__ */React79.createElement(ViewMedium9, null, /* @__PURE__ */React79.createElement(EGDSHeading15, {
    size: 4
  }, trustMessageHeading))), columnNumber > 0 && /* @__PURE__ */React79.createElement(Viewport10, null, /* @__PURE__ */React79.createElement(ViewSmall10, null, isInlineHeading ? /* @__PURE__ */React79.createElement(EGDSViewRow7, {
    layout: "fullwidth"
  }, /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    padding: isIllustration ? void 0 : {
      blockstart: "four",
      blockend: "four"
    }
  }, /* @__PURE__ */React79.createElement("div", null, titleItem && "text" in titleItem && /* @__PURE__ */React79.createElement(EGDSHeading15, {
    tag: "h2",
    typeStyle: {
      customStyle: "display-small",
      customTheme: "standard"
    }
  }, /* @__PURE__ */React79.createElement(EGDSStylizedText, {
    weight: weightProp ? TextWeight[weightProp] : "REGULAR" /* REGULAR */,
    size: "600",
    theme: themeProp ? TextTheme[themeProp] : "PRIMARY" /* PRIMARY */,
    text: titleItem.text
  })), /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    padding: isIllustration ? void 0 : "six"
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGrid10, {
    columns: 1,
    space: "four",
    tag: "ul"
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGridItem9, {
    alignSelf: "center"
  }), messageCards))))) : /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGrid10, {
    columns: 1,
    space: "four",
    tag: "ul"
  }, messageCards))), /* @__PURE__ */React79.createElement(ViewMedium9, null, isInlineHeading ? /* @__PURE__ */React79.createElement(EGDSCard12, null, /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    padding: isIllustration ? "three" : "four"
  }, /* @__PURE__ */React79.createElement("div", null, titleItem && "text" in titleItem && /* @__PURE__ */React79.createElement(EGDSHeading15, {
    tag: "h2",
    typeStyle: {
      customStyle: "display-small",
      customTheme: "standard"
    }
  }, /* @__PURE__ */React79.createElement(EGDSStylizedText, {
    weight: weightProp ? TextWeight[weightProp] : "REGULAR" /* REGULAR */,
    size: "600",
    theme: themeProp ? TextTheme[themeProp] : "PRIMARY" /* PRIMARY */,
    text: titleItem.text
  })), /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    padding: {
      blockstart: isIllustration ? void 0 : "six"
    }
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGrid10, {
    columns: 3,
    space: "four",
    tag: "ul"
  }, messageCards))))) : /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGrid10, {
    columns: 2,
    space: "four",
    tag: "ul"
  }, messageCards))), /* @__PURE__ */React79.createElement(ViewLarge4, null, isInlineHeading ? /* @__PURE__ */React79.createElement(EGDSCard12, null, /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    padding: isIllustration ? void 0 : "four"
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGrid10, {
    columns: titleItem ? columnNumber + 1 : columnNumber,
    space: "four",
    tag: "ul"
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGridItem9, {
    alignSelf: "center"
  }, /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    padding: {
      block: "three",
      inlinestart: "six",
      inlineend: "four"
    }
  }, titleItem && "text" in titleItem && /* @__PURE__ */React79.createElement("li", null, /* @__PURE__ */React79.createElement(EGDSHeading15, {
    tag: "h2",
    typeStyle: {
      customStyle: "display-small",
      customTheme: "standard"
    }
  }, /* @__PURE__ */React79.createElement(EGDSStylizedText, {
    weight: weightProp ? TextWeight[weightProp] : "REGULAR" /* REGULAR */,
    size: "600",
    theme: themeProp ? TextTheme[themeProp] : "PRIMARY" /* PRIMARY */,
    align: "left",
    text: titleItem.text
  }))))), messageCards))) : /* @__PURE__ */React79.createElement(EGDSSpacing28, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React79.createElement(EGDSLayoutGrid10, {
    columns: columnNumber,
    space: "four",
    tag: "ul"
  }, messageCards)))));
};
TrustMessageWithGrid.displayName = "TrustMessageWithGrid";

// src/components/trust-message/trust-message-grid-extended-padding.tsx
import React80 from "react";
import { EGDSCard as EGDSCard13 } from "@egds/react-core/cards";
import { EGDSLayoutGrid as EGDSLayoutGrid11 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing29 } from "@egds/react-core/spacing";
import { ViewRow } from "@egds/react-search-experience";
import { IntersectionTracker as IntersectionTracker3 } from "@shared-ui/clickstream-analytics-context";
import { ViewLarge as ViewLarge5, ViewMedium as ViewMedium10, Viewport as Viewport11, ViewSmall as ViewSmall11 } from "@shared-ui/viewport-context";
var TrustMessageWithExtendedPaddingGrid = ({
  messageCards,
  columnNumber,
  impressionAnalytics
}) => {
  var _a, _b;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const notificationAnalytics = impressionAnalytics == null ? void 0 : impressionAnalytics.find(item => item.__typename === "NotificationAnalytics");
  React80.useEffect(() => {
    if (!notificationAnalytics) {
      customerNotificationActionsExecutor(impressionAnalytics);
    }
  }, []);
  return /* @__PURE__ */React80.createElement(IntersectionTracker3, {
    tag: "section",
    referrerId: (_a = notificationAnalytics == null ? void 0 : notificationAnalytics.referrerId) != null ? _a : "",
    linkName: (_b = notificationAnalytics == null ? void 0 : notificationAnalytics.description) != null ? _b : ""
  }, columnNumber > 0 && /* @__PURE__ */React80.createElement(Viewport11, null, /* @__PURE__ */React80.createElement(ViewSmall11, null, /* @__PURE__ */React80.createElement(EGDSSpacing29, {
    margin: {
      block: "eight",
      inline: "unset"
    }
  }, /* @__PURE__ */React80.createElement(ViewRow, {
    canvasTheme: "primary",
    layout: "fullwidth",
    paddedViewRow: false
  }, /* @__PURE__ */React80.createElement(EGDSLayoutGrid11, {
    columns: 1,
    space: "xlarge",
    tag: "ul"
  }, messageCards)))), /* @__PURE__ */React80.createElement(ViewMedium10, null, /* @__PURE__ */React80.createElement(EGDSSpacing29, {
    padding: {
      inline: "six"
    },
    margin: {
      block: "eight"
    }
  }, /* @__PURE__ */React80.createElement(EGDSCard13, null, /* @__PURE__ */React80.createElement(EGDSLayoutGrid11, {
    columns: 3,
    space: "twelve",
    tag: "ul"
  }, messageCards)))), /* @__PURE__ */React80.createElement(ViewLarge5, null, /* @__PURE__ */React80.createElement(EGDSSpacing29, {
    padding: {
      inline: "six"
    },
    margin: {
      blockstart: "eight",
      blockend: "four"
    }
  }, /* @__PURE__ */React80.createElement(EGDSCard13, null, /* @__PURE__ */React80.createElement(EGDSLayoutGrid11, {
    columns: 3,
    space: "twelve",
    tag: "ul"
  }, messageCards))))));
};
TrustMessageWithExtendedPaddingGrid.displayName = "TrustMessageWithExtendedPaddingGrid";

// src/components/trust-message/trust-message-props.tsx
var Theme = /* @__PURE__ */(Theme2 => {
  Theme2["NONE"] = "none";
  Theme2["LIGHT_1"] = "light-1";
  Theme2["DARK_1"] = "dark-1";
  Theme2["BRIGHT_1"] = "bright-1";
  Theme2["GLOBAL_LOW"] = "global-loyalty-low";
  Theme2["GLOBAL_MID"] = "global-loyalty-mid";
  Theme2["GLOBAL_HIGH"] = "global-loyalty-high";
  Theme2["GLOBAL_EXTRA_HIGH"] = "global-loyalty-extra-high";
  return Theme2;
})(Theme || {});

// src/components/trust-message/trust-message-wrapper.tsx
var TrustMessageWrapper = ({
  data
}) => {
  var _a, _b, _c, _d, _e, _f, _g;
  const {
    title,
    subBody,
    bannerContainer,
    revealActions
  } = data || {};
  if (!subBody && !title) {
    return null;
  }
  const titleItem = title == null ? void 0 : title.egdsItems[0];
  const weightProp = titleItem && "weight" in titleItem && titleItem.weight;
  const themeProp = titleItem && "theme" in titleItem && titleItem.theme;
  const cardLayout = ((_a = subBody == null ? void 0 : subBody[0]) == null ? void 0 : _a.__typename) === "NotificationMessageCard" ? subBody[0].layout : null;
  const isInlineHeading = cardLayout === "WITH_BORDER";
  const isIllustration = !data.title && ((_b = subBody == null ? void 0 : subBody[0]) == null ? void 0 : _b.__typename) === "NotificationMessageCard" && ((_c = subBody[0].graphicElement) == null ? void 0 : _c.__typename) === "Illustration";
  const trustMessageCards = subBody == null ? void 0 : subBody.map((card, index) => {
    const graphicElement = "graphicElement" in card ? card.graphicElement : null;
    const markSize = graphicElement && "markSize" in graphicElement && graphicElement.markSize || EGDSMarkSize.LARGE;
    const illustrationSize = (bannerContainer == null ? void 0 : bannerContainer.view) === "GRID_EXTENDED_PADDING" /* GRID_EXTENDED_PADDING */ ? "12x" : "10x";
    return /* @__PURE__ */React81.createElement(TrustMessage, {
      key: index,
      title: card.title,
      graphicElement,
      markSize,
      illustrationSize,
      body: "body" in card ? card.body : null,
      links: "links" in card ? card.links : null,
      layout: "layout" in card ? card.layout : null,
      view: bannerContainer == null ? void 0 : bannerContainer.view,
      impressionAnalytics: (bannerContainer == null ? void 0 : bannerContainer.view) === "CAROUSEL" /* CAROUSEL */ && revealActions && revealActions[index] ? revealActions[index] : void 0,
      isIllustration
    });
  });
  const trustMessageHeading = (title == null ? void 0 : title.completeText) && /* @__PURE__ */React81.createElement(EGDSText27, {
    weight: weightProp ? EGDSTextWeightMap[weightProp] : void 0,
    size: 700,
    theme: themeProp ? EGDSTextThemeMap[themeProp] : void 0
  }, titleItem && "text" in titleItem && titleItem.text);
  const backgroundColor = Theme[((_d = bannerContainer == null ? void 0 : bannerContainer.theme) == null ? void 0 : _d.__typename) === "NotificationCardTheme" && bannerContainer.theme.personalizedTheme ? bannerContainer.theme.personalizedTheme : "LIGHT_1"];
  if ((bannerContainer == null ? void 0 : bannerContainer.view) === "GRID" /* GRID */) {
    return /* @__PURE__ */React81.createElement(EGDSThemeProvider2, {
      config: {
        lightMode: {
          colorTheme: backgroundColor,
          isGradient: true
        },
        darkMode: {
          colorTheme: backgroundColor,
          isGradient: true
        }
      },
      isColorThemeContainer: true
    }, /* @__PURE__ */React81.createElement(TrustMessageWithGrid, {
      trustMessageHeading,
      messageCards: trustMessageCards,
      columnNumber: (_e = subBody == null ? void 0 : subBody.length) != null ? _e : 0,
      isInlineHeading,
      title: data && "title" in data ? data.title : null,
      impressionAnalytics: revealActions || void 0,
      isIllustration
    }));
  }
  if ((bannerContainer == null ? void 0 : bannerContainer.view) === "CAROUSEL" /* CAROUSEL */) {
    return /* @__PURE__ */React81.createElement(EGDSThemeProvider2, {
      config: {
        lightMode: {
          colorTheme: backgroundColor,
          isGradient: true
        },
        darkMode: {
          colorTheme: backgroundColor,
          isGradient: true
        }
      },
      isColorThemeContainer: true
    }, /* @__PURE__ */React81.createElement(TrustMessageWithCarousel, {
      heading: title || null,
      messageCards: trustMessageCards
    }));
  }
  if ((bannerContainer == null ? void 0 : bannerContainer.view) === "GRID_EXTENDED_PADDING" /* GRID_EXTENDED_PADDING */) {
    return /* @__PURE__ */React81.createElement(EGDSThemeProvider2, {
      config: {
        lightMode: {
          colorTheme: backgroundColor,
          isGradient: true
        },
        darkMode: {
          colorTheme: backgroundColor,
          isGradient: true
        }
      },
      isColorThemeContainer: true
    }, /* @__PURE__ */React81.createElement(TrustMessageWithExtendedPaddingGrid, {
      messageCards: trustMessageCards,
      columnNumber: (_f = subBody == null ? void 0 : subBody.length) != null ? _f : 0,
      impressionAnalytics: revealActions || void 0
    }));
  }
  return /* @__PURE__ */React81.createElement(TrustMessageWithGrid, {
    trustMessageHeading,
    messageCards: trustMessageCards,
    columnNumber: (_g = subBody == null ? void 0 : subBody.length) != null ? _g : 0,
    isInlineHeading,
    title: data && "title" in data ? data.title : null,
    impressionAnalytics: revealActions || void 0,
    isIllustration
  });
};
TrustMessageWrapper.displayName = "TrustMessageWrapper";

// src/components/customer-notification/customer-notification-components-dictionary.ts
var NOTIFICATION_COMPONENTS_DICTIONARY = {
  [`${"AFTER_HEADER" /* AFTER_HEADER */}|${"TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */}`]: TravelAdvisoryWrapper,
  [`${"AFTER_WIZARD" /* AFTER_WIZARD */}|${"CLEANLINESS" /* CLEANLINESS */}`]: CleanlinessBannerWrapper,
  [`${"AFTER_WIZARD" /* AFTER_WIZARD */}|${"GENERIC" /* GENERIC */}`]: GenericNotificationWrapper,
  [`${"AFTER_WIZARD" /* AFTER_WIZARD */}|${"ONE_KEY" /* ONE_KEY */}`]: OneKeyWrapper,
  [`${"AFTER_WIZARD" /* AFTER_WIZARD */}|${"TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */}`]: TravelAdvisoryWrapper,
  [`${"FOOTER" /* FOOTER */}|${"MAD_MARQUEE" /* MAD_MARQUEE */}`]: MadMarqueeWrapper,
  [`${"IN_PAGE_AD" /* IN_PAGE_AD */}|${"CITI_COBRAND" /* CITI_COBRAND */}`]: CitiCobrandAdWrapper,
  [`${"IN_PAGE_AD" /* IN_PAGE_AD */}|${"CITI_COBRAND_VERTICAL" /* CITI_COBRAND_VERTICAL */}`]: CitiCobrandAdWrapper,
  [`${"IN_PAGE_AD" /* IN_PAGE_AD */}|${"ONE_KEY" /* ONE_KEY */}`]: OneKeyWrapper,
  [`${"IN_PAGE_AD" /* IN_PAGE_AD */}|${"CONFIGURABLE" /* CONFIGURABLE */}`]: ConfigurableBannerWrapper,
  [`${"IN_PAGE" /* IN_PAGE */}|${"CONFIGURABLE" /* CONFIGURABLE */}`]: ConfigurableBannerWrapper,
  [`${"IN_PAGE" /* IN_PAGE */}|${"GENERIC" /* GENERIC */}`]: GenericNotificationWrapper,
  [`${"IN_PAGE" /* IN_PAGE */}|${"MAD_MARQUEE" /* MAD_MARQUEE */}`]: MadMarqueeWrapper,
  [`${"IN_PAGE" /* IN_PAGE */}|${"ONE_KEY" /* ONE_KEY */}`]: OneKeyWrapper,
  [`${"IN_PAGE" /* IN_PAGE */}|${"TRUST_MSG_BANNER" /* TRUST_MSG_BANNER */}`]: TrustMessageWrapper,
  [`${"IN_MODULE" /* IN_MODULE */}|${"GENERIC" /* GENERIC */}`]: GenericNotificationWrapper,
  [`${"IN_MODULE" /* IN_MODULE */}|${"CONFIGURABLE" /* CONFIGURABLE */}`]: ConfigurableBannerWrapper,
  [`${"IN_MODULE" /* IN_MODULE */}|${"BOTTOM_SHEET" /* BOTTOM_SHEET */}`]: BottomSheetWrapper,
  [`${"IN_MODULE" /* IN_MODULE */}|${"CENTERED_SHEET" /* CENTERED_SHEET */}`]: SheetWrapper,
  [`${"LEGAL" /* LEGAL */}|${"ONETRUST" /* ONETRUST */}`]: OnetrustWrapper,
  [`${"POPUP" /* POPUP */}|${"BOTTOM_SHEET" /* BOTTOM_SHEET */}`]: BottomSheetWrapper,
  [`${"POPUP" /* POPUP */}|${"CENTERED_SHEET" /* CENTERED_SHEET */}`]: SheetWrapper,
  [`${"POPUP" /* POPUP */}|${"FULL_SHEET" /* FULL_SHEET */}`]: SheetWrapper,
  [`${"POPUP" /* POPUP */}|${"FULL_SHEET_MEDIA" /* FULL_SHEET_MEDIA */}`]: FullSheetImageWrapper,
  [`${"IN_MODAL" /* IN_MODAL */}|${"POPOVER" /* POPOVER */}`]: PopoverSheetWrapper,
  [`${"POPUP" /* POPUP */}|${"TRAVEL_ADVISORY" /* TRAVEL_ADVISORY */}`]: TravelAdvisoryDialogWrapper,
  [`${"PRE_HEADER" /* PRE_HEADER */}|${"CONFIGURABLE" /* CONFIGURABLE */}`]: ConfigurableBannerWrapper,
  [`${"PRE_HEADER" /* PRE_HEADER */}|${"HEADER" /* HEADER */}`]: HeaderBannerWrapper,
  [`${"PRE_HEADER" /* PRE_HEADER */}|${"TAKEOVER" /* TAKEOVER */}`]: TakeoverBannerWrapper
};
var getCustomerNotificationComponent = (location, type) => NOTIFICATION_COMPONENTS_DICTIONARY[`${location}|${type}`] || null;

// src/components/customer-notification/customer-notification-wrapper.tsx
import React82 from "react";
import { useProvidedState } from "@shared-ui/provided-state-context";

// src/components/customer-notification/state/customer-notification-control-state.ts
var CustomerNotificationStateEvent = /* @__PURE__ */(CustomerNotificationStateEvent2 => {
  CustomerNotificationStateEvent2["CustomerNotificationNone"] = "customerNotificationNone";
  CustomerNotificationStateEvent2["CustomerNotificationInitialized"] = "customerNotificationInitialized";
  CustomerNotificationStateEvent2["CustomerNotificationError"] = "customerNotificationError";
  return CustomerNotificationStateEvent2;
})(CustomerNotificationStateEvent || {});
var CustomerNotificationControlState = /*#__PURE__*/function () {
  function CustomerNotificationControlState() {
    _classCallCheck(this, CustomerNotificationControlState);
    this.data = Object.keys(NotificationLocationOnPage).reduce((acc, location) => {
      acc[location] = {
        state: "customerNotificationNone" /* CustomerNotificationNone */,
        type: "NONE" /* NONE */
      };
      return acc;
    }, {});
    this.events = Object.values(CustomerNotificationStateEvent);
    this.stateFieldName = "customerNotificationControlState";
  }
  return _createClass(CustomerNotificationControlState, [{
    key: "update",
    value: function update(event, currentState, payload) {
      const newState = Object.assign(currentState);
      if (payload.data) {
        newState[payload.data.location] = {
          state: event,
          type: payload.data.type
        };
      }
      return newState;
    }
  }]);
}();

// src/components/customer-notification/customer-notification-wrapper.tsx
var CustomerNotificationWrapper = ({
  notificationLocation,
  notificationType,
  children
}) => {
  const [, dispatch] = useProvidedState();
  React82.useEffect(() => {
    dispatch({
      type: "customerNotificationInitialized" /* CustomerNotificationInitialized */,
      payload: {
        location: notificationLocation,
        type: notificationType
      }
    });
  }, [dispatch, notificationLocation, notificationType]);
  return /* @__PURE__ */React82.createElement(React82.Fragment, null, children);
};

// src/components/customer-notification/customer-notification-render.tsx
var CustomerNotificationRender = ({
  notificationLocation,
  notificationType,
  data,
  inputs,
  actionCallback,
  switchHandler,
  useRewards,
  dismissCallback,
  spacingProps,
  className
}) => {
  const NotificationComponent = getCustomerNotificationComponent(notificationLocation, notificationType);
  if (!NotificationComponent) {
    actionCallback == null ? void 0 : actionCallback({
      id: "notification-not-found-error",
      notificationLocation,
      notificationType
    });
    return null;
  }
  const CustomerNotificationComponent = /* @__PURE__ */React83.createElement(BannerThemeStateProvider, {
    notificationContainer: data.bannerContainer
  }, /* @__PURE__ */React83.createElement(CustomerNotificationWrapper, {
    notificationLocation,
    notificationType
  }, /* @__PURE__ */React83.createElement(NotificationComponent, {
    data,
    inputs,
    actionCallback,
    switchHandler,
    useRewards,
    dismissCallback
  })));
  if (spacingProps) {
    return /* @__PURE__ */React83.createElement(EGDSSpacing30, {
      margin: spacingProps == null ? void 0 : spacingProps.margin,
      padding: spacingProps == null ? void 0 : spacingProps.padding
    }, /* @__PURE__ */React83.createElement("div", {
      className
    }, CustomerNotificationComponent));
  }
  if (className) {
    return /* @__PURE__ */React83.createElement("div", {
      className
    }, CustomerNotificationComponent);
  }
  return /* @__PURE__ */React83.createElement(React83.Fragment, null, CustomerNotificationComponent);
};

// src/components/customer-notification/helpers/get-optional-context.ts
var stringToDateInput = date => {
  var _a, _b, _c;
  if (typeof date === "string") {
    const identifiers = date.split("-").map(identifier => identifier.trim());
    return {
      day: parseInt((_a = identifiers[2]) != null ? _a : "", 10),
      month: parseInt((_b = identifiers[1]) != null ? _b : "", 10),
      year: parseInt((_c = identifiers[0]) != null ? _c : "", 10)
    };
  }
  return date;
};
var getJourneyCriterias = customJourneyCriterias => {
  return customJourneyCriterias ? customJourneyCriterias.map(journeyCriteria => {
    var _a, _b;
    if (((_a = journeyCriteria == null ? void 0 : journeyCriteria.dateRange) == null ? void 0 : _a.start) && ((_b = journeyCriteria == null ? void 0 : journeyCriteria.dateRange) == null ? void 0 : _b.end)) {
      return __spreadProps(__spreadValues({}, journeyCriteria), {
        dateRange: {
          start: stringToDateInput(journeyCriteria.dateRange.start),
          end: stringToDateInput(journeyCriteria.dateRange.end)
        }
      });
    }
    return __spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, journeyCriteria.origin && {
      origin: journeyCriteria.origin
    }), journeyCriteria.destination && {
      destination: journeyCriteria.destination
    }), journeyCriteria.scheduleChangeStatus && {
      scheduleChangeStatus: journeyCriteria.scheduleChangeStatus
    }), journeyCriteria.tripType && {
      tripType: journeyCriteria.tripType
    }), journeyCriteria.scheduleChangeStatus && {
      scheduleChangeStatus: journeyCriteria.scheduleChangeStatus
    }), journeyCriteria.cabinClass && {
      cabinClass: journeyCriteria.cabinClass
    }), journeyCriteria.travelerDetail && {
      travelerDetail: journeyCriteria.travelerDetail
    }), journeyCriteria.filter && {
      filter: journeyCriteria.filter
    }), journeyCriteria.tripsData && {
      tripsData: journeyCriteria.tripsData
    });
  }) : customJourneyCriterias;
};
var decorateOptionalContextWithJourneyCriterias = optionalContext => {
  return __spreadProps(__spreadValues({}, optionalContext), {
    journeyCriterias: getJourneyCriterias(optionalContext.journeyCriterias)
  });
};
var getOptionalContextWithReferer = customOptionalContext => {
  const _a = customOptionalContext,
    {
      referer
    } = _a,
    optionalContext = __objRest(_a, ["referer"]);
  let urlReferrer;
  if (typeof referer === "string") {
    try {
      urlReferrer = new URL(referer);
    } catch (error) {
      return decorateOptionalContextWithJourneyCriterias(__spreadValues({}, optionalContext));
    }
  } else {
    urlReferrer = referer;
  }
  if (urlReferrer) {
    const regex = /(?:\w*)[Dd]ialog(?:\w*)/g;
    const searchParamsToRemove = ["abov", "preview", "cache", "tName", "pwaOverlay", "x_pwa", "reviewId"];
    const {
      searchParams
    } = urlReferrer;
    const searchParamsIterator = new URLSearchParams(searchParams);
    searchParamsIterator.forEach((_, key) => {
      if (key.match(regex) || searchParamsToRemove.includes(key)) {
        searchParams.delete(key);
      }
    });
  }
  return decorateOptionalContextWithJourneyCriterias(__spreadValues({
    referer: urlReferrer
  }, optionalContext));
};
var selectOptionalContext = (sessionId, customOptionalContext) => {
  return customOptionalContext ? getOptionalContextWithReferer(__spreadValues({}, sessionId ? __spreadValues({
    sessionId
  }, customOptionalContext) : customOptionalContext)) : customOptionalContext;
};

// src/components/customer-notification/helpers/get-clickstream-action-location.ts
function getClickStreamEventByLocation(notificationLocation, inModuleLocation) {
  if (notificationLocation === "IN_PAGE" /* IN_PAGE */) {
    return "message_module_reroute" /* REROUTE */;
  }
  if (inModuleLocation && notificationLocation === "IN_MODULE" /* IN_MODULE */) {
    return mapper[inModuleLocation];
  }
  return void 0;
}
var mapper = {
  ["CPM_CC_ON_FILE_MESSAGE" /* CPM_CC_ON_FILE_MESSAGE */]: "message_module_agency_card_on_file" /* AGENCY_CARD */,
  ["CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE" /* CPM_CC_ON_FILE_ONLY_INSURANCE_PAYMENT_MESSAGE */]: "message_module_agency_card_on_file_plus_insurance" /* AGENCY_CARD_INSURANCE */,
  ["CPM_NO_PAYMENT_DUE_MESSAGE" /* CPM_NO_PAYMENT_DUE_MESSAGE */]: "message_module_agency_no_cc" /* AGENCY_NO_CC */,
  ["CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE" /* CPM_ONLY_INSURANCE_PAYMENT_DUE_MESSAGE */]: "message_module_agency_no_cc_plus_insurance" /* AGENCY_NO_CC_INSURANCE */,
  ["PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT" /* PAY_NOW_CC_ON_FILE_GIFT_CARD_COUPON_TOTAL_AMOUNT */]: "message_module_agency_gift_card_coupons" /* AGENCY_CARD_GC_COUPON */,
  ["PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT" /* PAY_NOW_CC_ON_FILE_GIFT_CARD_TOTAL_AMOUNT */]: "message_module_agency_gift_card" /* AGENCY_CARD_GC */,
  ["PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT" /* PAY_NOW_CC_ON_FILE_OKC_COUPON_TOTAL_AMOUNT */]: "message_module_agency_okc_coupons" /* AGENCY_CARD_OKC_COUPON */,
  ["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT" /* PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT */]: "message_module_agency_okc_gift_card_coupons" /* AGENCY_CARD_OKC_GC_COUPON */,
  ["PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT" /* PAY_NOW_CC_ON_FILE_OKC_GIFT_CARD_TOTAL_AMOUNT */]: "message_module_agency_okc_gift_card" /* AGENCY_CARD_OKC_GC */,
  ["PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT" /* PAY_NOW_CC_ON_FILE_OKC_TOTAL_AMOUNT */]: "message_module_agency_okc" /* AGENCY_CARD_OKC */,
  ["PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT" /* PAY_NOW_GIFT_CARD_COUPON_TOTAL_AMOUNT */]: "message_module_merchant_gift_card_coupons" /* MERCHANT_GC_COUPON */,
  ["PAY_NOW_GIFT_CARD_TOTAL_AMOUNT" /* PAY_NOW_GIFT_CARD_TOTAL_AMOUNT */]: "message_module_merchant_gift_card" /* MERCHANT_GC */,
  ["PAY_NOW_OKC_COUPON_TOTAL_AMOUNT" /* PAY_NOW_OKC_COUPON_TOTAL_AMOUNT */]: "message_module_merchant_okc_coupons" /* MERCHANT_OKC_COUPONS */,
  ["PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT" /* PAY_NOW_OKC_GIFT_CARD_COUPON_TOTAL_AMOUNT */]: "message_module_merchant_okc_gift_card_coupons" /* MERCHANT_OKC_GC_COUPONS */,
  ["PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT" /* PAY_NOW_OKC_GIFT_CARD_TOTAL_AMOUNT */]: "message_module_merchant_okc_gift_card" /* MERCHANT_OKC_GC */,
  ["PAY_NOW_OKC_TOTAL_AMOUNT" /* PAY_NOW_OKC_TOTAL_AMOUNT */]: "message_module_merchant_okc" /* MERCHANT_OKC */,
  ["OKC_ADD_FAILED_MESSAGE" /* OKC_ADD_FAILED_MESSAGE */]: "message_module_reroute" /* REROUTE */,
  ["OKC_REMOVAL_FAILED_MESSAGE" /* OKC_REMOVAL_FAILED_MESSAGE */]: "message_module_reroute" /* REROUTE */,
  ["COUPON_REMOVAL_FAILED_MESSAGE" /* COUPON_REMOVAL_FAILED_MESSAGE */]: "message_module_reroute" /* REROUTE */
};

// src/components/customer-notification/helpers/get-default-notification-type-none.ts
var notificationTypeNone = {
  __typename: "InlineNotification",
  type: "NONE" /* NONE */,
  theme: null,
  switch: null,
  title: null,
  body: null,
  subBody: null,
  legalText: null,
  containerLink: null,
  icon: null,
  logo: null,
  links: null,
  attributes: null,
  dismiss: null,
  revealActions: null,
  backgroundImage: null,
  customQrCode: null,
  form: null
};
var getDefaultNoneNotification = notificationLocation => __spreadValues({
  notificationLocation
}, notificationTypeNone);

// src/components/customer-notification/query/customer-notification-query.tsx
import { gql as gql16 } from "@shared-ui/apollo-client-wrapper";
var NotificationQuery = gql16`
  fragment NotificationAttribute on NotificationAttribute {
    name
    value
  }

  fragment NotificationContainer on NotificationContainer {
    layout
    theme {
      ...NotificationTheme
    }
    view
  }

  fragment NotificationTheme on NotificationTheme {
    ...NotificationBannerTheme
    ...NotificationCardTheme
  }

  fragment NotificationBannerTheme on NotificationBannerTheme {
    bannerTheme: themeValue
  }

  fragment NotificationCardTheme on NotificationCardTheme {
    cardBorder
    personalizedTheme
    themeValue
  }

  fragment NotificationContainerLink on NotificationContainerLink {
    uri {
      __typename
      value
    }
    target
    actions {
      ...NotificationActionFragment
    }
  }

  fragment NotificationImage on Image {
    description
    url
  }

  fragment NotificationLinks on NotificationPhraseLinkNode {
    id
    type
    text
    uri {
      __typename
      value
    }
    linkStyle
    linkTheme
    styles
    target
    icon {
      ...NotificationIcon
    }
    actions {
      ...NotificationActionFragment
    }
  }

  fragment NotificationSimpleSubBody on NotificationSimpleBody {
    title {
      ...TitleParts
    }
  }

  fragment NotificationMultiSubBody on NotificationMultiBody {
    title {
      ...TitleParts
    }
    body {
      ...TitleParts
    }
  }

  fragment NotificationMessageCardSubBody on NotificationMessageCard {
    title {
      ...TitleParts
    }
    body {
      ...TitleParts
    }
    graphicElement {
      ... on Icon {
        description
        id
        size
        theme
        title
        token
        withBackground
      }
      ... on Mark {
        description
        id
        markSize: size
        url {
          ... on HttpURI {
            relativePath
            value
          }
        }
      }
      ... on Illustration {
        description
        id
        link: url
      }
    }
    links {
      id
      text
      type
      uri {
        value
      }
      linkStyle
      linkTheme
      target
      actions {
        ...NotificationActionFragment
      }
      accessibilityLabel
    }
    layout
  }

  fragment NotificationSwitch on EGDSStandardSwitch {
    enabled
    checked
    checkedLabel
    checkedDescription
    checkedAccessibilityLabel
    uncheckedLabel
    uncheckedDescription
    uncheckedAccessibilityLabel
    label
    checkedAnalytics {
      referrerId
      linkName
    }
    uncheckedAnalytics {
      referrerId
      linkName
    }
  }

  fragment NotificationForm on NotificationForm {
    __typename
    title
    sections {
      __typename
      title
      fields {
        __typename
        ...NotificationTextInputFieldForm
        ...NotificationSubmitButtonForm
        ...NotificationSelectionFieldForm
      }
    }
    feedbackMessages {
      __typename
      name
      title
      text
      displayType
      level
    }
    successFormAnalytics {
      ...NotificationActionFragment
    }
    errorFormAnalytics {
      ...NotificationActionFragment
    }
  }

  fragment TitleParts on NotificationPhrase {
    accessibilityLabel
    completeText
    ...EgdsItems
  }

  fragment NotificationActionFragment on NotificationAction {
    __typename
    ... on NotificationAnalytics {
      __typename
      description
      referrerId
      schema {
        __typename
        name
        messageContent {
          __typename
          name
          value
        }
      }
    }
    ... on NotificationAnalyticsEgClickstream {
      __typename
      description
      event {
        __typename
        eventName
        eventType
        eventCategory
        eventVersion
        actionLocation
      }
      schema {
        name
        messageContent {
          name
          value
        }
      }
    }
    ... on NotificationCookie {
      __typename
      name
      value
      expires
    }
  }

  fragment EgdsItems on NotificationPhrase {
    egdsItems {
      ... on NotificationEGDSTextNode {
        text
        theme
        weight
      }
      ... on NotificationEGDSLinkNode {
        action {
          accessibility
          analytics {
            linkName
            referrerId
          }
          resource {
            value
          }
          target
        }
      }
    }
  }

  fragment NotificationCard on NotificationCardTheme {
    themeValue
    cardBorder
  }

  fragment NotificationIcon on Icon {
    id
    description
    title
    withBackground
    spotLight
  }

  fragment NotificationTextInputFieldForm on NotificationTextInputField {
    label
    id
    placeholder
    icon {
      id
      description
      title
    }
  }

  fragment NotificationSubmitButtonForm on NotificationSubmitButton {
    label
    id
    actions {
      ...NotificationActionFragment
    }
    icon {
      id
      description
      title
    }
    buttonType
  }

  fragment NotificationSelectionFieldForm on NotificationSelectionField {
    label
    id
    options {
      __typename
      id
      text
      shortLabel
      value
      selected
      icon {
        id
        description
        title
      }
    }
  }

  query NotificationsQuery(
    $context: ContextInput!
    $notificationLocation: NotificationLocationOnPage!
    $lineOfBusiness: LineOfBusinessDomain!
    $pageLocation: PageLocation!
    $optionalPageId: String
    $optionalContext: NotificationOptionalContextInput
  ) {
    notification(context: $context) {
      inlineNotification(
        notificationLocation: $notificationLocation
        lineOfBusiness: $lineOfBusiness
        pageLocation: $pageLocation
        optionalPageId: $optionalPageId
        optionalContext: $optionalContext
      ) {
        type
        notificationLocation
        title {
          ...NotificationPhraseFragment
        }
        backgroundImage {
          ...BackgroundImageFragment
        }
        body {
          ...NotificationPhraseFragment
        }
        bannerContainer {
          ...NotificationContainer
        }
        containerLink {
          ...NotificationContainerLink
        }
        featuredImages {
          ...NotificationImage
        }
        links {
          ...NotificationLinks
        }
        dismiss {
          ...NotificationDismissFragment
        }
        icon {
          ...NotificationIcon
        }
        legalText {
          ...NotificationPhraseFragment
        }
        logo {
          ...NotificationLogoFragment
        }
        revealActions {
          ...NotificationActionFragment
        }
        ...NotificationCustomQrCodeFragment
        theme {
          __typename
          ...NotificationCard
        }
        attributes {
          ...NotificationAttribute
        }
        switch {
          ...NotificationSwitch
        }
        subBody {
          ...NotificationSimpleSubBody
          ...NotificationMultiSubBody
          ...NotificationMessageCardSubBody
        }
        form {
          ...NotificationForm
        }
      }
    }
  }

  ${CustomQrCodeImage.fragment}
  ${DismissNotification.fragment}
  ${NotificationLogo.fragment}
  ${BackgroundImage.fragment}
  ${NotificationPhrase.fragment}
`;

// src/components/customer-notification/customer-notification.tsx
var CustomerNotification = ({
  inputs: {
    xPageId,
    notificationLocation,
    optionalContext
  },
  actionCallback,
  skipSsr = false,
  isLoadingUI = false,
  switchHandler,
  useRewards,
  dismissCallback,
  spacingProps,
  className
}) => {
  var _a, _b, _c, _d, _e, _f, _g, _h;
  const {
    context
  } = useBexApi3();
  const identity = getIdentity(xPageId);
  const bookingContext = useEntityContext("booking");
  const sessionId = bookingContext == null ? void 0 : bookingContext.id;
  const [shouldSkipQuery, setShouldSkipQuery] = React84.useState(false);
  const variables = {
    context,
    notificationLocation,
    lineOfBusiness: identity.lineOfBusiness,
    pageLocation: identity.pageLocation,
    optionalPageId: identity.pageId.length > 0 ? identity.pageId : null,
    optionalContext: selectOptionalContext(sessionId, optionalContext)
  };
  const {
    error,
    data,
    previousData,
    loading,
    client
  } = useQuery(NotificationQuery, {
    context: {
      useApq: true,
      shouldLogPerformance: true
    },
    variables,
    ssr: !skipSsr,
    skip: shouldSkipQuery
  });
  const apolloCache = client.cache.extract();
  const cachedNotification = Object.values(apolloCache).find(value => (value == null ? void 0 : value.__typename) === "InlineNotification" && value.notificationLocation === notificationLocation && value.type === "HEADER" /* HEADER */);
  const previousDataNotification = previousData == null ? void 0 : previousData.notification.inlineNotification;
  const notification = (_d = (_c = (_b = (_a = data == null ? void 0 : data.notification) == null ? void 0 : _a.inlineNotification) != null ? _b : previousDataNotification) != null ? _c : cachedNotification) != null ? _d : getDefaultNoneNotification(notificationLocation);
  const previousDataNotificationType = previousData == null ? void 0 : previousData.notification.inlineNotification.type;
  const notificationType = (_g = (_f = (_e = notification == null ? void 0 : notification.type) != null ? _e : previousDataNotificationType) != null ? _f : cachedNotification == null ? void 0 : cachedNotification.type) != null ? _g : "NONE" /* NONE */;
  const revealActions = notification == null ? void 0 : notification.revealActions;
  const customerNotificationActionsExecutor = useNotificationActionExecutor();
  const isFirstTimeQuery = !data && !previousData;
  const {
    exposure
  } = useExperiment2("customer_notifications_query_call_killswitch");
  if (skipSsr && isLoadingUI && loading) {
    return /* @__PURE__ */React84.createElement(CustomerNotificationPlaceholder, null);
  }
  if ((error || isFirstTimeQuery) && !loading) {
    if (error) {
      actionCallback == null ? void 0 : actionCallback({
        id: "notification-network-error",
        notificationLocation,
        notificationType: "NONE" /* NONE */
      });
      const actionLocation = getClickStreamEventByLocation(notificationLocation, (_h = optionalContext == null ? void 0 : optionalContext.inModuleMessage) == null ? void 0 : _h.name);
      const trackingData = buildEgClickstreamErrorEvent({
        errorName: error == null ? void 0 : error.name,
        errorDescription: error == null ? void 0 : error.message,
        errorCode: null,
        clickStreamActionLocation: actionLocation
      });
      customerNotificationActionsExecutor([trackingData]);
    }
    return null;
  }
  if (notificationType === "NONE" /* NONE */ && (!isFirstTimeQuery || !cachedNotification)) {
    customerNotificationActionsExecutor(revealActions);
    actionCallback == null ? void 0 : actionCallback({
      id: "notification-none-value",
      notificationLocation,
      notificationType: "NONE" /* NONE */
    });
    const isSkipQueryEnabled = (exposure == null ? void 0 : exposure.bucket) === 1;
    if (!shouldSkipQuery && !isFirstTimeQuery && isSkipQueryEnabled) {
      setShouldSkipQuery(true);
    }
    return null;
  }
  return /* @__PURE__ */React84.createElement(CustomerNotificationRender, {
    data: notification,
    inputs: {
      xPageId,
      notificationLocation,
      optionalContext
    },
    actionCallback,
    switchHandler,
    useRewards,
    dismissCallback,
    notificationLocation,
    notificationType,
    spacingProps,
    className
  });
};
CustomerNotification.displayName = "sharedui-CustomerNotification";

// src/components/customer-notification/customer-notification-with-entitycontext.tsx
import React86 from "react";
import { useEntityContext as useEntityContext2 } from "@shared-ui/entity-context";

// src/components/customer-notification/customer-notification-styling-wrapper.tsx
import React85 from "react";
import { EGDSSpacing as EGDSSpacing31 } from "@egds/react-core/spacing";
var CustomerNotificationStylingWrapper = ({
  spacing,
  children
}) => /* @__PURE__ */React85.createElement(EGDSSpacing31, __spreadValues({}, spacing), /* @__PURE__ */React85.createElement("div", null, children));
CustomerNotificationStylingWrapper.displayName = "CustomerNotificationStylingWrapper";

// src/components/customer-notification/customer-notification-with-entitycontext.tsx
var CustomerNotificationWithEntityContext = _a => {
  var _b = _a,
    {
      children,
      wrapper,
      notificationLocation
    } = _b,
    props = __objRest(_b, ["children", "wrapper", "notificationLocation"]);
  const entityContext = useEntityContext2("customerNotification");
  const inputs = __spreadProps(__spreadValues({}, entityContext), {
    notificationLocation
  });
  return /* @__PURE__ */React86.createElement(CustomerNotificationStylingWrapper, __spreadValues({}, wrapper), /* @__PURE__ */React86.createElement(CustomerNotification, __spreadProps(__spreadValues({}, props), {
    inputs
  }), children));
};
CustomerNotificationWithEntityContext.displayName = "CustomerNotificationWithEntityContext";
export { CustomerNotification, CustomerNotificationControlState, NotificationLocationOnPage as CustomerNotificationLocation, CustomerNotificationStateEvent, NotificationInModuleMessageName, NotificationInModuleModuleName, TripScheduleChangeStatus };
/* istanbul ignore file -- @preserve */